var zde = zde || {}; zde["modules"] = zde["modules"] || {}; zde["modules"]["blog"] =
webpackJsonpzde_modules__name_([7],{

/***/ "/Q8n":
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ "0iPh":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("r1M9");
module.exports = __webpack_require__("tM7p");


/***/ }),

/***/ "243j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar_index__ = __webpack_require__("J9kM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_soon_countdown__ = __webpack_require__("webD");



function init() {
	var $list = $('#contestsList');

	__WEBPACK_IMPORTED_MODULE_0__sidebar_index__["a" /* init */]({
		heightTarget: $list
	});

	$list.zInfiniteScroll({
		selector: '[rel=page]',
		loading: '#pagesScrollLoader',
		maxAutoloadPages: 200,
		totalCount: $list.data('totalCount'),
		fetch: function fetch(page, callback) {
			var data = {
				page: page,
				type: $list.data('blogType'),
				category: $list.data('blogCategory')
			};
			$.get($list.data('loadUrl'), data, null, 'json').done(function (response) {
				var $blocks = $(response['html']).filter('[rel=page]');
				callback($blocks);
			});
		}
	});
}

/***/ }),

/***/ "2uje":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_toastr__ = __webpack_require__("og09");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("YnTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_var__ = __webpack_require__("dTkA");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var t = Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* checkIsIframe */])() ? window.top.toastr : __WEBPACK_IMPORTED_MODULE_0_lib_toastr___default.a;

var MSG_ERROR = 'Ошибка';
var MSG_ERROR_XHR = 'Не удалось выполнить запрос';

var Notifier = function () {
	function Notifier() {
		_classCallCheck(this, Notifier);
	}

	_createClass(Notifier, null, [{
		key: "error",
		value: function error() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			// Extend timeout for errors to 10 seconds by default
			var timeOut = options ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_var__["g" /* orDefault */])(options.timeOut, 10000) : 10000;
			t.error(Object(__WEBPACK_IMPORTED_MODULE_2__utils_var__["g" /* orDefault */])(message, MSG_ERROR), title, _extends({ timeOut: timeOut }, options));
		}
	}, {
		key: "errorXHR",
		value: function errorXHR(jqXHR, textStatus, errorThrown) {
			if (textStatus != 'abort') {
				Notifier.error(MSG_ERROR_XHR);
			}
		}
	}, {
		key: "info",
		value: function info(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.info(message, title, _extends({}, options));
		}
	}, {
		key: "success",
		value: function success(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.success(message, title, _extends({}, options));
		}
	}, {
		key: "warning",
		value: function warning(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.warning(message, title, _extends({}, options));
		}
	}]);

	return Notifier;
}();

/***/ }),

/***/ "5wqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newLogger;
/* unused harmony export setDefaultLevel */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LEVEL_DEBUG = 0;
var LEVEL_INFO = 1;
var LEVEL_WARN = 2;
var LEVEL_ERROR = 3;

var LEVELS = ['debug', 'info', 'warn', 'error'];

var defaultLevel = window.IS_PRODUCTION ? LEVEL_WARN : LEVEL_DEBUG;

/**
 * Creates new logger instance with default level.
 * @param {string|null} name
 * @return {MyLogger}
 */
function newLogger() {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	return new MyLogger(name, defaultLevel);
}

/**
 * Sets level for new loggers.
 * @param {number} level
 */
function setDefaultLevel(level) {
	defaultLevel = level;
}

var MyLogger = function () {
	function MyLogger(name, level) {
		_classCallCheck(this, MyLogger);

		this._name = '';
		this._level = -1;

		this._dummy = function () {};

		this._name = name;
		this.setLevel(level);
	}

	_createClass(MyLogger, [{
		key: 'setLevel',
		value: function setLevel(level) {
			var _this = this;

			level = Number.isInteger(level) ? level : LEVELS.indexOf(level);
			this._level = level;

			var name = this._name ? '[' + this._name + ']' : null;
			var bind = function bind(condition, methodName) {
				if (!condition || !console[methodName]) return _this._dummy;
				return name ? console[methodName].bind(console, name) : console[methodName].bind(console);
			};
			var bindSimple = function bindSimple(condition, methodName) {
				return condition && console[methodName] ? console[methodName].bind(console) : _this._dummy;
			};

			[['log', LEVEL_DEBUG], ['info', LEVEL_INFO], ['warn', LEVEL_WARN], ['error', LEVEL_ERROR]].forEach(function (i) {
				var _i = _slicedToArray(i, 2),
				    method = _i[0],
				    lvl = _i[1];

				_this[method] = bind(level <= lvl, method);
			});

			['time', 'timeEnd', 'profile', 'profileEnd'].forEach(function (method) {
				_this[method] = bindSimple(level <= LEVEL_DEBUG, method);
			});
		}

		/** The same as {@link Console.log} */

	}, {
		key: 'log',
		value: function log(args) {}

		/** The same as {@link Console.info} */

	}, {
		key: 'info',
		value: function info(args) {}

		/** The same as {@link Console.warn} */

	}, {
		key: 'warn',
		value: function warn(args) {}

		/** The same as {@link Console.error} */

	}, {
		key: 'error',
		value: function error(args) {}

		/** The same as {@link Console.time} */

	}, {
		key: 'time',
		value: function time(label) {}

		/** The same as {@link Console.timeEnd} */

	}, {
		key: 'timeEnd',
		value: function timeEnd(label) {}

		/** The same as {@link Console.profile} */

	}, {
		key: 'profile',
		value: function profile(label) {}

		/** The same as {@link Console.profileEnd} */

	}, {
		key: 'profileEnd',
		value: function profileEnd(label) {}
	}, {
		key: 'measureTime',
		value: function measureTime(label, callable) {
			this.time(label);
			var result = callable();
			this.timeEnd(label);
			return result;
		}
	}, {
		key: 'doProfile',
		value: function doProfile(label, callable) {
			this.profile(label);
			var result = callable();
			this.profileEnd(label);
			return result;
		}
	}, {
		key: 'setLevelDebug',
		value: function setLevelDebug() {
			this.setLevel(LEVEL_DEBUG);
		}
	}, {
		key: 'setLevelInfo',
		value: function setLevelInfo() {
			this.setLevel(LEVEL_INFO);
		}
	}, {
		key: 'setLevelWarn',
		value: function setLevelWarn() {
			this.setLevel(LEVEL_WARN);
		}
	}, {
		key: 'setLevelError',
		value: function setLevelError() {
			this.setLevel(LEVEL_ERROR);
		}
	}]);

	return MyLogger;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (newLogger());

/***/ }),

/***/ "6mWo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7fPx":
/***/ (function(module, exports) {

module.exports = ko;

/***/ }),

/***/ "8ZSj":
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ "9Aqb":
/***/ (function(module, exports) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var isWindowLoaded = false;
$(window).one('load', function () {
	isWindowLoaded = true;
});

var log = function log() {};

// uncomment to enable logging
// log = console.log;

/**
 * This plugin calculates font size for element to fit parent.
 * It incrementally changes font size until element's dimensions are most close to parent's.
 * To manually fix font size trigger 'refresh-font-size' event
 * @param options
 * @return {JQuery}
 */
$.fn.adaptiveFontSize = function () {
	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	var o = _extends({
		minFontSize: '30%',
		maxFontSize: '100%',
		// 'up' or 'down'. Either increase font size starting from min, or decrease starting from max
		direction: 'down',
		// If null - immediate parent will be used, otherwise: $(element).parents(o.parentSelector)
		parentSelector: null,
		// Set font size only if window is already loaded.
		// Don't forget to enable fixOnLoad option
		setIfLoaded: true,
		// Fix font size on window resize event
		fixOnResize: true,
		// Fix font size on window load event
		fixOnLoad: true,

		// Done callback. Called when font size is finally set. Accepts two parameters - DOM Element and font size
		done: null

	}, options);
	return this.each(function () {
		var $block = $(this);
		init();

		function init() {
			if (!o.setIfLoaded || isWindowLoaded) {
				process();
			} else {
				log('postpone set');
			}
			if (o.fixOnResize) {
				$(window).on('resize', eventHandler);
			}
			if (o.fixOnLoad) {
				$(window).on('load', eventHandler);
			}
			$block.on('refresh-font-size', eventHandler);
		}

		function eventHandler() {
			log('fix on event');
			process();
		}

		function getParent() {
			return o.parentSelector ? $block.parents(o.parentSelector).first() : $block.parent();
		}

		function process() {
			if (!$.contains(document, $block[0])) {
				// element has been detached, stop processing
				log('stop processing');
				$(window).off('resize', eventHandler);
				$(window).off('load', eventHandler);
				$block.off('refresh-font-size', eventHandler);
				return;
			}

			var $parent = getParent();
			var isPercent = ('' + o.minFontSize).indexOf('%') >= 0;
			var minFontSize = parseFloat(o.minFontSize);
			var maxFontSize = parseFloat(o.maxFontSize);
			var delta = Math.floor((maxFontSize - minFontSize) / 10);
			var initial = minFontSize;
			if (o.direction == 'down') {
				delta *= -1;
				initial = maxFontSize;
			}
			var fontSize = calculateFontSize($block, $parent.width(), $parent.height(), initial, minFontSize, maxFontSize, delta, isPercent);
			if ($.isFunction(o.done)) {
				log('done', fontSize);
				o.done($block[0], fontSize);
			}
		}
	});
};

function addDelta(value, delta, min, max) {
	var newValue = value + delta;
	if (newValue > max) newValue = max;
	if (newValue < min) newValue = min;
	return newValue;
}

function calculateFontSize($block, maxWidth, maxHeight, fontSize, minFontSize, maxFontSize, delta, isPercent) {
	var newFontSize = addDelta(fontSize, delta, minFontSize, maxFontSize);
	if (newFontSize == fontSize) {
		return fontSize;
	}
	setFontSize($block, newFontSize, isPercent);
	if (delta > 0) {
		if ($block.width() < maxWidth && $block.height() < maxHeight) {
			return calculateFontSize($block, maxWidth, maxHeight, newFontSize, minFontSize, maxFontSize, delta, isPercent);
		} else {
			// rollback
			setFontSize($block, fontSize, isPercent);
			return fontSize;
		}
	} else {
		if ($block.width() > maxWidth || $block.height() > maxHeight) {
			return calculateFontSize($block, maxWidth, maxHeight, newFontSize, minFontSize, maxFontSize, delta, isPercent);
		}
	}
	return newFontSize;
}

function setFontSize($block, fontSize, isPercent) {
	if (isPercent) {
		fontSize += '%';
	}
	$block.css('font-size', fontSize);
}

/***/ }),

/***/ "F0bM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sale__ = __webpack_require__("WO3R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contest__ = __webpack_require__("243j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__article__ = __webpack_require__("YWK7");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "sale", function() { return __WEBPACK_IMPORTED_MODULE_0__sale__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "contest", function() { return __WEBPACK_IMPORTED_MODULE_1__contest__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "article", function() { return __WEBPACK_IMPORTED_MODULE_2__article__; });






/***/ }),

/***/ "FE6W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sale__ = __webpack_require__("Jkdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_widgets_popup__ = __webpack_require__("ZuML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagecomments__ = __webpack_require__("NdAU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidebar__ = __webpack_require__("J9kM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_fancybox__ = __webpack_require__("w2CW");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var logger = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_logger__["a" /* newLogger */])('Article page');

function init(options) {
    var o = _extends({
        page: {},
        comments: []
    }, options);

    logger.log('init', o);

    __WEBPACK_IMPORTED_MODULE_3__pagecomments__["a" /* init */]({ page: o.page, comments: o.comments });
    setTimeout(__WEBPACK_IMPORTED_MODULE_4__sidebar__["a" /* init */]);

    Object(__WEBPACK_IMPORTED_MODULE_1__sale__["categoriesCrop"])($('#page_content .sale-cats'));

    openTablePopup();
}

function openTablePopup() {
    /*$('[rel="compare-table"]').click(function(){
           const template = require('./templates/compare-table.html');
           const src = $(this).attr('src');
           const content = $.tmpl(template, {src: src});
           openPopup(content, {
               cssClass: 'compare-table-popup'
           });
    })*/
    $('[rel="compare-table"]').click(function () {
        var src = $(this).attr('src');
        $.fancybox.open({
            src: src,
            baseClass: 'fancybox-custom-layout',
            thumbs: {
                hideOnClose: false
            },
            touch: {
                vertical: false
            },
            buttons: ['close'],
            animationEffect: "fade",
            transitionEffect: false,
            clickContent: "zoom",
            clickOutside: "close"
        });
    });
}

/***/ }),

/***/ "FYi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_URL; });
/* harmony export (immutable) */ __webpack_exports__["g"] = siteUrl;
/* harmony export (immutable) */ __webpack_exports__["f"] = joinPath;
/* harmony export (immutable) */ __webpack_exports__["e"] = isAbsolute;
/* unused harmony export buildQuery */
/* harmony export (immutable) */ __webpack_exports__["d"] = highlightUrls;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UrlParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UrlBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__("XRua");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__var__ = __webpack_require__("dTkA");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var BASE_URL = (window.base_url || '/').replace(/(.*)\/\/$|([^/])$/, '$1/');

var isAbsoluteUrlRegex = /^https?:\/\//i;

/**
 * @param {string|object} url Url path
 * @param {string|object} more Additional parts
 * @return {string}
 */
function siteUrl(url) {
	for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		more[_key - 1] = arguments[_key];
	}

	if (isAbsoluteUrlRegex.test(url)) {
		if (more.length === 0) {
			return url;
		} else {
			return joinPath.apply(null, [url].concat(more));
		}
	} else {
		return joinPath.apply(null, [BASE_URL, url].concat(more));
	}
}

/**
 * Joins given values with slash.
 * If last value is an object - it will be formatted as query data.
 * @param {string|object} values
 * @return {string}
 */
function joinPath() {
	for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		values[_key2] = arguments[_key2];
	}

	if (values.length == 0) return '';
	var query = {};
	var queryString = '';
	var fragment = '';
	var components = [];
	var processValue = function processValue(v) {
		if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isObject(v)) {
			query = _extends({}, query, v);
		} else {
			v = Object(__WEBPACK_IMPORTED_MODULE_2__var__["d" /* asString */])(v).trim();
			var i = void 0;
			if ((i = v.indexOf('#')) >= 0) {
				fragment = v.substr(i + 1);
				v = v.substr(0, i);
			} else if ((i = v.indexOf('?')) >= 0) {
				queryString = v.substr(i + 1);
				v = v.substr(0, i);
			}
			if (v) {
				if (components.length == 0) {
					v = v.replace(/\/$/g, '');
				} else {
					v = v.replace(/^\/|\/$/g, '');
				}
				components.push(v);
			}
		}
	};
	values.forEach(function (v) {
		if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(v)) {
			v.forEach(processValue);
		} else {
			processValue(v);
		}
	});
	var url = components.join('/');
	if (!__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(query)) {
		var q = buildQuery(query);
		if (queryString) {
			queryString += '&';
		}
		queryString += q;
	}
	if (queryString) {
		url += '?' + queryString;
	}
	if (fragment) {
		url += '#' + fragment;
	}
	return url;
}

/**
 *
 * @param {string} url
 * @return {boolean}
 */
function isAbsolute(url) {
	return isAbsoluteUrlRegex.test(url);
}

/**
 * Builds query string from given object
 * @param {object} queryData
 * @return {string}
 */
function buildQuery(queryData) {
	return __WEBPACK_IMPORTED_MODULE_1__location__["c" /* buildQuery */](queryData);
}

function highlightUrls(text) {
	var maxlength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

	return text.replace(/(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\?+=&%#\/\wА-Яа-яёЁ\.;-]*)*\/?/g, function (s) {
		var st = s;

		if (s.length > maxlength) {
			st = s.slice(0, maxlength) + "...";
		}

		if (!/^(https?:\/\/)/.test(s)) {
			s = "http://" + s;
		}

		return "<a href='" + s + "' target='_blank' rel='nofollow noopener'>" + st + "</a>";
	});
}

var UrlParser = function () {
	/**
  * @param {string} url
  */
	function UrlParser(url) {
		_classCallCheck(this, UrlParser);

		this._a = document.createElement('a');
		this._a.href = url;
	}

	/** @return {string} */


	_createClass(UrlParser, [{
		key: 'origin',
		get: function get() {
			return this._a.origin;
		}

		/** @return {string} */

	}, {
		key: 'protocol',
		get: function get() {
			return this._a.protocol;
		}

		/** @return {string} */

	}, {
		key: 'host',
		get: function get() {
			return this._a.host;
		}

		/** @return {string} */

	}, {
		key: 'hostname',
		get: function get() {
			return this._a.hostname;
		}

		/** @return {string} */

	}, {
		key: 'port',
		get: function get() {
			return this._a.port;
		}

		/** @return {string} */

	}, {
		key: 'pathname',
		get: function get() {
			return this._a.pathname;
		}

		/** @return {string} */

	}, {
		key: 'search',
		get: function get() {
			return this._a.search;
		}

		/** @return {string} */

	}, {
		key: 'hash',
		get: function get() {
			return this._a.hash;
		}
	}]);

	return UrlParser;
}();

var UrlBuilder = function () {
	function UrlBuilder() {
		var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var port = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
		var query = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
		var hash = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

		_classCallCheck(this, UrlBuilder);

		this._protocol = protocol;
		this._host = host;
		this._port = port;
		this._path = path;
		this._query = query;
		this._hash = hash;
	}

	/**
  * @param {string|null} value
  */


	_createClass(UrlBuilder, [{
		key: 'build',


		/**
   * @return {string}
   */
		value: function build() {
			var origin = (this._protocol ? this._protocol + '//' : '') + (this._host ? this._host + (this._port ? ':' + this._port : '') : '');
			var query = _typeof(this._query) === 'object' ? prefix(buildQuery(this._query), '?') : this._query;
			return joinPath(origin, this._path, query, this._hash);
		}
	}, {
		key: 'protocol',
		set: function set(value) {
			this._protocol = postfix(value, ':');
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._protocol;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'host',
		set: function set(value) {
			this._host = value;
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._host;
		}

		/**
   * @param {string|number|null} value
   */

	}, {
		key: 'port',
		set: function set(value) {
			this._port = value;
		}

		/** @return {string|number|null} */
		,
		get: function get() {
			return this._port;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'path',
		set: function set(value) {
			this._path = value;
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._path;
		}

		/**
   * @param {string|object|null} value
   */

	}, {
		key: 'query',
		set: function set(value) {
			this._query = prefix(value, '?');
		}

		/** @return {string|object|null} */
		,
		get: function get() {
			return this._query;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'hash',
		set: function set(value) {
			this._hash = prefix(value, '#');
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._hash;
		}
	}]);

	return UrlBuilder;
}();

function prefix(val, prefix) {
	if (val && typeof val === 'string' && !val.startsWith(prefix)) {
		return prefix + val;
	}
	return val;
}

function postfix(val, postfix) {
	if (val && typeof val === 'string' && !val.endsWith(postfix)) {
		return val + postfix;
	}
	return val;
}

/***/ }),

/***/ "GfF8":
/***/ (function(module, exports) {

// ==================================================
// fancyBox v3.2.10
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2017 fancyApps
//
// ==================================================
;(function (window, document, $, undefined) {
    'use strict';

    // If there's no jQuery, fancyBox can't work
    // =========================================

    if ( !$ ) {
        return;
    }

    // Check if fancyBox is already initialized
    // ========================================

    if ( $.fn.fancybox ) {

        if ( 'console' in window ) {
            console.log( 'fancyBox already initialized' );
        }

        return;
    }

    // Private default settings
    // ========================

    var defaults = {

        // Enable infinite gallery navigation
        loop : false,

        // Space around image, ignored if zoomed-in or viewport width is smaller than 800px
        margin : [44, 0],

        // Horizontal space between slides
        gutter : 50,

        // Enable keyboard navigation
        keyboard : true,

        // Should display navigation arrows at the screen edges
        arrows : true,

        // Should display infobar (counter and arrows at the top)
        infobar : true,

        // Should display toolbar (buttons at the top)
        toolbar : true,

        // What buttons should appear in the top right corner.
        // Buttons will be created using templates from `btnTpl` option
        // and they will be placed into toolbar (class="fancybox-toolbar"` element)
        buttons : [
            'slideShow',
            'fullScreen',
            'thumbs',
            'share',
            //'download',
            //'zoom',
            'close'
        ],

        // Detect "idle" time in seconds
        idleTime : 3,

        // Should display buttons at top right corner of the content
        // If 'auto' - they will be created for content having type 'html', 'inline' or 'ajax'
        // Use template from `btnTpl.smallBtn` for customization
        smallBtn : 'auto',

        // Disable right-click and use simple image protection for images
        protect : false,

        // Shortcut to make content "modal" - disable keyboard navigtion, hide buttons, etc
        modal : false,

        image : {

            // Wait for images to load before displaying
            // Requires predefined image dimensions
            // If 'auto' - will zoom in thumbnail if 'width' and 'height' attributes are found
            preload : "auto"

        },

        ajax : {

            // Object containing settings for ajax request
            settings : {

                // This helps to indicate that request comes from the modal
                // Feel free to change naming
                data : {
                    fancybox : true
                }
            }

        },

        iframe : {

            // Iframe template
            tpl : '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen allowtransparency="true" src=""></iframe>',

            // Preload iframe before displaying it
            // This allows to calculate iframe content width and height
            // (note: Due to "Same Origin Policy", you can't get cross domain data).
            preload : true,

            // Custom CSS styling for iframe wrapping element
            // You can use this to set custom iframe dimensions
            css : {},

            // Iframe tag attributes
            attr : {
                scrolling : 'auto'
            }

        },

        // Default content type if cannot be detected automatically
        defaultType : 'image',

        // Open/close animation type
        // Possible values:
        //   false            - disable
        //   "zoom"           - zoom images from/to thumbnail
        //   "fade"
        //   "zoom-in-out"
        //
        animationEffect : "zoom",

        // Duration in ms for open/close animation
        animationDuration : 500,

        // Should image change opacity while zooming
        // If opacity is "auto", then opacity will be changed if image and thumbnail have different aspect ratios
        zoomOpacity : "auto",

        // Transition effect between slides
        //
        // Possible values:
        //   false            - disable
        //   "fade'
        //   "slide'
        //   "circular'
        //   "tube'
        //   "zoom-in-out'
        //   "rotate'
        //
        transitionEffect : "fade",

        // Duration in ms for transition animation
        transitionDuration : 366,

        // Custom CSS class for slide element
        slideClass : '',

        // Custom CSS class for layout
        baseClass : '',

        // Base template for layout
        baseTpl	:
            '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                '<div class="fancybox-bg"></div>' +
                '<div class="fancybox-inner">' +
                    '<div class="fancybox-infobar">' +
                        '<span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span>' +
                    '</div>' +
                    '<div class="fancybox-toolbar">{{buttons}}</div>' +
                    '<div class="fancybox-navigation">{{arrows}}</div>' +
                    '<div class="fancybox-stage"></div>' +
                    '<div class="fancybox-caption-wrap"><div class="fancybox-caption"></div></div>' +
                '</div>' +
            '</div>',

        // Loading indicator template
        spinnerTpl : '<div class="fancybox-loading"></div>',

        // Error message template
        errorTpl : '<div class="fancybox-error"><p>{{ERROR}}<p></div>',

        btnTpl : {

            download : '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}">' +
                        '<svg viewBox="0 0 40 40">' +
                            '<path d="M20,23 L20,8 L20,23 L13,16 L20,23 L27,16 L20,23 M26,28 L13,28 L27,28 L14,28" />' +
                        '</svg>' +
                    '</a>',

            zoom : '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}">' +
                        '<svg viewBox="0 0 40 40">' +
                            '<path d="M 18,17 m-8,0 a 8,8 0 1,0 16,0 a 8,8 0 1,0 -16,0 M25,23 L31,29 L25,23" />' +
                        '</svg>' +
                    '</button>',

            close : '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
                        '<svg viewBox="0 0 40 40">' +
                            '<path d="M10,10 L30,30 M30,10 L10,30" />' +
                        '</svg>' +
                    '</button>',

            // This small close button will be appended to your html/inline/ajax content by default,
            // if "smallBtn" option is not set to false
            smallBtn   : '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"></button>',

            // Arrows
            arrowLeft : '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
                            '<svg viewBox="0 0 40 40">' +
                              '<path d="M10,20 L30,20 L10,20 L18,28 L10,20 L18,12 L10,20"></path>' +
                            '</svg>' +
                          '</button>',

            arrowRight : '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
                          '<svg viewBox="0 0 40 40">' +
                            '<path d="M30,20 L10,20 L30,20 L22,28 L30,20 L22,12 L30,20"></path>' +
                          '</svg>' +
                        '</button>'
        },

        // Container is injected into this element
        parentEl : 'body',


        // Focus handling
        // ==============

        // Try to focus on the first focusable element after opening
        autoFocus : false,

        // Put focus back to active element after closing
        backFocus : true,

        // Do not let user to focus on element outside modal content
        trapFocus : true,


        // Module specific options
        // =======================

        fullScreen : {
            autoStart : false,
        },

        // Set `touch: false` to disable dragging/swiping
        touch : {
            vertical : true,  // Allow to drag content vertically
            momentum : true   // Continue movement after releasing mouse/touch when panning
        },

        // Hash value when initializing manually,
        // set `false` to disable hash change
        hash : null,

        // Customize or add new media types
        // Example:
        /*
        media : {
            youtube : {
                params : {
                    autoplay : 0
                }
            }
        }
        */
        media : {},

        slideShow : {
            autoStart : false,
            speed     : 4000
        },

        thumbs : {
			autoStart   : false,                  // Display thumbnails on opening
			hideOnClose : true,                   // Hide thumbnail grid when closing animation starts
			parentEl    : '.fancybox-container',  // Container is injected into this element
			axis        : 'y'                     // Vertical (y) or horizontal (x) scrolling
		},

        // Use mousewheel to navigate gallery
        // If 'auto' - enabled for images only
        wheel : 'auto',

        // Callbacks
        //==========

        // See Documentation/API/Events for more information
        // Example:
        /*
            afterShow: function( instance, current ) {
                 console.info( 'Clicked element:' );
                 console.info( current.opts.$orig );
            }
        */

        onInit       : $.noop,  // When instance has been initialized

        beforeLoad   : $.noop,  // Before the content of a slide is being loaded
        afterLoad    : $.noop,  // When the content of a slide is done loading

        beforeShow   : $.noop,  // Before open animation starts
        afterShow    : $.noop,  // When content is done loading and animating

        beforeClose  : $.noop,  // Before the instance attempts to close. Return false to cancel the close.
        afterClose   : $.noop,  // After instance has been closed

        onActivate   : $.noop,  // When instance is brought to front
        onDeactivate : $.noop,  // When other instance has been activated


        // Interaction
        // ===========

        // Use options below to customize taken action when user clicks or double clicks on the fancyBox area,
        // each option can be string or method that returns value.
        //
        // Possible values:
        //   "close"           - close instance
        //   "next"            - move to next gallery item
        //   "nextOrClose"     - move to next gallery item or close if gallery has only one item
        //   "toggleControls"  - show/hide controls
        //   "zoom"            - zoom image (if loaded)
        //   false             - do nothing

        // Clicked on the content
        clickContent : function( current, event ) {
            return current.type === 'image' ? 'zoom' : false;
        },

        // Clicked on the slide
        clickSlide : 'close',

        // Clicked on the background (backdrop) element
        clickOutside : 'close',

        // Same as previous two, but for double click
        dblclickContent : false,
        dblclickSlide   : false,
        dblclickOutside : false,


        // Custom options when mobile device is detected
        // =============================================

        mobile : {
            idleTime : false,
            margin   : 0,

            clickContent : function( current, event ) {
                return current.type === 'image' ? 'toggleControls' : false;
            },
            clickSlide : function( current, event ) {
                return current.type === 'image' ? 'toggleControls' : 'close';
            },
            dblclickContent : function( current, event ) {
                return current.type === 'image' ? 'zoom' : false;
            },
            dblclickSlide : function( current, event ) {
                return current.type === 'image' ? 'zoom' : false;
            }
        },


        // Internationalization
        // ============

        lang : 'en',
        i18n : {
            'en' : {
                CLOSE       : 'Close',
                NEXT        : 'Next',
                PREV        : 'Previous',
                ERROR       : 'The requested content cannot be loaded. <br/> Please try again later.',
                PLAY_START  : 'Start slideshow',
                PLAY_STOP   : 'Pause slideshow',
                FULL_SCREEN : 'Full screen',
                THUMBS      : 'Thumbnails',
                DOWNLOAD    : 'Download',
                SHARE       : 'Share',
                ZOOM        : 'Zoom'
            },
            'de' : {
                CLOSE       : 'Schliessen',
                NEXT        : 'Weiter',
                PREV        : 'Zurück',
                ERROR       : 'Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.',
                PLAY_START  : 'Diaschau starten',
                PLAY_STOP   : 'Diaschau beenden',
                FULL_SCREEN : 'Vollbild',
                THUMBS      : 'Vorschaubilder',
                DOWNLOAD    : 'Herunterladen',
                SHARE       : 'Teilen',
                ZOOM        : 'Maßstab'
            }
        }

    };

    // Few useful variables and methods
    // ================================

    var $W = $(window);
    var $D = $(document);

    var called = 0;


    // Check if an object is a jQuery object and not a native JavaScript object
    // ========================================================================

    var isQuery = function ( obj ) {
        return obj && obj.hasOwnProperty && obj instanceof $;
    };


    // Handle multiple browsers for "requestAnimationFrame" and "cancelAnimationFrame"
    // ===============================================================================

    var requestAFrame = (function () {
        return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                // if all else fails, use setTimeout
                function (callback) {
                    return window.setTimeout(callback, 1000 / 60);
                };
    })();


    // Detect the supported transition-end event property name
    // =======================================================

    var transitionEnd = (function () {
        var t, el = document.createElement("fakeelement");

        var transitions = {
            "transition"      : "transitionend",
            "OTransition"     : "oTransitionEnd",
            "MozTransition"   : "transitionend",
            "WebkitTransition": "webkitTransitionEnd"
        };

        for (t in transitions) {
            if (el.style[t] !== undefined){
                return transitions[t];
            }
        }

        return 'transitionend';
    })();


    // Force redraw on an element.
    // This helps in cases where the browser doesn't redraw an updated element properly.
    // =================================================================================

    var forceRedraw = function( $el ) {
        return ( $el && $el.length && $el[0].offsetHeight );
    };


    // Class definition
    // ================

    var FancyBox = function( content, opts, index ) {
        var self = this;

        self.opts = $.extend( true, { index : index }, $.fancybox.defaults, opts || {} );

        if ( $.fancybox.isMobile ) {
            self.opts = $.extend( true, {}, self.opts, self.opts.mobile );
        }

        // Exclude buttons option from deep merging
        if ( opts && $.isArray( opts.buttons ) ) {
            self.opts.buttons = opts.buttons;
        }

        self.id    = self.opts.id || ++called;
        self.group = [];

        self.currIndex = parseInt( self.opts.index, 10 ) || 0;
        self.prevIndex = null;

        self.prevPos = null;
        self.currPos = 0;

        self.firstRun = null;

        // Create group elements from original item collection
        self.createGroup( content );

        if ( !self.group.length ) {
            return;
        }

        // Save last active element and current scroll position
        self.$lastFocus = $(document.activeElement).blur();

        // Collection of gallery objects
        self.slides = {};

        self.init();
    };

    $.extend(FancyBox.prototype, {

        // Create DOM structure
        // ====================

        init : function() {
            var self = this,
                firstItem      = self.group[ self.currIndex ],
                firstItemOpts  = firstItem.opts,
                scrollbarWidth = $.fancybox.scrollbarWidth,
                $scrollDiv,
                $container,
                buttonStr;

            self.scrollTop  = $D.scrollTop();
            self.scrollLeft = $D.scrollLeft();


            // Hide scrollbars
            // ===============

            if ( !$.fancybox.getInstance() ) {

                $( 'body' ).addClass( 'fancybox-active' );

                // iOS hack
                if ( /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream ) {

                    // iOS has problems for input elements inside fixed containers,
                    // the workaround is to apply `position: fixed` to `<body>` element,
                    // unfortunately, this makes it lose the scrollbars and forces address bar to appear.

                    if ( firstItem.type !== 'image' ) {
                        $( 'body' ).css( 'top', $( 'body' ).scrollTop() * -1 ).addClass( 'fancybox-iosfix' );
                    }

                } else if ( !$.fancybox.isMobile && document.body.scrollHeight > window.innerHeight ) {

                    if ( scrollbarWidth === undefined ) {
                        $scrollDiv = $('<div style="width:50px;height:50px;overflow:scroll;" />').appendTo( 'body' );

                        scrollbarWidth = $.fancybox.scrollbarWidth = $scrollDiv[0].offsetWidth - $scrollDiv[0].clientWidth;

                        $scrollDiv.remove();
                    }

                    $( 'head' ).append( '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar { margin-right: ' + scrollbarWidth + 'px; }</style>' );
                    $( 'body' ).addClass( 'compensate-for-scrollbar' );
                }
            }


            // Build html markup and set references
            // ====================================

            // Build html code for buttons and insert into main template
            buttonStr = '';

            $.each( firstItemOpts.buttons, function( index, value ) {
                buttonStr += ( firstItemOpts.btnTpl[ value ] || '' );
            });

            // Create markup from base template, it will be initially hidden to
            // avoid unnecessary work like painting while initializing is not complete
            $container = $(
                self.translate( self,
                    firstItemOpts.baseTpl
                        .replace( '\{\{buttons\}\}', buttonStr )
                        .replace( '\{\{arrows\}\}', firstItemOpts.btnTpl.arrowLeft + firstItemOpts.btnTpl.arrowRight )
                )
            )
                .attr( 'id', 'fancybox-container-' + self.id )
                .addClass( 'fancybox-is-hidden' )
                .addClass( firstItemOpts.baseClass )
                .data( 'FancyBox', self )
                .appendTo( firstItemOpts.parentEl );

            // Create object holding references to jQuery wrapped nodes
            self.$refs = {
                container : $container
            };

            [ 'bg', 'inner', 'infobar', 'toolbar', 'stage', 'caption', 'navigation' ].forEach(function(item) {
                self.$refs[ item ] = $container.find( '.fancybox-' + item );
            });

            self.trigger( 'onInit' );

            // Enable events, deactive previous instances
            self.activate();

            // Build slides, load and reveal content
            self.jumpTo( self.currIndex );
        },


        // Simple i18n support - replaces object keys found in template
        // with corresponding values
        // ============================================================

        translate : function( obj, str ) {
            var arr = obj.opts.i18n[ obj.opts.lang ];

            return str.replace(/\{\{(\w+)\}\}/g, function(match, n) {
                var value = arr[n];

                if ( value === undefined ) {
                    return match;
                }

                return value;
            });
        },

        // Create array of gally item objects
        // Check if each object has valid type and content
        // ===============================================

        createGroup : function ( content ) {
            var self  = this;
            var items = $.makeArray( content );

            $.each(items, function( i, item ) {
                var obj  = {},
                    opts = {},
                    $item,
                    type,
                    found,
                    src,
                    srcParts;

                // Step 1 - Make sure we have an object
                // ====================================

                if ( $.isPlainObject( item ) ) {

                    // We probably have manual usage here, something like
                    // $.fancybox.open( [ { src : "image.jpg", type : "image" } ] )

                    obj  = item;
                    opts = item.opts || item;

                } else if ( $.type( item ) === 'object' && $( item ).length ) {

                    // Here we probably have jQuery collection returned by some selector
                    $item = $( item );

                    opts = $item.data();
                    opts = $.extend( {}, opts, opts.options || {} );

                    // Here we store clicked element
                    opts.$orig = $item;

                    obj.src = opts.src || $item.attr( 'href' );

                    // Assume that simple syntax is used, for example:
                    //   `$.fancybox.open( $("#test"), {} );`
                    if ( !obj.type && !obj.src ) {
                        obj.type = 'inline';
                        obj.src  = item;
                    }

                } else {

                    // Assume we have a simple html code, for example:
                    //   $.fancybox.open( '<div><h1>Hi!</h1></div>' );

                    obj = {
                        type : 'html',
                        src  : item + ''
                    };

                }

                // Each gallery object has full collection of options
                obj.opts = $.extend( true, {}, self.opts, opts );

                // Do not merge buttons array
                if ( $.isArray( opts.buttons ) ) {
                    obj.opts.buttons = opts.buttons;
                }


                // Step 2 - Make sure we have content type, if not - try to guess
                // ==============================================================

                type = obj.type || obj.opts.type;
                src  = obj.src || '';

                if ( !type && src ) {
                    if ( src.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ) {
                        type = 'image';

                    } else if ( src.match(/\.(pdf)((\?|#).*)?$/i) ) {
                        type = 'pdf';

                    } else if ( found = src.match(/\.(mp4|mov|ogv)((\?|#).*)?$/i) ) {
                        type = 'video';

                        if ( !obj.opts.videoFormat ) {
                            obj.opts.videoFormat = 'video/' + ( found[1] === 'ogv' ? 'ogg' : found[1] );
                        }

                    } else if ( src.charAt(0) === '#' ) {
                        type = 'inline';
                    }
                }

                if ( type ) {
                    obj.type = type;

                } else {
                    self.trigger( 'objectNeedsType', obj );
                }


                // Step 3 - Some adjustments
                // =========================

                obj.index = self.group.length;

                // Check if $orig and $thumb objects exist
                if ( obj.opts.$orig && !obj.opts.$orig.length ) {
                    delete obj.opts.$orig;
                }

                if ( !obj.opts.$thumb && obj.opts.$orig ) {
                    obj.opts.$thumb = obj.opts.$orig.find( 'img:first' );
                }

                if ( obj.opts.$thumb && !obj.opts.$thumb.length ) {
                    delete obj.opts.$thumb;
                }

                // "caption" is a "special" option, it can be used to customize caption per gallery item ..
                if ( $.type( obj.opts.caption ) === 'function' ) {
                    obj.opts.caption = obj.opts.caption.apply( item, [ self, obj ] );
                }

                if ( $.type( self.opts.caption ) === 'function' ) {
                    obj.opts.caption = self.opts.caption.apply( item, [ self, obj ] );
                }

                // Make sure we have caption as a string or jQuery object
                if ( !( obj.opts.caption instanceof $ ) ) {
                    obj.opts.caption = obj.opts.caption === undefined ? '' : obj.opts.caption + '';
                }

                // Check if url contains "filter" used to filter the content
                // Example: "ajax.html #something"
                if ( type === 'ajax' ) {
                    srcParts = src.split(/\s+/, 2);

                    if ( srcParts.length > 1 ) {
                        obj.src = srcParts.shift();

                        obj.opts.filter = srcParts.shift();
                    }
                }

                if ( obj.opts.smallBtn == 'auto' ) {

                    if ( $.inArray( type, ['html', 'inline', 'ajax'] ) > -1 ) {
                        obj.opts.toolbar  = false;
                        obj.opts.smallBtn = true;

                    } else {
                        obj.opts.smallBtn = false;
                    }

                }

                // If the type is "pdf", then simply load file into iframe
                if ( type === 'pdf' ) {
                    obj.type = 'iframe';

                    obj.opts.iframe.preload = false;
                }

                // Hide all buttons and disable interactivity for modal items
                if ( obj.opts.modal ) {

                    obj.opts = $.extend(true, obj.opts, {
                        // Remove buttons
                        infobar : 0,
                        toolbar : 0,

                        smallBtn : 0,

                        // Disable keyboard navigation
                        keyboard : 0,

                        // Disable some modules
                        slideShow  : 0,
                        fullScreen : 0,
                        thumbs     : 0,
                        touch      : 0,

                        // Disable click event handlers
                        clickContent    : false,
                        clickSlide      : false,
                        clickOutside    : false,
                        dblclickContent : false,
                        dblclickSlide   : false,
                        dblclickOutside : false
                    });

                }

                // Step 4 - Add processed object to group
                // ======================================

                self.group.push( obj );

            });

        },


        // Attach an event handler functions for:
        //   - navigation buttons
        //   - browser scrolling, resizing;
        //   - focusing
        //   - keyboard
        //   - detect idle
        // ======================================

        addEvents : function() {
            var self = this;

            self.removeEvents();

            // Make navigation elements clickable
            self.$refs.container.on('click.fb-close', '[data-fancybox-close]', function(e) {
                e.stopPropagation();
                e.preventDefault();

                self.close( e );

            }).on( 'click.fb-prev touchend.fb-prev', '[data-fancybox-prev]', function(e) {
                e.stopPropagation();
                e.preventDefault();

                self.previous();

            }).on( 'click.fb-next touchend.fb-next', '[data-fancybox-next]', function(e) {
                e.stopPropagation();
                e.preventDefault();

                self.next();

            }).on( 'click.fb', '[data-fancybox-zoom]', function(e) {
                // Click handler for zoom button
                self[ self.isScaledDown() ? 'scaleToActual' : 'scaleToFit' ]();
            });


            // Handle page scrolling and browser resizing
            $W.on('orientationchange.fb resize.fb', function(e) {

                if ( e && e.originalEvent && e.originalEvent.type === "resize" ) {

                    requestAFrame(function() {
                        self.update();
                    });

                } else {

                    self.$refs.stage.hide();

                    setTimeout(function() {
                        self.$refs.stage.show();

                        self.update();
                    }, 600);

                }

            });

            // Trap keyboard focus inside of the modal, so the user does not accidentally tab outside of the modal
            // (a.k.a. "escaping the modal")
            $D.on('focusin.fb', function(e) {
                var instance = $.fancybox ? $.fancybox.getInstance() : null;

                if ( instance.isClosing || !instance.current || !instance.current.opts.trapFocus || $( e.target ).hasClass( 'fancybox-container' ) || $( e.target ).is( document ) ) {
                    return;
                }

                if ( instance && $( e.target ).css( 'position' ) !== 'fixed' && !instance.$refs.container.has( e.target ).length ) {
                    e.stopPropagation();

                    instance.focus();

                    // Sometimes page gets scrolled, set it back
                    $W.scrollTop( self.scrollTop ).scrollLeft( self.scrollLeft );
                }
            });


            // Enable keyboard navigation
            $D.on('keydown.fb', function (e) {
                var current = self.current,
                    keycode = e.keyCode || e.which;

                if ( !current || !current.opts.keyboard ) {
                    return;
                }

                if ( $(e.target).is('input') || $(e.target).is('textarea') ) {
                    return;
                }

                // Backspace and Esc keys
                if ( keycode === 8 || keycode === 27 ) {
                    e.preventDefault();

                    self.close( e );

                    return;
                }

                // Left arrow and Up arrow
                if ( keycode === 37 || keycode === 38 ) {
                    e.preventDefault();

                    self.previous();

                    return;
                }

                // Righ arrow and Down arrow
                if ( keycode === 39 || keycode === 40 ) {
                    e.preventDefault();

                    self.next();

                    return;
                }

                self.trigger('afterKeydown', e, keycode);
            });


            // Hide controls after some inactivity period
            if ( self.group[ self.currIndex ].opts.idleTime ) {
                self.idleSecondsCounter = 0;

                $D.on('mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle', function(e) {
                    self.idleSecondsCounter = 0;

                    if ( self.isIdle ) {
                        self.showControls();
                    }

                    self.isIdle = false;
                });

                self.idleInterval = window.setInterval(function() {
                    self.idleSecondsCounter++;

                    if ( self.idleSecondsCounter >= self.group[ self.currIndex ].opts.idleTime && !self.isDragging ) {
                        self.isIdle = true;
                        self.idleSecondsCounter = 0;

                        self.hideControls();
                    }

                }, 1000);
            }

        },


        // Remove events added by the core
        // ===============================

        removeEvents : function() {
            var self = this;

            $W.off( 'orientationchange.fb resize.fb' );
            $D.off( 'focusin.fb keydown.fb .fb-idle' );

            this.$refs.container.off( '.fb-close .fb-prev .fb-next' );

            if ( self.idleInterval ) {
                window.clearInterval( self.idleInterval );

                self.idleInterval = null;
            }
        },


        // Change to previous gallery item
        // ===============================

        previous : function( duration ) {
            return this.jumpTo( this.currPos - 1, duration );
        },


        // Change to next gallery item
        // ===========================

        next : function( duration ) {
            return this.jumpTo( this.currPos + 1, duration );
        },


        // Switch to selected gallery item
        // ===============================

        jumpTo : function ( pos, duration, slide ) {
            var self = this,
                firstRun,
                loop,
                current,
                previous,
                canvasWidth,
                currentPos,
                transitionProps;

            var groupLen = self.group.length;

            if ( self.isDragging || self.isClosing || ( self.isAnimating && self.firstRun ) ) {
                return;
            }

            pos  = parseInt( pos, 10 );
            loop = self.current ? self.current.opts.loop : self.opts.loop;

            if ( !loop && ( pos < 0 || pos >= groupLen ) ) {
                return false;
            }

            firstRun = self.firstRun = ( self.firstRun === null );

            if ( groupLen < 2 && !firstRun && !!self.isDragging ) {
                return;
            }

            previous = self.current;

            self.prevIndex = self.currIndex;
            self.prevPos   = self.currPos;

            // Create slides
            current = self.createSlide( pos );

            if ( groupLen > 1 ) {
                if ( loop || current.index > 0 ) {
                    self.createSlide( pos - 1 );
                }

                if ( loop || current.index < groupLen - 1 ) {
                    self.createSlide( pos + 1 );
                }
            }

            self.current   = current;
            self.currIndex = current.index;
            self.currPos   = current.pos;

            self.trigger( 'beforeShow', firstRun );

            self.updateControls();

            currentPos = $.fancybox.getTranslate( current.$slide );

            current.isMoved        = ( currentPos.left !== 0 || currentPos.top !== 0 ) && !current.$slide.hasClass( 'fancybox-animated' );
            current.forcedDuration = undefined;

            if ( $.isNumeric( duration ) ) {
                current.forcedDuration = duration;
            } else {
                duration = current.opts[ firstRun ? 'animationDuration' : 'transitionDuration' ];
            }

            duration = parseInt( duration, 10 );

            // Fresh start - reveal container, current slide and start loading content
            if ( firstRun ) {

                if ( current.opts.animationEffect && duration ) {
                    self.$refs.container.css( 'transition-duration', duration + 'ms' );
                }

                self.$refs.container.removeClass( 'fancybox-is-hidden' );

                forceRedraw( self.$refs.container );

                self.$refs.container.addClass( 'fancybox-is-open' );

                // Make first slide visible (to display loading icon, if needed)
                current.$slide.addClass( 'fancybox-slide--current' );

                self.loadSlide( current );

                self.preload( 'image' );

                return;
            }

            // Clean up
            $.each(self.slides, function( index, slide ) {
                $.fancybox.stop( slide.$slide );
            });

            // Make current that slide is visible even if content is still loading
            current.$slide.removeClass( 'fancybox-slide--next fancybox-slide--previous' ).addClass( 'fancybox-slide--current' );

            // If slides have been dragged, animate them to correct position
            if ( current.isMoved ) {
                canvasWidth = Math.round( current.$slide.width() );

                $.each(self.slides, function( index, slide ) {
                    var pos = slide.pos - current.pos;

                    $.fancybox.animate( slide.$slide, {
                        top  : 0,
                        left : ( pos * canvasWidth ) + ( pos * slide.opts.gutter )
                    }, duration, function() {

                        slide.$slide.removeAttr('style').removeClass( 'fancybox-slide--next fancybox-slide--previous' );

                        if ( slide.pos === self.currPos ) {
                            current.isMoved = false;

                            self.complete();
                        }
                    });
                });

            } else {
                self.$refs.stage.children().removeAttr( 'style' );
            }

            // Start transition that reveals current content
            // or wait when it will be loaded

            if ( current.isLoaded ) {
                self.revealContent( current );

            } else {
                self.loadSlide( current );
            }

            self.preload( 'image' );

            if ( previous.pos === current.pos ) {
                return;
            }

            // Handle previous slide
            // =====================

            transitionProps = 'fancybox-slide--' + ( previous.pos > current.pos ? 'next' : 'previous' );

            previous.$slide.removeClass( 'fancybox-slide--complete fancybox-slide--current fancybox-slide--next fancybox-slide--previous' );

            previous.isComplete = false;

            if ( !duration || ( !current.isMoved && !current.opts.transitionEffect ) ) {
                return;
            }

            if ( current.isMoved ) {
                previous.$slide.addClass( transitionProps );

            } else {

                transitionProps = 'fancybox-animated ' + transitionProps + ' fancybox-fx-' + current.opts.transitionEffect;

                $.fancybox.animate( previous.$slide, transitionProps, duration, function() {
                    previous.$slide.removeClass( transitionProps ).removeAttr( 'style' );
                });

            }

        },


        // Create new "slide" element
        // These are gallery items  that are actually added to DOM
        // =======================================================

        createSlide : function( pos ) {

            var self = this;
            var $slide;
            var index;

            index = pos % self.group.length;
            index = index < 0 ? self.group.length + index : index;

            if ( !self.slides[ pos ] && self.group[ index ] ) {
                $slide = $('<div class="fancybox-slide"></div>').appendTo( self.$refs.stage );

                self.slides[ pos ] = $.extend( true, {}, self.group[ index ], {
                    pos      : pos,
                    $slide   : $slide,
                    isLoaded : false,
                });

                self.updateSlide( self.slides[ pos ] );
            }

            return self.slides[ pos ];
        },


        // Scale image to the actual size of the image
        // ===========================================

        scaleToActual : function( x, y, duration ) {

            var self = this;

            var current = self.current;
            var $what   = current.$content;

            var imgPos, posX, posY, scaleX, scaleY;

            var canvasWidth  = parseInt( current.$slide.width(), 10 );
            var canvasHeight = parseInt( current.$slide.height(), 10 );

            var newImgWidth  = current.width;
            var newImgHeight = current.height;

            if ( !( current.type == 'image' && !current.hasError) || !$what || self.isAnimating ) {
                return;
            }

            $.fancybox.stop( $what );

            self.isAnimating = true;

            x = x === undefined ? canvasWidth  * 0.5  : x;
            y = y === undefined ? canvasHeight * 0.5  : y;

            imgPos = $.fancybox.getTranslate( $what );

            scaleX  = newImgWidth  / imgPos.width;
            scaleY  = newImgHeight / imgPos.height;

            // Get center position for original image
            posX = ( canvasWidth * 0.5  - newImgWidth * 0.5 );
            posY = ( canvasHeight * 0.5 - newImgHeight * 0.5 );

            // Make sure image does not move away from edges
            if ( newImgWidth > canvasWidth ) {
                posX = imgPos.left * scaleX - ( ( x * scaleX ) - x );

                if ( posX > 0 ) {
                    posX = 0;
                }

                if ( posX <  canvasWidth - newImgWidth ) {
                    posX = canvasWidth - newImgWidth;
                }
            }

            if ( newImgHeight > canvasHeight) {
                posY = imgPos.top  * scaleY - ( ( y * scaleY ) - y );

                if ( posY > 0 ) {
                    posY = 0;
                }

                if ( posY <  canvasHeight - newImgHeight ) {
                    posY = canvasHeight - newImgHeight;
                }
            }

            self.updateCursor( newImgWidth, newImgHeight );

            $.fancybox.animate( $what, {
                top    : posY,
                left   : posX,
                scaleX : scaleX,
                scaleY : scaleY
            }, duration || 330, function() {
                self.isAnimating = false;
            });

            // Stop slideshow
            if ( self.SlideShow && self.SlideShow.isActive ) {
                self.SlideShow.stop();
            }
        },


        // Scale image to fit inside parent element
        // ========================================

        scaleToFit : function( duration ) {

            var self = this;

            var current = self.current;
            var $what   = current.$content;
            var end;

            if ( !( current.type == 'image' && !current.hasError) || !$what || self.isAnimating ) {
                return;
            }

            $.fancybox.stop( $what );

            self.isAnimating = true;

            end = self.getFitPos( current );

            self.updateCursor( end.width, end.height );

            $.fancybox.animate( $what, {
                top    : end.top,
                left   : end.left,
                scaleX : end.width  / $what.width(),
                scaleY : end.height / $what.height()
            }, duration || 330, function() {
                self.isAnimating = false;
            });

        },

        // Calculate image size to fit inside viewport
        // ===========================================

        getFitPos : function( slide ) {
            var self  = this;
            var $what = slide.$content;

            var imgWidth  = slide.width;
            var imgHeight = slide.height;

            var margin = slide.opts.margin;

            var canvasWidth, canvasHeight, minRatio, width, height;

            if ( !$what || !$what.length || ( !imgWidth && !imgHeight) ) {
                return false;
            }

            // Convert "margin to CSS style: [ top, right, bottom, left ]
            if ( $.type( margin ) === "number" ) {
                margin = [ margin, margin ];
            }

            if ( margin.length == 2 ) {
                margin = [ margin[0], margin[1], margin[0], margin[1] ];
            }

            // We can not use $slide width here, because it can have different diemensions while in transiton
            canvasWidth  = parseInt( self.$refs.stage.width(), 10 )  - ( margin[ 1 ] + margin[ 3 ] );
            canvasHeight = parseInt( self.$refs.stage.height(), 10 ) - ( margin[ 0 ] + margin[ 2 ] );

            minRatio = Math.min(1, canvasWidth / imgWidth, canvasHeight / imgHeight );

            width  = Math.floor( minRatio * imgWidth );
            height = Math.floor( minRatio * imgHeight );

            // Use floor rounding to make sure it really fits
            return {
                top    : Math.floor( ( canvasHeight - height ) * 0.5 ) + margin[ 0 ],
                left   : Math.floor( ( canvasWidth  - width )  * 0.5 ) + margin[ 3 ],
                width  : width,
                height : height
            };

        },


        // Update content size and position for all slides
        // ==============================================

        update : function() {
            var self = this;

            $.each( self.slides, function( key, slide ) {
                self.updateSlide( slide );
            });
        },


        // Update slide content position and size
        // ======================================

        updateSlide : function( slide, duration ) {
            var self  = this,
                $what = slide && slide.$content;

            if ( $what && ( slide.width || slide.height ) ) {
                self.isAnimating = false;

                $.fancybox.stop( $what );

                $.fancybox.setTranslate( $what, self.getFitPos( slide ) );

                if ( slide.pos === self.currPos ) {
                    self.updateCursor();
                }
            }

            slide.$slide.trigger( 'refresh' );

            self.trigger( 'onUpdate', slide );

        },


        // Horizontally center slide
        // =========================

        centerSlide : function( slide, duration ) {
            var self  = this, canvasWidth, pos;

            if ( self.current ) {
                canvasWidth = Math.round( slide.$slide.width() );
                pos = slide.pos - self.current.pos;

                $.fancybox.animate( slide.$slide, {
                    top  : 0,
                    left : ( pos * canvasWidth ) + ( pos * slide.opts.gutter ),
                    opacity : 1
                }, duration === undefined ? 0 : duration, null, false);
            }
        },


        // Update cursor style depending if content can be zoomed
        // ======================================================

        updateCursor : function( nextWidth, nextHeight ) {

            var self = this;
            var isScaledDown;

            var $container = self.$refs.container.removeClass( 'fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-drag fancybox-can-zoomOut' );

            if ( !self.current || self.isClosing ) {
                return;
            }

            if ( self.isZoomable() ) {

                $container.addClass( 'fancybox-is-zoomable' );

                if ( nextWidth !== undefined && nextHeight !== undefined ) {
                    isScaledDown = nextWidth < self.current.width && nextHeight < self.current.height;

                } else {
                    isScaledDown = self.isScaledDown();
                }

                if ( isScaledDown ) {

                    // If image is scaled down, then, obviously, it can be zoomed to full size
                    $container.addClass( 'fancybox-can-zoomIn' );

                } else {

                    if ( self.current.opts.touch ) {

                        // If image size ir largen than available available and touch module is not disable,
                        // then user can do panning
                        $container.addClass( 'fancybox-can-drag' );

                    } else {
                        $container.addClass( 'fancybox-can-zoomOut' );
                    }

                }

            } else if ( self.current.opts.touch ) {
                $container.addClass( 'fancybox-can-drag' );
            }

        },


        // Check if current slide is zoomable
        // ==================================

        isZoomable : function() {

            var self = this;

            var current = self.current;
            var fitPos;

            if ( !current || self.isClosing ) {
                return;
            }

            // Assume that slide is zoomable if
            //   - image is loaded successfuly
            //   - click action is "zoom"
            //   - actual size of the image is smaller than available area
            if ( current.type === 'image' && current.isLoaded && !current.hasError &&
                ( current.opts.clickContent === 'zoom' || ( $.isFunction( current.opts.clickContent ) && current.opts.clickContent( current ) ===  "zoom" ) )
            ) {

                fitPos = self.getFitPos( current );

                if ( current.width > fitPos.width || current.height > fitPos.height ) {
                    return true;
                }

            }

            return false;

        },


        // Check if current image dimensions are smaller than actual
        // =========================================================

        isScaledDown : function() {

            var self = this;

            var current = self.current;
            var $what   = current.$content;

            var rez = false;

            if ( $what ) {
                rez = $.fancybox.getTranslate( $what );
                rez = rez.width < current.width || rez.height < current.height;
            }

            return rez;

        },


        // Check if image dimensions exceed parent element
        // ===============================================

        canPan : function() {

            var self = this;

            var current = self.current;
            var $what   = current.$content;

            var rez = false;

            if ( $what ) {
                rez = self.getFitPos( current );
                rez = Math.abs( $what.width() - rez.width ) > 1  || Math.abs( $what.height() - rez.height ) > 1;
            }

            return rez;

        },


        // Load content into the slide
        // ===========================

        loadSlide : function( slide ) {

            var self = this, type, $slide;
            var ajaxLoad;

            if ( slide.isLoading ) {
                return;
            }

            if ( slide.isLoaded ) {
                return;
            }

            slide.isLoading = true;

            self.trigger( 'beforeLoad', slide );

            type   = slide.type;
            $slide = slide.$slide;

            $slide
                .off( 'refresh' )
                .trigger( 'onReset' )
                .addClass( 'fancybox-slide--' + ( type || 'unknown' ) )
                .addClass( slide.opts.slideClass );

            // Create content depending on the type

            switch ( type ) {

                case 'image':

                    self.setImage( slide );

                break;

                case 'iframe':

                    self.setIframe( slide );

                break;

                case 'html':

                    self.setContent( slide, slide.src || slide.content );

                break;

                case 'inline':

                    if ( $( slide.src ).length ) {
                        self.setContent( slide, $( slide.src ) );

                    } else {
                        self.setError( slide );
                    }

                break;

                case 'ajax':

                    self.showLoading( slide );

                    ajaxLoad = $.ajax( $.extend( {}, slide.opts.ajax.settings, {
                        url : slide.src,
                        success : function ( data, textStatus ) {

                            if ( textStatus === 'success' ) {
                                self.setContent( slide, data );
                            }

                        },
                        error : function ( jqXHR, textStatus ) {

                            if ( jqXHR && textStatus !== 'abort' ) {
                                self.setError( slide );
                            }

                        }
                    }));

                    $slide.one( 'onReset', function () {
                        ajaxLoad.abort();
                    });

                break;

                case 'video' :

                    self.setContent( slide,
                        '<video controls>' +
                          '<source src="' + slide.src + '" type="' + slide.opts.videoFormat + '">' +
                            'Your browser doesn\'t support HTML5 video' +
                        '</video>'
                    );

                break;

                default:

                    self.setError( slide );

                break;

            }

            return true;

        },


        // Use thumbnail image, if possible
        // ================================

        setImage : function( slide ) {

            var self   = this;
            var srcset = slide.opts.srcset || slide.opts.image.srcset;

            var found, temp, pxRatio, windowWidth;

            // If we have "srcset", then we need to find matching "src" value.
            // This is necessary, because when you set an src attribute, the browser will preload the image
            // before any javascript or even CSS is applied.
            if ( srcset ) {
                pxRatio     = window.devicePixelRatio || 1;
                windowWidth = window.innerWidth  * pxRatio;

                temp = srcset.split(',').map(function ( el ) {
            		var ret = {};

            		el.trim().split(/\s+/).forEach(function ( el, i ) {
                        var value = parseInt( el.substring(0, el.length - 1), 10 );

            			if ( i === 0 ) {
            				return ( ret.url = el );
            			}

                        if ( value ) {
                            ret.value   = value;
                            ret.postfix = el[ el.length - 1 ];
                        }

            		});

            		return ret;
            	});

                // Sort by value
                temp.sort(function (a, b) {
                  return a.value - b.value;
                });

                // Ok, now we have an array of all srcset values
                for ( var j = 0; j < temp.length; j++ ) {
                    var el = temp[ j ];

                    if ( ( el.postfix === 'w' && el.value >= windowWidth ) || ( el.postfix === 'x' && el.value >= pxRatio ) ) {
                        found = el;
                        break;
                    }
                }

                // If not found, take the last one
                if ( !found && temp.length ) {
                    found = temp[ temp.length - 1 ];
                }

                if ( found ) {
                    slide.src = found.url;

                    // If we have default width/height values, we can calculate height for matching source
                    if ( slide.width && slide.height && found.postfix == 'w' ) {
                        slide.height = ( slide.width / slide.height ) * found.value;
                        slide.width  = found.value;
                    }
                }
            }

            // This will be wrapper containing both ghost and actual image
            slide.$content = $('<div class="fancybox-image-wrap"></div>')
                .addClass( 'fancybox-is-hidden' )
                .appendTo( slide.$slide );


            // If we have a thumbnail, we can display it while actual image is loading
            // Users will not stare at black screen and actual image will appear gradually
            if ( slide.opts.preload !== false && slide.opts.width && slide.opts.height && ( slide.opts.thumb || slide.opts.$thumb ) ) {

                slide.width  = slide.opts.width;
                slide.height = slide.opts.height;

                slide.$ghost = $('<img />')
                    .one('error', function() {

                        $(this).remove();

                        slide.$ghost = null;

                        self.setBigImage( slide );

                    })
                    .one('load', function() {

                        self.afterLoad( slide );

                        self.setBigImage( slide );

                    })
                    .addClass( 'fancybox-image' )
                    .appendTo( slide.$content )
                    .attr( 'src', slide.opts.thumb || slide.opts.$thumb.attr( 'src' ) );

            } else {

                self.setBigImage( slide );

            }

        },


        // Create full-size image
        // ======================

        setBigImage : function ( slide ) {
            var self = this;
            var $img = $('<img />');

            slide.$image = $img
                .one('error', function() {

                    self.setError( slide );

                })
                .one('load', function() {

                    // Clear timeout that checks if loading icon needs to be displayed
                    clearTimeout( slide.timouts );

                    slide.timouts = null;

                    if ( self.isClosing ) {
                        return;
                    }

                    slide.width  = slide.opts.width  || this.naturalWidth;
                    slide.height = slide.opts.height || this.naturalHeight;

                    if ( slide.opts.image.srcset ) {
                        $img.attr( 'sizes', '100vw' ).attr( 'srcset', slide.opts.image.srcset );
                    }

                    self.hideLoading( slide );

                    if ( slide.$ghost ) {

                        slide.timouts = setTimeout(function() {
                            slide.timouts = null;

                            slide.$ghost.hide();

                        }, Math.min( 300, Math.max( 1000, slide.height / 1600 ) ) );

                    } else {
                        self.afterLoad( slide );
                    }

                })
                .addClass( 'fancybox-image' )
                .attr('src', slide.src)
                .appendTo( slide.$content );

            if ( ( $img[0].complete || $img[0].readyState == "complete" ) && $img[0].naturalWidth && $img[0].naturalHeight ) {
                  $img.trigger( 'load' );

            } else if( $img[0].error ) {
                 $img.trigger( 'error' );

            } else {

                slide.timouts = setTimeout(function() {
                    if ( !$img[0].complete && !slide.hasError ) {
                        self.showLoading( slide );
                    }

                }, 100);

            }

        },


        // Create iframe wrapper, iframe and bindings
        // ==========================================

        setIframe : function( slide ) {
            var self	= this,
                opts    = slide.opts.iframe,
                $slide	= slide.$slide,
                $iframe;

            slide.$content = $('<div class="fancybox-content' + ( opts.preload ? ' fancybox-is-hidden' : '' ) + '"></div>')
                .css( opts.css )
                .appendTo( $slide );

            $iframe = $( opts.tpl.replace(/\{rnd\}/g, new Date().getTime()) )
                .attr( opts.attr )
                .appendTo( slide.$content );

            if ( opts.preload ) {

                self.showLoading( slide );

                // Unfortunately, it is not always possible to determine if iframe is successfully loaded
                // (due to browser security policy)

                $iframe.on('load.fb error.fb', function(e) {
                    this.isReady = 1;

                    slide.$slide.trigger( 'refresh' );

                    self.afterLoad( slide );
                });

                // Recalculate iframe content size
                // ===============================

                $slide.on('refresh.fb', function() {
                    var $wrap = slide.$content,
                        frameWidth  = opts.css.width,
                        frameHeight = opts.css.height,
                        scrollWidth,
                        $contents,
                        $body;

                    if ( $iframe[0].isReady !== 1 ) {
                        return;
                    }

                    // Check if content is accessible,
                    // it will fail if frame is not with the same origin

                    try {
                        $contents = $iframe.contents();
                        $body     = $contents.find('body');

                    } catch (ignore) {}

                    // Calculate dimensions for the wrapper
                    if ( $body && $body.length ) {

                        if ( frameWidth === undefined ) {
                            scrollWidth = $iframe[0].contentWindow.document.documentElement.scrollWidth;

                            frameWidth = Math.ceil( $body.outerWidth(true) + ( $wrap.width() - scrollWidth ) );
                            frameWidth += $wrap.outerWidth() - $wrap.innerWidth();
                        }

                        if ( frameHeight === undefined ) {
                            frameHeight = Math.ceil( $body.outerHeight(true) );
                            frameHeight += $wrap.outerHeight() - $wrap.innerHeight();
                        }

                        // Resize wrapper to fit iframe content
                        if ( frameWidth ) {
                            $wrap.width( frameWidth );
                        }

                        if ( frameHeight ) {
                            $wrap.height( frameHeight );
                        }
                    }

                    $wrap.removeClass( 'fancybox-is-hidden' );

                });

            } else {

                this.afterLoad( slide );

            }

            $iframe.attr( 'src', slide.src );

            if ( slide.opts.smallBtn === true ) {
                slide.$content.prepend( self.translate( slide, slide.opts.btnTpl.smallBtn ) );
            }

            // Remove iframe if closing or changing gallery item
            $slide.one( 'onReset', function () {

                // This helps IE not to throw errors when closing
                try {

                    $( this ).find( 'iframe' ).hide().attr( 'src', '//about:blank' );

                } catch ( ignore ) {}

                $( this ).empty();

                slide.isLoaded = false;

            });

        },


        // Wrap and append content to the slide
        // ======================================

        setContent : function ( slide, content ) {

            var self = this;

            if ( self.isClosing ) {
                return;
            }

            self.hideLoading( slide );

            slide.$slide.empty();

            if ( isQuery( content ) && content.parent().length ) {

                // If content is a jQuery object, then it will be moved to the slide.
                // The placeholder is created so we will know where to put it back.
                // If user is navigating gallery fast, then the content might be already inside fancyBox
                // =====================================================================================

                // Make sure content is not already moved to fancyBox
                content.parent( '.fancybox-slide--inline' ).trigger( 'onReset' );

                // Create temporary element marking original place of the content
                slide.$placeholder = $( '<div></div>' ).hide().insertAfter( content );

                // Make sure content is visible
                content.css('display', 'inline-block');

            } else if ( !slide.hasError ) {

                // If content is just a plain text, try to convert it to html
                if ( $.type( content ) === 'string' ) {
                    content = $('<div>').append( $.trim( content ) ).contents();

                    // If we have text node, then add wrapping element to make vertical alignment work
                    if ( content[0].nodeType === 3 ) {
                        content = $('<div>').html( content );
                    }
                }

                // If "filter" option is provided, then filter content
                if ( slide.opts.filter ) {
                    content = $('<div>').html( content ).find( slide.opts.filter );
                }

            }

            slide.$slide.one('onReset', function () {

                // Pause all html5 video/audio
                $( this ).find( 'video,audio' ).trigger( 'pause' );

                // Put content back
                if ( slide.$placeholder ) {
                    slide.$placeholder.after( content.hide() ).remove();

                    slide.$placeholder = null;
                }

                // Remove custom close button
                if ( slide.$smallBtn ) {
                    slide.$smallBtn.remove();

                    slide.$smallBtn = null;
                }

                // Remove content and mark slide as not loaded
                if ( !slide.hasError ) {
                    $(this).empty();

                    slide.isLoaded = false;
                }

            });

            slide.$content = $( content ).appendTo( slide.$slide );

            this.afterLoad( slide );
        },

        // Display error message
        // =====================

        setError : function ( slide ) {

            slide.hasError = true;

            slide.$slide.removeClass( 'fancybox-slide--' + slide.type );

            this.setContent( slide, this.translate( slide, slide.opts.errorTpl ) );

        },


        // Show loading icon inside the slide
        // ==================================

        showLoading : function( slide ) {

            var self = this;

            slide = slide || self.current;

            if ( slide && !slide.$spinner ) {
                slide.$spinner = $( self.opts.spinnerTpl ).appendTo( slide.$slide );
            }

        },

        // Remove loading icon from the slide
        // ==================================

        hideLoading : function( slide ) {

            var self = this;

            slide = slide || self.current;

            if ( slide && slide.$spinner ) {
                slide.$spinner.remove();

                delete slide.$spinner;
            }

        },


        // Adjustments after slide content has been loaded
        // ===============================================

        afterLoad : function( slide ) {

            var self = this;

            if ( self.isClosing ) {
                return;
            }

            slide.isLoading = false;
            slide.isLoaded  = true;

            self.trigger( 'afterLoad', slide );

            self.hideLoading( slide );

            if ( slide.opts.smallBtn && !slide.$smallBtn ) {
                slide.$smallBtn = $( self.translate( slide, slide.opts.btnTpl.smallBtn ) ).appendTo( slide.$content.filter('div,form').first() );
            }

            if ( slide.opts.protect && slide.$content && !slide.hasError ) {

                // Disable right click
                slide.$content.on( 'contextmenu.fb', function( e ) {
                     if ( e.button == 2 ) {
                         e.preventDefault();
                     }

                    return true;
                });

                // Add fake element on top of the image
                // This makes a bit harder for user to select image
                if ( slide.type === 'image' ) {
                    $( '<div class="fancybox-spaceball"></div>' ).appendTo( slide.$content );
                }

            }

            self.revealContent( slide );

        },


        // Make content visible
        // This method is called right after content has been loaded or
        // user navigates gallery and transition should start
        // ============================================================

        revealContent : function( slide ) {

            var self   = this;
            var $slide = slide.$slide;

            var effect, effectClassName, duration, opacity, end, start = false;

            effect   = slide.opts[ self.firstRun ? 'animationEffect'   : 'transitionEffect' ];
            duration = slide.opts[ self.firstRun ? 'animationDuration' : 'transitionDuration' ];

            duration = parseInt( slide.forcedDuration === undefined ? duration : slide.forcedDuration, 10 );

            if ( slide.isMoved || slide.pos !== self.currPos || !duration ) {
                effect = false;
            }

            // Check if can zoom
            if ( effect === 'zoom' && !( slide.pos === self.currPos && duration && slide.type === 'image' && !slide.hasError && ( start = self.getThumbPos( slide ) ) ) ) {
                effect = 'fade';
            }

            // Zoom animation
            // ==============

            if ( effect === 'zoom' ) {
                end = self.getFitPos( slide );

                end.scaleX = end.width  / start.width;
                end.scaleY = end.height / start.height;

                delete end.width;
                delete end.height;

                // Check if we need to animate opacity
                opacity = slide.opts.zoomOpacity;

                if ( opacity == 'auto' ) {
                    opacity = Math.abs( slide.width / slide.height - start.width / start.height ) > 0.1;
                }

                if ( opacity ) {
                    start.opacity = 0.1;
                    end.opacity   = 1;
                }

                // Draw image at start position
                $.fancybox.setTranslate( slide.$content.removeClass( 'fancybox-is-hidden' ), start );

                forceRedraw( slide.$content );

                // Start animation
                $.fancybox.animate( slide.$content, end, duration, function() {
                    self.complete();
                });

                return;
            }

            self.updateSlide( slide );


            // Simply show content
            // ===================

            if ( !effect ) {
                forceRedraw( $slide );

                slide.$content.removeClass( 'fancybox-is-hidden' );

                if ( slide.pos === self.currPos ) {
                    self.complete();
                }

                return;
            }

            $.fancybox.stop( $slide );

            effectClassName = 'fancybox-animated fancybox-slide--' + ( slide.pos >= self.prevPos ? 'next' : 'previous' ) + ' fancybox-fx-' + effect;

            $slide.removeAttr( 'style' ).removeClass( 'fancybox-slide--current fancybox-slide--next fancybox-slide--previous' ).addClass( effectClassName );

            slide.$content.removeClass( 'fancybox-is-hidden' );

            //Force reflow for CSS3 transitions
            forceRedraw( $slide );

            $.fancybox.animate( $slide, 'fancybox-slide--current', duration, function(e) {
                $slide.removeClass( effectClassName ).removeAttr( 'style' );

                if ( slide.pos === self.currPos ) {
                    self.complete();
                }

            }, true);

        },


        // Check if we can and have to zoom from thumbnail
        //================================================

        getThumbPos : function( slide ) {

            var self = this;
            var rez  = false;

            // Check if element is inside the viewport by at least 1 pixel
            var isElementVisible = function( $el ) {
                var element = $el[0];

                var elementRect = element.getBoundingClientRect();
                var parentRects = [];

                var visibleInAllParents;

                while ( element.parentElement !== null ) {
                    if ( $(element.parentElement).css('overflow') === 'hidden'  || $(element.parentElement).css('overflow') === 'auto' ) {
                        parentRects.push(element.parentElement.getBoundingClientRect());
                    }

                    element = element.parentElement;
                }

                visibleInAllParents = parentRects.every(function(parentRect){
                    var visiblePixelX = Math.min(elementRect.right, parentRect.right) - Math.max(elementRect.left, parentRect.left);
                    var visiblePixelY = Math.min(elementRect.bottom, parentRect.bottom) - Math.max(elementRect.top, parentRect.top);

                    return visiblePixelX > 0 && visiblePixelY > 0;
                });

                return visibleInAllParents &&
                    elementRect.bottom > 0 && elementRect.right > 0 &&
                    elementRect.left < $(window).width() && elementRect.top < $(window).height();
            };

            var $thumb   = slide.opts.$thumb;
            var thumbPos = $thumb ? $thumb.offset() : 0;
            var slidePos;

            if ( thumbPos && $thumb[0].ownerDocument === document && isElementVisible( $thumb ) ) {
                slidePos = self.$refs.stage.offset();

                rez = {
                    top    : thumbPos.top  - slidePos.top  + parseFloat( $thumb.css( "border-top-width" ) || 0 ),
                    left   : thumbPos.left - slidePos.left + parseFloat( $thumb.css( "border-left-width" ) || 0 ),
                    width  : $thumb.width(),
                    height : $thumb.height(),
                    scaleX : 1,
                    scaleY : 1
                };
            }

            return rez;
        },


        // Final adjustments after current gallery item is moved to position
        // and it`s content is loaded
        // ==================================================================

        complete : function() {
            var self = this,
                current = self.current,
                slides  = {},
                promise;

            if ( current.isMoved || !current.isLoaded || current.isComplete ) {
                return;
            }

            current.isComplete = true;

            current.$slide.siblings().trigger( 'onReset' );

            self.preload( 'inline' );

            // Trigger any CSS3 transiton inside the slide
            forceRedraw( current.$slide );

            current.$slide.addClass( 'fancybox-slide--complete' );

            // Remove unnecessary slides
            $.each( self.slides, function( key, slide ) {
                if ( slide.pos >= self.currPos - 1 && slide.pos <= self.currPos + 1 ) {
                    slides[ slide.pos ] = slide;

                } else if ( slide ) {
                    $.fancybox.stop( slide.$slide );

                    slide.$slide.off().remove();
                }
            });

            self.slides = slides;

            self.updateCursor();

            self.trigger( 'afterShow' );

            // Play first html5 video/audio
            current.$slide.find( 'video,audio' ).first().trigger( 'play' );

            // Try to focus on the first focusable element
            if ( $( document.activeElement ).is( '[disabled]' ) || ( current.opts.autoFocus && !( current.type == 'image' || current.type === 'iframe' ) ) ) {
                self.focus();
            }

        },


        // Preload next and previous slides
        // ================================

        preload : function( type ) {
            var self = this,
                next = self.slides[ self.currPos + 1 ],
                prev = self.slides[ self.currPos - 1 ];

            if ( next && next.type === type ) {
                self.loadSlide( next );
            }

            if ( prev && prev.type === type ) {
                self.loadSlide( prev );
            }
        },


        // Try to find and focus on the first focusable element
        // ====================================================

        focus : function() {
            var current = this.current;
            var $el;

            if ( this.isClosing ) {
                return;
            }

            if ( current && current.isComplete ) {

                // Look for first input with autofocus attribute
                $el = current.$slide.find('input[autofocus]:enabled:visible:first');

                if ( !$el.length ) {
                    $el = current.$slide.find('button,:input,[tabindex],a').filter(':enabled:visible:first');
                }
            }

            $el = $el && $el.length ? $el : this.$refs.container;

            $el.focus();
        },


        // Activates current instance - brings container to the front and enables keyboard,
        // notifies other instances about deactivating
        // =================================================================================

        activate : function () {
            var self = this;

            // Deactivate all instances
            $( '.fancybox-container' ).each(function () {
                var instance = $(this).data( 'FancyBox' );

                // Skip self and closing instances
                if (instance && instance.id !== self.id && !instance.isClosing) {
                    instance.trigger( 'onDeactivate' );

                    instance.removeEvents();

                    instance.isVisible = false;
                }

            });

            self.isVisible = true;

            if ( self.current || self.isIdle ) {
                self.update();

                self.updateControls();
            }

            self.trigger( 'onActivate' );

            self.addEvents();
        },


        // Start closing procedure
        // This will start "zoom-out" animation if needed and clean everything up afterwards
        // =================================================================================

        close : function( e, d ) {

            var self    = this;
            var current = self.current;

            var effect, duration;
            var $what, opacity, start, end;

            var done = function() {
                self.cleanUp( e );
            };

            if ( self.isClosing ) {
                return false;
            }

            self.isClosing = true;

            // If beforeClose callback prevents closing, make sure content is centered
            if ( self.trigger( 'beforeClose', e ) === false ) {
                self.isClosing = false;

                requestAFrame(function() {
                    self.update();
                });

                return false;
            }

            // Remove all events
            // If there are multiple instances, they will be set again by "activate" method
            self.removeEvents();

            if ( current.timouts ) {
                clearTimeout( current.timouts );
            }

            $what    = current.$content;
            effect   = current.opts.animationEffect;
            duration = $.isNumeric( d ) ? d : ( effect ? current.opts.animationDuration : 0 );

            // Remove other slides
            current.$slide.off( transitionEnd ).removeClass( 'fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated' );

            current.$slide.siblings().trigger( 'onReset' ).remove();

            // Trigger animations
            if ( duration ) {
                self.$refs.container.removeClass( 'fancybox-is-open' ).addClass( 'fancybox-is-closing' );
            }

            // Clean up
            self.hideLoading( current );

            self.hideControls();

            self.updateCursor();

            // Check if possible to zoom-out
            if ( effect === 'zoom' && !( e !== true && $what && duration && current.type === 'image' && !current.hasError && ( end = self.getThumbPos( current ) ) ) ) {
                effect = 'fade';
            }

            if ( effect === 'zoom' ) {
                $.fancybox.stop( $what );

                start = $.fancybox.getTranslate( $what );

                start.width  = start.width  * start.scaleX;
                start.height = start.height * start.scaleY;

                // Check if we need to animate opacity
                opacity = current.opts.zoomOpacity;

                if ( opacity == 'auto' ) {
                    opacity = Math.abs( current.width / current.height - end.width / end.height ) > 0.1;
                }

                if ( opacity ) {
                    end.opacity = 0;
                }

                start.scaleX = start.width  / end.width;
                start.scaleY = start.height / end.height;

                start.width  = end.width;
                start.height = end.height;

                $.fancybox.setTranslate( current.$content, start );

                forceRedraw( current.$content );

                $.fancybox.animate( current.$content, end, duration, done );

                return true;
            }

            if ( effect && duration ) {

                // If skip animation
                if ( e === true ) {
                    setTimeout( done, duration );

                } else {
                    $.fancybox.animate( current.$slide.removeClass( 'fancybox-slide--current' ), 'fancybox-animated fancybox-slide--previous fancybox-fx-' + effect, duration, done );
                }

            } else {
                done();
            }

            return true;
        },


        // Final adjustments after removing the instance
        // =============================================

        cleanUp : function( e ) {
            var self  = this,
                $body = $( 'body' ),
                instance,
                offset;

            self.current.$slide.trigger( 'onReset' );

            self.$refs.container.empty().remove();

            self.trigger( 'afterClose', e );

            // Place back focus
            if ( self.$lastFocus && !!self.current.opts.backFocus ) {
                self.$lastFocus.focus();
            }

            self.current = null;

            // Check if there are other instances
            instance = $.fancybox.getInstance();

            if ( instance ) {
                instance.activate();

            } else {

                $W.scrollTop( self.scrollTop ).scrollLeft( self.scrollLeft );

                $body.removeClass( 'fancybox-active compensate-for-scrollbar' );

                if ( $body.hasClass( 'fancybox-iosfix' ) ) {
                    offset = parseInt(document.body.style.top, 10);

                    $body.removeClass( 'fancybox-iosfix' ).css( 'top', '' ).scrollTop( offset * -1 );
                }

                $( '#fancybox-style-noscroll' ).remove();

            }

        },


        // Call callback and trigger an event
        // ==================================

        trigger : function( name, slide ) {
            var args  = Array.prototype.slice.call(arguments, 1),
                self  = this,
                obj   = slide && slide.opts ? slide : self.current,
                rez;

            if ( obj ) {
                args.unshift( obj );

            } else {
                obj = self;
            }

            args.unshift( self );

            if ( $.isFunction( obj.opts[ name ] ) ) {
                rez = obj.opts[ name ].apply( obj, args );
            }

            if ( rez === false ) {
                return rez;
            }

            if ( name === 'afterClose' || !self.$refs ) {
                $D.trigger( name + '.fb', args );

            } else {
                self.$refs.container.trigger( name + '.fb', args );
            }

        },


        // Update infobar values, navigation button states and reveal caption
        // ==================================================================

        updateControls : function ( force ) {

            var self = this;

            var current  = self.current,
                index    = current.index,
                caption  = current.opts.caption,
                $container = self.$refs.container,
                $caption   = self.$refs.caption;

            // Recalculate content dimensions
            current.$slide.trigger( 'refresh' );

            self.$caption = caption && caption.length ? $caption.html( caption ) : null;

            if ( !self.isHiddenControls && !self.isIdle ) {
                self.showControls();
            }

            // Update info and navigation elements
            $container.find('[data-fancybox-count]').html( self.group.length );
            $container.find('[data-fancybox-index]').html( index + 1 );

            $container.find('[data-fancybox-prev]').prop( 'disabled', ( !current.opts.loop && index <= 0 ) );
            $container.find('[data-fancybox-next]').prop( 'disabled', ( !current.opts.loop && index >= self.group.length - 1 ) );

            if ( current.type === 'image' ) {

                // Update download button source
                $container.find('[data-fancybox-download]').attr( 'href', current.opts.image.src || current.src ).show();

            } else {
                $container.find('[data-fancybox-download],[data-fancybox-zoom]').hide();
            }
        },

        // Hide toolbar and caption
        // ========================

        hideControls : function () {

            this.isHiddenControls = true;

            this.$refs.container.removeClass( 'fancybox-show-infobar fancybox-show-toolbar fancybox-show-caption fancybox-show-nav' );

        },

        showControls : function() {
            var self = this;
            var opts = self.current ? self.current.opts : self.opts;
            var $container = self.$refs.container;

            self.isHiddenControls   = false;
            self.idleSecondsCounter = 0;

            $container
                .toggleClass( 'fancybox-show-toolbar', !!( opts.toolbar && opts.buttons ) )
                .toggleClass( 'fancybox-show-infobar', !!( opts.infobar && self.group.length > 1 ) )
                .toggleClass( 'fancybox-show-nav',     !!( opts.arrows && self.group.length > 1 ) )
                .toggleClass( 'fancybox-is-modal',     !!opts.modal );

            if ( self.$caption ) {
                $container.addClass( 'fancybox-show-caption ');

            } else {
               $container.removeClass( 'fancybox-show-caption' );
           }

       },


       // Toggle toolbar and caption
       // ==========================

       toggleControls : function() {
           if ( this.isHiddenControls ) {
               this.showControls();

           } else {
               this.hideControls();
           }

       },


    });


    $.fancybox = {

        version  : "3.2.10",
        defaults : defaults,


        // Get current instance and execute a command.
        //
        // Examples of usage:
        //
        //   $instance = $.fancybox.getInstance();
        //   $.fancybox.getInstance().jumpTo( 1 );
        //   $.fancybox.getInstance( 'jumpTo', 1 );
        //   $.fancybox.getInstance( function() {
        //       console.info( this.currIndex );
        //   });
        // ======================================================

        getInstance : function ( command ) {
            var instance = $('.fancybox-container:not(".fancybox-is-closing"):last').data( 'FancyBox' );
            var args     = Array.prototype.slice.call(arguments, 1);

            if ( instance instanceof FancyBox ) {

                if ( $.type( command ) === 'string' ) {
                    instance[ command ].apply( instance, args );

                } else if ( $.type( command ) === 'function' ) {
                    command.apply( instance, args );
                }

                return instance;
            }

            return false;

        },


        // Create new instance
        // ===================

        open : function ( items, opts, index ) {
            return new FancyBox( items, opts, index );
        },


        // Close current or all instances
        // ==============================

        close : function ( all ) {
            var instance = this.getInstance();

            if ( instance ) {
                instance.close();

                // Try to find and close next instance

                if ( all === true ) {
                    this.close();
                }
            }

        },

        // Close instances and unbind all events
        // ==============================

        destroy : function() {

            this.close( true );

            $D.off( 'click.fb-start' );

        },


        // Try to detect mobile devices
        // ============================

        isMobile : document.createTouch !== undefined && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),


        // Detect if 'translate3d' support is available
        // ============================================

        use3d : (function() {
            var div = document.createElement('div');

            return window.getComputedStyle && window.getComputedStyle( div ).getPropertyValue('transform') && !(document.documentMode && document.documentMode < 11);
        }()),

        // Helper function to get current visual state of an element
        // returns array[ top, left, horizontal-scale, vertical-scale, opacity ]
        // =====================================================================

        getTranslate : function( $el ) {
            var matrix;

            if ( !$el || !$el.length ) {
                return false;
            }

            matrix  = $el.eq( 0 ).css('transform');

            if ( matrix && matrix.indexOf( 'matrix' ) !== -1 ) {
                matrix = matrix.split('(')[1];
                matrix = matrix.split(')')[0];
                matrix = matrix.split(',');
            } else {
                matrix = [];
            }

            if ( matrix.length ) {

                // If IE
                if ( matrix.length > 10 ) {
                    matrix = [ matrix[13], matrix[12], matrix[0], matrix[5] ];

                } else {
                    matrix = [ matrix[5], matrix[4], matrix[0], matrix[3]];
                }

                matrix = matrix.map(parseFloat);

            } else {
                matrix = [ 0, 0, 1, 1 ];

                var transRegex = /\.*translate\((.*)px,(.*)px\)/i;
                var transRez = transRegex.exec( $el.eq( 0 ).attr('style') );

                if ( transRez ) {
                    matrix[ 0 ] = parseFloat( transRez[2] );
                    matrix[ 1 ] = parseFloat( transRez[1] );
                }
            }

            return {
                top     : matrix[ 0 ],
                left    : matrix[ 1 ],
                scaleX  : matrix[ 2 ],
                scaleY  : matrix[ 3 ],
                opacity : parseFloat( $el.css('opacity') ),
                width   : $el.width(),
                height  : $el.height()
            };

        },


        // Shortcut for setting "translate3d" properties for element
        // Can set be used to set opacity, too
        // ========================================================

        setTranslate : function( $el, props ) {
            var str  = '';
            var css  = {};

            if ( !$el || !props ) {
                return;
            }

            if ( props.left !== undefined || props.top !== undefined ) {
                str = ( props.left === undefined ? $el.position().left : props.left )  + 'px, ' + ( props.top === undefined ? $el.position().top : props.top ) + 'px';

                if ( this.use3d ) {
                    str = 'translate3d(' + str + ', 0px)';

                } else {
                    str = 'translate(' + str + ')';
                }
            }

            if ( props.scaleX !== undefined && props.scaleY !== undefined ) {
                str = (str.length ? str + ' ' : '') + 'scale(' + props.scaleX + ', ' + props.scaleY + ')';
            }

            if ( str.length ) {
                css.transform = str;
            }

            if ( props.opacity !== undefined ) {
                css.opacity = props.opacity;
            }

            if ( props.width !== undefined ) {
                css.width = props.width;
            }

            if ( props.height !== undefined ) {
                css.height = props.height;
            }

            return $el.css( css );
        },


        // Simple CSS transition handler
        // =============================

        animate : function ( $el, to, duration, callback, leaveAnimationName ) {
            if ( $.isFunction( duration ) ) {
                callback = duration;
                duration = null;
            }

            if ( !$.isPlainObject( to ) ) {
                $el.removeAttr( 'style' );
            }

            $el.on( transitionEnd, function(e) {

                // Skip events from child elements and z-index change
                if ( e && e.originalEvent && ( !$el.is( e.originalEvent.target ) || e.originalEvent.propertyName == 'z-index' ) ) {
                    return;
                }

                $.fancybox.stop( $el );

                if ( $.isPlainObject( to ) ) {

                    if ( to.scaleX !== undefined && to.scaleY !== undefined ) {
                        $el.css( 'transition-duration', '' );

                        to.width  = Math.round( $el.width()  * to.scaleX );
                        to.height = Math.round( $el.height() * to.scaleY );

                        to.scaleX = 1;
                        to.scaleY = 1;

                        $.fancybox.setTranslate( $el, to );
                    }

                    if ( leaveAnimationName === false ) {
                        $el.removeAttr( 'style' );
                    }

                } else if ( leaveAnimationName !== true ) {
                    $el.removeClass( to );
                }

                if ( $.isFunction( callback ) ) {
                    callback( e );
                }

            });

            if ( $.isNumeric( duration ) ) {
                $el.css( 'transition-duration', duration + 'ms' );
            }

            if ( $.isPlainObject( to ) ) {
                $.fancybox.setTranslate( $el, to );

            } else {
                $el.addClass( to );
            }

            if ( to.scaleX && $el.hasClass( 'fancybox-image-wrap' ) ) {
                $el.parent().addClass( 'fancybox-is-scaling' );
            }

            // Make sure that `transitionend` callback gets fired
            $el.data("timer", setTimeout(function() {
                $el.trigger( 'transitionend' );
            }, duration + 16));

        },

        stop : function( $el ) {
            clearTimeout( $el.data("timer") );

            $el.off( 'transitionend' ).css( 'transition-duration', '' );

            if ( $el.hasClass( 'fancybox-image-wrap' ) ) {
                $el.parent().removeClass( 'fancybox-is-scaling' );
            }
        }

    };


    // Default click handler for "fancyboxed" links
    // ============================================

    function _run( e ) {
        var $target	= $( e.currentTarget ),
            opts	= e.data ? e.data.options : {},
            value	= $target.attr( 'data-fancybox' ) || '',
            index	= 0,
            items   = [];

        // Avoid opening multiple times
        if ( e.isDefaultPrevented() ) {
            return;
        }

        e.preventDefault();

        // Get all related items and find index for clicked one
        if ( value ) {
            items = opts.selector ? $( opts.selector ) : ( e.data ? e.data.items : [] );
            items = items.length ? items.filter( '[data-fancybox="' + value + '"]' ) : $( '[data-fancybox="' + value + '"]' );

            index = items.index( $target );

            // Sometimes current item can not be found
            // (for example, when slider clones items)
            if ( index < 0 ) {
                index = 0;
            }

        } else {
            items = [ $target ];
        }

        $.fancybox.open( items, opts, index );
    }


    // Create a jQuery plugin
    // ======================

    $.fn.fancybox = function (options) {
        var selector;

        options  = options || {};
        selector = options.selector || false;

        if ( selector ) {

            $( 'body' ).off( 'click.fb-start', selector ).on( 'click.fb-start', selector, {
                options : options
            }, _run );

        } else {

            this.off( 'click.fb-start' ).on( 'click.fb-start', {
                items   : this,
                options : options
            }, _run);

        }

        return this;
    };


    // Self initializing plugin
    // ========================

    $D.on( 'click.fb-start', '[data-fancybox]', _run );

}( window, document, window.jQuery || jQuery ));

// ==========================================================================
//
// Media
// Adds additional media type support
//
// ==========================================================================
;(function ($) {

	'use strict';

	// Formats matching url to final form

	var format = function (url, rez, params) {
		if ( !url ) {
			return;
		}

		params = params || '';

		if ( $.type(params) === "object" ) {
			params = $.param(params, true);
		}

		$.each(rez, function (key, value) {
			url = url.replace('$' + key, value || '');
		});

		if (params.length) {
			url += (url.indexOf('?') > 0 ? '&' : '?') + params;
		}

		return url;
	};

	// Object containing properties for each media type

	var defaults = {
		youtube : {
			matcher : /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
			params  : {
				autoplay : 1,
				autohide : 1,
				fs  : 1,
				rel : 0,
				hd  : 1,
				wmode : 'transparent',
				enablejsapi : 1,
				html5 : 1
			},
			paramPlace : 8,
			type  : 'iframe',
			url   : '//www.youtube.com/embed/$4',
			thumb : '//img.youtube.com/vi/$4/hqdefault.jpg'
		},

		vimeo : {
			matcher : /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
			params  : {
				autoplay : 1,
				hd : 1,
				show_title    : 1,
				show_byline   : 1,
				show_portrait : 0,
				fullscreen    : 1,
				api : 1
			},
			paramPlace : 3,
			type : 'iframe',
			url : '//player.vimeo.com/video/$2'
		},

		metacafe : {
			matcher : /metacafe.com\/watch\/(\d+)\/(.*)?/,
			type    : 'iframe',
			url     : '//www.metacafe.com/embed/$1/?ap=1'
		},

		dailymotion : {
			matcher : /dailymotion.com\/video\/(.*)\/?(.*)/,
			params : {
				additionalInfos : 0,
				autoStart : 1
			},
			type : 'iframe',
			url  : '//www.dailymotion.com/embed/video/$1'
		},

		vine : {
			matcher : /vine.co\/v\/([a-zA-Z0-9\?\=\-]+)/,
			type    : 'iframe',
			url     : '//vine.co/v/$1/embed/simple'
		},

		instagram : {
			matcher : /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
			type    : 'image',
			url     : '//$1/p/$2/media/?size=l'
		},

		// Examples:
		// http://maps.google.com/?ll=48.857995,2.294297&spn=0.007666,0.021136&t=m&z=16
		// https://www.google.com/maps/@37.7852006,-122.4146355,14.65z
		// https://www.google.com/maps/place/Googleplex/@37.4220041,-122.0833494,17z/data=!4m5!3m4!1s0x0:0x6c296c66619367e0!8m2!3d37.4219998!4d-122.0840572
		gmap_place : {
			matcher : /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
			type    : 'iframe',
			url     : function (rez) {
				return '//maps.google.' + rez[2] + '/?ll=' + ( rez[9] ? rez[9] + '&z=' + Math.floor(  rez[10]  ) + ( rez[12] ? rez[12].replace(/^\//, "&") : '' )  : rez[12] ) + '&output=' + ( rez[12] && rez[12].indexOf('layer=c') > 0 ? 'svembed' : 'embed' );
			}
		},

		// Examples:
		// https://www.google.com/maps/search/Empire+State+Building/
		// https://www.google.com/maps/search/?api=1&query=centurylink+field
		// https://www.google.com/maps/search/?api=1&query=47.5951518,-122.3316393
		gmap_search : {
			matcher : /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
			type    : 'iframe',
			url     : function (rez) {
				return '//maps.google.' + rez[2] + '/maps?q=' + rez[5].replace('query=', 'q=').replace('api=1', '') + '&output=embed';
			}
		}
	};

	$(document).on('objectNeedsType.fb', function (e, instance, item) {

		var url	 = item.src || '',
			type = false,
			media,
			thumb,
			rez,
			params,
			urlParams,
			paramObj,
			provider;

		media = $.extend( true, {}, defaults, item.opts.media );

		// Look for any matching media type
		$.each(media, function ( providerName, providerOpts ) {
			rez = url.match( providerOpts.matcher );

			if ( !rez ) {
				return;
			}

			type     = providerOpts.type;
			paramObj = {};

			if ( providerOpts.paramPlace && rez[ providerOpts.paramPlace ] ) {
				urlParams = rez[ providerOpts.paramPlace ];

				if ( urlParams[ 0 ] == '?' ) {
					urlParams = urlParams.substring(1);
				}

				urlParams = urlParams.split('&');

				for ( var m = 0; m < urlParams.length; ++m ) {
					var p = urlParams[ m ].split('=', 2);

					if ( p.length == 2 ) {
						paramObj[ p[0] ] = decodeURIComponent( p[1].replace(/\+/g, " ") );
					}
				}
			}

			params = $.extend( true, {}, providerOpts.params, item.opts[ providerName ], paramObj );

			url   = $.type( providerOpts.url ) === "function" ? providerOpts.url.call( this, rez, params, item ) : format( providerOpts.url, rez, params );
			thumb = $.type( providerOpts.thumb ) === "function" ? providerOpts.thumb.call( this, rez, params, item ) : format( providerOpts.thumb, rez );

			if ( providerName === 'vimeo' ) {
				url = url.replace('&%23', '#');
			}

			return false;
		});

		// If it is found, then change content type and update the url

		if ( type ) {
			item.src  = url;
			item.type = type;

			if ( !item.opts.thumb && !( item.opts.$thumb && item.opts.$thumb.length ) ) {
				item.opts.thumb = thumb;
			}

			if ( type === 'iframe' ) {
				$.extend(true, item.opts, {
					iframe : {
						preload : false,
						attr : {
							scrolling : "no"
						}
					}
				});

				item.contentProvider = provider;

				item.opts.slideClass += ' fancybox-slide--' + ( provider == 'gmap_place' || provider == 'gmap_search' ? 'map' : 'video' );
			}

		} else if ( url ) {
			item.type = item.opts.defaultType;
		}

	});

}( window.jQuery || jQuery ));

// ==========================================================================
//
// Guestures
// Adds touch guestures, handles click and tap events
//
// ==========================================================================
;(function (window, document, $) {
	'use strict';

	var requestAFrame = (function () {
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			// if all else fails, use setTimeout
			function (callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	})();

	var cancelAFrame = (function () {
		return window.cancelAnimationFrame ||
			window.webkitCancelAnimationFrame ||
			window.mozCancelAnimationFrame ||
			window.oCancelAnimationFrame ||
			function (id) {
				window.clearTimeout(id);
			};
	})();

	var pointers = function( e ) {
		var result = [];

		e = e.originalEvent || e || window.e;
		e = e.touches && e.touches.length ? e.touches : ( e.changedTouches && e.changedTouches.length ? e.changedTouches : [ e ] );

		for ( var key in e ) {

			if ( e[ key ].pageX ) {
				result.push( { x : e[ key ].pageX, y : e[ key ].pageY } );

			} else if ( e[ key ].clientX ) {
				result.push( { x : e[ key ].clientX, y : e[ key ].clientY } );
			}
		}

		return result;
	};

	var distance = function( point2, point1, what ) {
		if ( !point1 || !point2 ) {
			return 0;
		}

		if ( what === 'x' ) {
			return point2.x - point1.x;

		} else if ( what === 'y' ) {
			return point2.y - point1.y;
		}

		return Math.sqrt( Math.pow( point2.x - point1.x, 2 ) + Math.pow( point2.y - point1.y, 2 ) );
	};

	var isClickable = function( $el ) {
		if ( $el.is('a,area,button,[role="button"],input,label,select,summary,textarea') || $.isFunction( $el.get(0).onclick ) || $el.data('selectable') ) {
			return true;
		}

		// Check for attributes like data-fancybox-next or data-fancybox-close
		for ( var i = 0, atts = $el[0].attributes, n = atts.length; i < n; i++ ) {
			if ( atts[i].nodeName.substr(0, 14) === 'data-fancybox-' ) {
				return true;
			}
		}

	 	return false;
	};

	var hasScrollbars = function( el ) {
		var overflowY = window.getComputedStyle( el )['overflow-y'];
		var overflowX = window.getComputedStyle( el )['overflow-x'];

		var vertical   = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
		var horizontal = (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

		return vertical || horizontal;
	};

	var isScrollable = function ( $el ) {
		var rez = false;

		while ( true ) {
			rez	= hasScrollbars( $el.get(0) );

			if ( rez ) {
				break;
			}

			$el = $el.parent();

			if ( !$el.length || $el.hasClass( 'fancybox-stage' ) || $el.is( 'body' ) ) {
				break;
			}
		}

		return rez;
	};


	var Guestures = function ( instance ) {
		var self = this;

		self.instance = instance;

		self.$bg        = instance.$refs.bg;
		self.$stage     = instance.$refs.stage;
		self.$container = instance.$refs.container;

		self.destroy();

		self.$container.on( 'touchstart.fb.touch mousedown.fb.touch', $.proxy(self, 'ontouchstart') );
	};

	Guestures.prototype.destroy = function() {
		this.$container.off( '.fb.touch' );
	};

	Guestures.prototype.ontouchstart = function( e ) {
		var self = this;

		var $target  = $( e.target );
		var instance = self.instance;
		var current  = instance.current;
		var $content = current.$content;

		var isTouchDevice = ( e.type == 'touchstart' );

		// Do not respond to both (touch and mouse) events
		if ( isTouchDevice ) {
			self.$container.off( 'mousedown.fb.touch' );
		}

		// Ignore right click
		if ( e.originalEvent && e.originalEvent.button == 2 ) {
			return;
		}

		// Ignore taping on links, buttons, input elements
		if ( !$target.length || isClickable( $target ) || isClickable( $target.parent() ) ) {
			return;
		}

		// Ignore clicks on the scrollbar
		if ( !$target.is('img') && e.originalEvent.clientX > $target[0].clientWidth + $target.offset().left ) {
			return;
		}

		// Ignore clicks while zooming or closing
		if ( !current || self.instance.isAnimating || self.instance.isClosing ) {
			e.stopPropagation();
			e.preventDefault();

			return;
		}

		self.realPoints = self.startPoints = pointers( e );

		if ( !self.startPoints ) {
			return;
		}

		e.stopPropagation();

		self.startEvent = e;

		self.canTap   = true;
		self.$target  = $target;
		self.$content = $content;
		self.opts     = current.opts.touch;

		self.isPanning   = false;
		self.isSwiping   = false;
		self.isZooming   = false;
		self.isScrolling = false;

		self.sliderStartPos  = self.sliderLastPos || { top: 0, left: 0 };
		self.contentStartPos = $.fancybox.getTranslate( self.$content );
		self.contentLastPos  = null;

		self.startTime = new Date().getTime();
		self.distanceX = self.distanceY = self.distance = 0;

		self.canvasWidth  = Math.round( current.$slide[0].clientWidth );
		self.canvasHeight = Math.round( current.$slide[0].clientHeight );

		$(document)
			.off( '.fb.touch' )
			.on( isTouchDevice ? 'touchend.fb.touch touchcancel.fb.touch' : 'mouseup.fb.touch mouseleave.fb.touch', $.proxy(self, "ontouchend"))
			.on( isTouchDevice ? 'touchmove.fb.touch' : 'mousemove.fb.touch', $.proxy(self, "ontouchmove"));

		if ( $.fancybox.isMobile ) {
			document.addEventListener('scroll', self.onscroll, true);
		}

		if ( !(self.opts || instance.canPan() ) || !( $target.is( self.$stage ) || self.$stage.find( $target ).length ) ) {

			// Prevent image ghosting while dragging
			if ( $target.is('img') ) {
				e.preventDefault();
			}

			return;
		}

		if ( !( $.fancybox.isMobile && ( isScrollable( $target ) || isScrollable( $target.parent() ) ) ) ) {
			e.preventDefault();
		}

		if ( self.startPoints.length === 1 ) {
			if ( current.type === 'image' && ( self.contentStartPos.width > self.canvasWidth + 1 || self.contentStartPos.height > self.canvasHeight + 1 ) ) {
				$.fancybox.stop( self.$content );

				self.$content.css( 'transition-duration', '' );

				self.isPanning = true;

			} else {
				self.isSwiping = true;
			}

			self.$container.addClass( 'fancybox-controls--isGrabbing' );
		}

		if ( self.startPoints.length === 2 && !instance.isAnimating && !current.hasError && current.type === 'image' && ( current.isLoaded || current.$ghost ) ) {
			self.canTap    = false;
			self.isSwiping = false;
			self.isPanning = false;

			self.isZooming = true;

			$.fancybox.stop( self.$content );

			self.$content.css( 'transition-duration', '' );

			self.centerPointStartX = ( ( self.startPoints[0].x + self.startPoints[1].x ) * 0.5 ) - $(window).scrollLeft();
			self.centerPointStartY = ( ( self.startPoints[0].y + self.startPoints[1].y ) * 0.5 ) - $(window).scrollTop();

			self.percentageOfImageAtPinchPointX = ( self.centerPointStartX - self.contentStartPos.left ) / self.contentStartPos.width;
			self.percentageOfImageAtPinchPointY = ( self.centerPointStartY - self.contentStartPos.top  ) / self.contentStartPos.height;

			self.startDistanceBetweenFingers = distance( self.startPoints[0], self.startPoints[1] );
		}

	};

	Guestures.prototype.onscroll = function(e) {
		self.isScrolling = true;
	};

	Guestures.prototype.ontouchmove = function( e ) {
		var self = this,
			$target = $(e.target);

		if ( self.isScrolling || !( $target.is( self.$stage ) || self.$stage.find( $target ).length ) ) {
			self.canTap = false;

			return;
		}

		self.newPoints = pointers( e );

		if ( !( self.opts || self.instance.canPan() ) || !self.newPoints || !self.newPoints.length ) {
			return;
		}

		if ( !(self.isSwiping && self.isSwiping === true) ) {
			e.preventDefault();
		}

		self.distanceX = distance( self.newPoints[0], self.startPoints[0], 'x' );
		self.distanceY = distance( self.newPoints[0], self.startPoints[0], 'y' );

		self.distance = distance( self.newPoints[0], self.startPoints[0] )

		// Skip false ontouchmove events (Chrome)
		if ( self.distance > 0 ) {
			if ( self.isSwiping ) {
				self.onSwipe(e);

			} else if ( self.isPanning ) {
				self.onPan();

			} else if ( self.isZooming ) {
				self.onZoom();
			}
		}

	};

	Guestures.prototype.onSwipe = function(e) {
		var self = this,
			swiping = self.isSwiping,
			left    = self.sliderStartPos.left || 0,
			angle;

		// If direction is not yet determined
		if ( swiping === true ) {

			// We need at least 10px distance to correctly calculate an angle
			if ( Math.abs( self.distance ) > 10 ) {
				self.canTap = false;

				if ( self.instance.group.length < 2 && self.opts.vertical ) {
					self.isSwiping = 'y';

				} else if ( self.instance.isDragging || self.opts.vertical === false || ( self.opts.vertical === 'auto' && $( window ).width() > 800 ) ) {
					self.isSwiping = 'x';

				} else {
					angle = Math.abs( Math.atan2( self.distanceY, self.distanceX ) * 180 / Math.PI );

					self.isSwiping = ( angle > 45 && angle < 135 ) ? 'y' : 'x';
				}

				self.canTap = false;

				 if ( self.isSwiping === 'y' && $.fancybox.isMobile && ( isScrollable( self.$target ) || isScrollable( self.$target.parent() ) ) ) {
					 self.isScrolling = true;

					 return;
				 }

				self.instance.isDragging = self.isSwiping;

				// Reset points to avoid jumping, because we dropped first swipes to calculate the angle
				self.startPoints = self.newPoints;

				$.each(self.instance.slides, function( index, slide ) {
					$.fancybox.stop( slide.$slide );

					slide.$slide.css( 'transition-duration', '' );

					slide.inTransition = false;

					if ( slide.pos === self.instance.current.pos ) {
						self.sliderStartPos.left = $.fancybox.getTranslate( slide.$slide ).left;
					}
				});

				// Stop slideshow
				if ( self.instance.SlideShow && self.instance.SlideShow.isActive ) {
					self.instance.SlideShow.stop();
				}
			}

			return;
		}

		// Sticky edges
		if ( swiping == 'x' ) {
			if ( self.distanceX > 0 && ( self.instance.group.length < 2 || ( self.instance.current.index === 0 && !self.instance.current.opts.loop ) ) ) {
				left = left + Math.pow( self.distanceX, 0.8 );

			} else if ( self.distanceX < 0 && ( self.instance.group.length < 2 || ( self.instance.current.index === self.instance.group.length - 1 && !self.instance.current.opts.loop ) ) ) {
				left = left - Math.pow( -self.distanceX, 0.8 );

			} else {
				left = left + self.distanceX;
			}
		}

		self.sliderLastPos = {
			top  : swiping == 'x' ? 0 : self.sliderStartPos.top + self.distanceY,
			left : left
		};

		if ( self.requestId ) {
			cancelAFrame( self.requestId );

			self.requestId = null;
		}

		self.requestId = requestAFrame(function() {

			if ( self.sliderLastPos ) {
				$.each(self.instance.slides, function( index, slide ) {
					var pos = slide.pos - self.instance.currPos;

					$.fancybox.setTranslate( slide.$slide, {
						top  : self.sliderLastPos.top,
						left : self.sliderLastPos.left + ( pos * self.canvasWidth ) + ( pos * slide.opts.gutter )
					});
				});

				self.$container.addClass( 'fancybox-is-sliding' );
			}

		});

	};

	Guestures.prototype.onPan = function() {
		var self = this;

		// Sometimes, when tapping causally, image can move a bit and that breaks double tapping
		if ( distance( self.newPoints[0], self.realPoints[0] ) < ($.fancybox.isMobile ? 10 : 5) ) {
			self.startPoints = self.newPoints;
			return;
		}

		self.canTap = false;

		self.contentLastPos = self.limitMovement();

		if ( self.requestId ) {
			cancelAFrame( self.requestId );

			self.requestId = null;
		}

		self.requestId = requestAFrame(function() {
			$.fancybox.setTranslate( self.$content, self.contentLastPos );
		});
	};

	// Make panning sticky to the edges
	Guestures.prototype.limitMovement = function() {
		var self = this;

		var canvasWidth  = self.canvasWidth;
		var canvasHeight = self.canvasHeight;

		var distanceX = self.distanceX;
		var distanceY = self.distanceY;

		var contentStartPos = self.contentStartPos;

		var currentOffsetX = contentStartPos.left;
		var currentOffsetY = contentStartPos.top;

		var currentWidth  = contentStartPos.width;
		var currentHeight = contentStartPos.height;

		var minTranslateX, minTranslateY,
			maxTranslateX, maxTranslateY,
			newOffsetX, newOffsetY;

		if ( currentWidth > canvasWidth ) {
			newOffsetX = currentOffsetX + distanceX;

		} else {
			newOffsetX = currentOffsetX;
		}

		newOffsetY = currentOffsetY + distanceY;

		// Slow down proportionally to traveled distance
		minTranslateX = Math.max( 0, canvasWidth  * 0.5 - currentWidth  * 0.5 );
		minTranslateY = Math.max( 0, canvasHeight * 0.5 - currentHeight * 0.5 );

		maxTranslateX = Math.min( canvasWidth  - currentWidth,  canvasWidth  * 0.5 - currentWidth  * 0.5 );
		maxTranslateY = Math.min( canvasHeight - currentHeight, canvasHeight * 0.5 - currentHeight * 0.5 );

		if ( currentWidth > canvasWidth ) {

			//   ->
			if ( distanceX > 0 && newOffsetX > minTranslateX ) {
				newOffsetX = minTranslateX - 1 + Math.pow( -minTranslateX + currentOffsetX + distanceX, 0.8 ) || 0;
			}

			//    <-
			if ( distanceX < 0 && newOffsetX < maxTranslateX ) {
				newOffsetX = maxTranslateX + 1 - Math.pow( maxTranslateX - currentOffsetX - distanceX, 0.8 ) || 0;
			}

		}

		if ( currentHeight > canvasHeight ) {

			//   \/
			if ( distanceY > 0 && newOffsetY > minTranslateY ) {
				newOffsetY = minTranslateY - 1 + Math.pow(-minTranslateY + currentOffsetY + distanceY, 0.8 ) || 0;
			}

			//   /\
			if ( distanceY < 0 && newOffsetY < maxTranslateY ) {
				newOffsetY = maxTranslateY + 1 - Math.pow ( maxTranslateY - currentOffsetY - distanceY, 0.8 ) || 0;
			}

		}

		return {
			top    : newOffsetY,
			left   : newOffsetX,
			scaleX : contentStartPos.scaleX,
			scaleY : contentStartPos.scaleY
		};

	};

	Guestures.prototype.limitPosition = function( newOffsetX, newOffsetY, newWidth, newHeight ) {
		var self = this;

		var canvasWidth  = self.canvasWidth;
		var canvasHeight = self.canvasHeight;

		if ( newWidth > canvasWidth ) {
			newOffsetX = newOffsetX > 0 ? 0 : newOffsetX;
			newOffsetX = newOffsetX < canvasWidth - newWidth ? canvasWidth - newWidth : newOffsetX;

		} else {

			// Center horizontally
			newOffsetX = Math.max( 0, canvasWidth / 2 - newWidth / 2 );

		}

		if ( newHeight > canvasHeight ) {
			newOffsetY = newOffsetY > 0 ? 0 : newOffsetY;
			newOffsetY = newOffsetY < canvasHeight - newHeight ? canvasHeight - newHeight : newOffsetY;

		} else {

			// Center vertically
			newOffsetY = Math.max( 0, canvasHeight / 2 - newHeight / 2 );

		}

		return {
			top  : newOffsetY,
			left : newOffsetX
		};

	};

	Guestures.prototype.onZoom = function() {
		var self = this;

		// Calculate current distance between points to get pinch ratio and new width and height

		var currentWidth  = self.contentStartPos.width;
		var currentHeight = self.contentStartPos.height;

		var currentOffsetX = self.contentStartPos.left;
		var currentOffsetY = self.contentStartPos.top;

		var endDistanceBetweenFingers = distance( self.newPoints[0], self.newPoints[1] );

		var pinchRatio = endDistanceBetweenFingers / self.startDistanceBetweenFingers;

		var newWidth  = Math.floor( currentWidth  * pinchRatio );
		var newHeight = Math.floor( currentHeight * pinchRatio );

		// This is the translation due to pinch-zooming
		var translateFromZoomingX = (currentWidth  - newWidth)  * self.percentageOfImageAtPinchPointX;
		var translateFromZoomingY = (currentHeight - newHeight) * self.percentageOfImageAtPinchPointY;

		//Point between the two touches

		var centerPointEndX = ((self.newPoints[0].x + self.newPoints[1].x) / 2) - $(window).scrollLeft();
		var centerPointEndY = ((self.newPoints[0].y + self.newPoints[1].y) / 2) - $(window).scrollTop();

		// And this is the translation due to translation of the centerpoint
		// between the two fingers

		var translateFromTranslatingX = centerPointEndX - self.centerPointStartX;
		var translateFromTranslatingY = centerPointEndY - self.centerPointStartY;

		// The new offset is the old/current one plus the total translation

		var newOffsetX = currentOffsetX + ( translateFromZoomingX + translateFromTranslatingX );
		var newOffsetY = currentOffsetY + ( translateFromZoomingY + translateFromTranslatingY );

		var newPos = {
			top    : newOffsetY,
			left   : newOffsetX,
			scaleX : self.contentStartPos.scaleX * pinchRatio,
			scaleY : self.contentStartPos.scaleY * pinchRatio
		};

		self.canTap = false;

		self.newWidth  = newWidth;
		self.newHeight = newHeight;

		self.contentLastPos = newPos;

		if ( self.requestId ) {
			cancelAFrame( self.requestId );

			self.requestId = null;
		}

		self.requestId = requestAFrame(function() {
			$.fancybox.setTranslate( self.$content, self.contentLastPos );
		});

	};

	Guestures.prototype.ontouchend = function( e ) {
		var self = this;
		var dMs  = Math.max( (new Date().getTime() ) - self.startTime, 1);

		var swiping   = self.isSwiping;
		var panning   = self.isPanning;
		var zooming   = self.isZooming;
		var scrolling = self.isScrolling;

		self.endPoints = pointers( e );

		self.$container.removeClass( 'fancybox-controls--isGrabbing' );

		$(document).off( '.fb.touch' );

		document.removeEventListener('scroll', self.onscroll, true);

		if ( self.requestId ) {
			cancelAFrame( self.requestId );

			self.requestId = null;
		}

		self.isSwiping   = false;
		self.isPanning   = false;
		self.isZooming   = false;
		self.isScrolling = false;

		self.instance.isDragging = false;

		if ( self.canTap ) {
			return self.onTap( e );
		}

		self.speed = 366;

		// Speed in px/ms
		self.velocityX = self.distanceX / dMs * 0.5;
		self.velocityY = self.distanceY / dMs * 0.5;

		self.speedX = Math.max( self.speed * 0.5, Math.min( self.speed * 1.5, ( 1 / Math.abs( self.velocityX ) ) * self.speed ) );

		if ( panning ) {
			self.endPanning();

		} else if ( zooming ) {
			self.endZooming();

		} else {
			self.endSwiping( swiping, scrolling );
		}

		return;
	};

	Guestures.prototype.endSwiping = function( swiping, scrolling ) {
		var self = this,
			ret  = false,
			len  = self.instance.group.length;

		self.sliderLastPos = null;

		// Close if swiped vertically / navigate if horizontally
		if ( swiping == 'y' && !scrolling && Math.abs( self.distanceY ) > 50 ) {

			// Continue vertical movement
			$.fancybox.animate( self.instance.current.$slide, {
				top     : self.sliderStartPos.top + self.distanceY + ( self.velocityY * 150 ),
				opacity : 0
			}, 150 );

			ret = self.instance.close( true, 300 );

		} else if ( swiping == 'x' && self.distanceX > 50 && len > 1 ) {
			ret = self.instance.previous( self.speedX );

		} else if ( swiping == 'x' && self.distanceX < -50 && len > 1 ) {
			ret = self.instance.next( self.speedX );
		}

		if ( ret === false && ( swiping == 'x' || swiping == 'y' ) ) {
			if ( scrolling || len < 2 ) {
				self.instance.centerSlide( self.instance.current, 150 );
			} else {
				self.instance.jumpTo( self.instance.current.index );
			}
		}

		self.$container.removeClass( 'fancybox-is-sliding' );

	};

	// Limit panning from edges
	// ========================

	Guestures.prototype.endPanning = function() {

		var self = this;
		var newOffsetX, newOffsetY, newPos;

		if ( !self.contentLastPos ) {
			return;
		}

		if ( self.opts.momentum === false ) {
			newOffsetX = self.contentLastPos.left;
			newOffsetY = self.contentLastPos.top;

		} else {

			// Continue movement
			newOffsetX = self.contentLastPos.left + ( self.velocityX * self.speed );
			newOffsetY = self.contentLastPos.top  + ( self.velocityY * self.speed );
		}

		newPos = self.limitPosition( newOffsetX, newOffsetY, self.contentStartPos.width, self.contentStartPos.height );

		 newPos.width  = self.contentStartPos.width;
		 newPos.height = self.contentStartPos.height;

		$.fancybox.animate( self.$content, newPos, 330 );
	};


	Guestures.prototype.endZooming = function() {
		var self = this;

		var current = self.instance.current;

		var newOffsetX, newOffsetY, newPos, reset;

		var newWidth  = self.newWidth;
		var newHeight = self.newHeight;

		if ( !self.contentLastPos ) {
			return;
		}

		newOffsetX = self.contentLastPos.left;
		newOffsetY = self.contentLastPos.top;

		reset = {
			top    : newOffsetY,
			left   : newOffsetX,
			width  : newWidth,
			height : newHeight,
			scaleX : 1,
			scaleY : 1
		};

		// Reset scalex/scaleY values; this helps for perfomance and does not break animation
		$.fancybox.setTranslate( self.$content, reset );

		if ( newWidth < self.canvasWidth && newHeight < self.canvasHeight ) {
			self.instance.scaleToFit( 150 );

		} else if ( newWidth > current.width || newHeight > current.height ) {
			self.instance.scaleToActual( self.centerPointStartX, self.centerPointStartY, 150 );

		} else {

			newPos = self.limitPosition( newOffsetX, newOffsetY, newWidth, newHeight );

			// Switch from scale() to width/height or animation will not work correctly
			$.fancybox.setTranslate( self.content, $.fancybox.getTranslate( self.$content ) );

			$.fancybox.animate( self.$content, newPos, 150 );
		}

	};

	Guestures.prototype.onTap = function(e) {
		var self    = this;
		var $target = $( e.target );

		var instance = self.instance;
		var current  = instance.current;

		var endPoints = ( e && pointers( e ) ) || self.startPoints;

		var tapX = endPoints[0] ? endPoints[0].x - self.$stage.offset().left : 0;
		var tapY = endPoints[0] ? endPoints[0].y - self.$stage.offset().top  : 0;

		var where;

		var process = function ( prefix ) {

			var action = current.opts[ prefix ];

			if ( $.isFunction( action ) ) {
				action = action.apply( instance, [ current, e ] );
			}

			if ( !action) {
				return;
			}

			switch ( action ) {

				case "close" :

					instance.close( self.startEvent );

				break;

				case "toggleControls" :

					instance.toggleControls( true );

				break;

				case "next" :

					instance.next();

				break;

				case "nextOrClose" :

					if ( instance.group.length > 1 ) {
						instance.next();

					} else {
						instance.close( self.startEvent );
					}

				break;

				case "zoom" :

					if ( current.type == 'image' && ( current.isLoaded || current.$ghost ) ) {

						if ( instance.canPan() ) {
							instance.scaleToFit();

						} else if ( instance.isScaledDown() ) {
							instance.scaleToActual( tapX, tapY );

						} else if ( instance.group.length < 2 ) {
							instance.close( self.startEvent );
						}
					}

				break;
			}

		};

		// Ignore right click
		if ( e.originalEvent && e.originalEvent.button == 2 ) {
			return;
		}

		// Skip if clicked on the scrollbar
		if ( !$target.is('img') && tapX > $target[0].clientWidth + $target.offset().left ) {
			return;
		}

		// Check where is clicked
		if ( $target.is( '.fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container' ) ) {
			where = 'Outside';

		} else if ( $target.is( '.fancybox-slide' ) ) {
			where = 'Slide';

		} else if ( instance.current.$content && instance.current.$content.find( $target ).addBack().filter( $target ).length ) {
		 	where = 'Content';

		} else {
			return;
		}

		// Check if this is a double tap
		if ( self.tapped ) {

			// Stop previously created single tap
			clearTimeout( self.tapped );
			self.tapped = null;

			// Skip if distance between taps is too big
			if ( Math.abs( tapX - self.tapX ) > 50 || Math.abs( tapY - self.tapY ) > 50 ) {
				return this;
			}

			// OK, now we assume that this is a double-tap
			process( 'dblclick' + where );

		} else {

			// Single tap will be processed if user has not clicked second time within 300ms
			// or there is no need to wait for double-tap
			self.tapX = tapX;
			self.tapY = tapY;

			if ( current.opts[ 'dblclick' + where ] && current.opts[ 'dblclick' + where ] !== current.opts[ 'click' + where ] ) {

				self.tapped = setTimeout(function() {
					self.tapped = null;

					process( 'click' + where );

				}, 500);

			} else {
				process( 'click' + where );
			}

		}

		return this;
	};

	$(document).on('onActivate.fb', function (e, instance) {
		if ( instance && !instance.Guestures ) {
			instance.Guestures = new Guestures( instance );
		}
	});

}( window, document, window.jQuery || jQuery ));

// ==========================================================================
//
// SlideShow
// Enables slideshow functionality
//
// Example of usage:
// $.fancybox.getInstance().SlideShow.start()
//
// ==========================================================================
;(function (document, $) {
	'use strict';

	$.extend(true, $.fancybox.defaults, {
		btnTpl : {
			slideShow :
				'<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}">' +
					'<svg viewBox="0 0 40 40">' +
						'<path d="M13,12 L27,20 L13,27 Z" />' +
						'<path d="M15,10 v19 M23,10 v19" />' +
					'</svg>' +
				'</button>'
		},
		slideShow : {
			autoStart : false,
            speed     : 3000
		}
	});

	var SlideShow = function( instance ) {
		this.instance = instance;
		this.init();
	};

	$.extend( SlideShow.prototype, {
		timer    : null,
		isActive : false,
		$button  : null,

		init : function() {
			var self = this;

			self.$button = self.instance.$refs.toolbar.find('[data-fancybox-play]').on('click', function() {
				self.toggle();
			});

			if ( self.instance.group.length < 2 || !self.instance.group[ self.instance.currIndex ].opts.slideShow ) {
				self.$button.hide();
			}
		},

		set : function( force ) {
			var self = this;

			// Check if reached last element
			if ( self.instance && self.instance.current && (force === true || self.instance.current.opts.loop || self.instance.currIndex < self.instance.group.length - 1 )) {
				self.timer = setTimeout(function() {
					if ( self.isActive ) {
						self.instance.jumpTo( (self.instance.currIndex + 1) % self.instance.group.length );
					}

				}, self.instance.current.opts.slideShow.speed);

			} else {
				self.stop();
				self.instance.idleSecondsCounter = 0;
				self.instance.showControls();
			}
		},

		clear : function() {
			var self = this;

			clearTimeout( self.timer );

			self.timer = null;
		},

		start : function() {
			var self = this;
			var current = self.instance.current;

			if ( current ) {
				self.isActive = true;

				self.$button
					.attr( 'title', current.opts.i18n[ current.opts.lang ].PLAY_STOP )
					.removeClass( 'fancybox-button--play' )
					.addClass( 'fancybox-button--pause' );

					self.set( true );
			}
		},

		stop : function() {
			var self = this;
			var current = self.instance.current;

			self.clear();

			self.$button
				.attr( 'title', current.opts.i18n[ current.opts.lang ].PLAY_START )
				.removeClass( 'fancybox-button--pause' )
				.addClass( 'fancybox-button--play' );

			self.isActive = false;
		},

		toggle : function() {
			var self = this;

			if ( self.isActive ) {
				self.stop();

			} else {
				self.start();
			}
		}

	});

	$(document).on({
		'onInit.fb' : function(e, instance) {
			if ( instance && !instance.SlideShow ) {
				instance.SlideShow = new SlideShow( instance );
			}
		},

		'beforeShow.fb' : function(e, instance, current, firstRun) {
			var SlideShow = instance && instance.SlideShow;

			if ( firstRun ) {

				if ( SlideShow && current.opts.slideShow.autoStart ) {
					SlideShow.start();
				}

			} else if ( SlideShow && SlideShow.isActive )  {
				SlideShow.clear();
			}
		},

		'afterShow.fb' : function(e, instance, current) {
			var SlideShow = instance && instance.SlideShow;

			if ( SlideShow && SlideShow.isActive ) {
				SlideShow.set();
			}
		},

		'afterKeydown.fb' : function(e, instance, current, keypress, keycode) {
			var SlideShow = instance && instance.SlideShow;

			// "P" or Spacebar
			if ( SlideShow && current.opts.slideShow && ( keycode === 80 || keycode === 32 ) && !$(document.activeElement).is( 'button,a,input' ) ) {
				keypress.preventDefault();

				SlideShow.toggle();
			}
		},

		'beforeClose.fb onDeactivate.fb' : function(e, instance) {
			var SlideShow = instance && instance.SlideShow;

			if ( SlideShow ) {
				SlideShow.stop();
			}
		}
	});

	// Page Visibility API to pause slideshow when window is not active
	$(document).on("visibilitychange", function() {
		var instance  = $.fancybox.getInstance();
		var SlideShow = instance && instance.SlideShow;

		if ( SlideShow && SlideShow.isActive ) {
			if ( document.hidden ) {
				SlideShow.clear();

			} else {
				SlideShow.set();
			}
		}
	});

}( document, window.jQuery || jQuery ));

// ==========================================================================
//
// FullScreen
// Adds fullscreen functionality
//
// ==========================================================================
;(function (document, $) {
	'use strict';

	// Collection of methods supported by user browser
	var fn = (function () {

		var fnMap = [
			[
				'requestFullscreen',
				'exitFullscreen',
				'fullscreenElement',
				'fullscreenEnabled',
				'fullscreenchange',
				'fullscreenerror'
			],
			// new WebKit
			[
				'webkitRequestFullscreen',
				'webkitExitFullscreen',
				'webkitFullscreenElement',
				'webkitFullscreenEnabled',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			// old WebKit (Safari 5.1)
			[
				'webkitRequestFullScreen',
				'webkitCancelFullScreen',
				'webkitCurrentFullScreenElement',
				'webkitCancelFullScreen',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			[
				'mozRequestFullScreen',
				'mozCancelFullScreen',
				'mozFullScreenElement',
				'mozFullScreenEnabled',
				'mozfullscreenchange',
				'mozfullscreenerror'
			],
			[
				'msRequestFullscreen',
				'msExitFullscreen',
				'msFullscreenElement',
				'msFullscreenEnabled',
				'MSFullscreenChange',
				'MSFullscreenError'
			]
		];

		var val;
		var ret = {};
		var i, j;

		for ( i = 0; i < fnMap.length; i++ ) {
			val = fnMap[ i ];

			if ( val && val[ 1 ] in document ) {
				for ( j = 0; j < val.length; j++ ) {
					ret[ fnMap[ 0 ][ j ] ] = val[ j ];
				}

				return ret;
			}
		}

		return false;
	})();

	// If browser does not have Full Screen API, then simply unset default button template and stop
	if ( !fn ) {

		if ( $ && $.fancybox ) {
			$.fancybox.defaults.btnTpl.fullScreen = false;
		}

		return;
	}

	var FullScreen = {

		request : function ( elem ) {

			elem = elem || document.documentElement;

			elem[ fn.requestFullscreen ]( elem.ALLOW_KEYBOARD_INPUT );

		},
		exit : function () {

			document[ fn.exitFullscreen ]();

		},
		toggle : function ( elem ) {

			elem = elem || document.documentElement;

			if ( this.isFullscreen() ) {
				this.exit();

			} else {
				this.request( elem );
			}

		},
		isFullscreen : function()  {

			return Boolean( document[ fn.fullscreenElement ] );

		},
		enabled : function()  {

			return Boolean( document[ fn.fullscreenEnabled ] );

		}
	};

	$.extend(true, $.fancybox.defaults, {
		btnTpl : {
			fullScreen :
				'<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fullscreen" title="{{FULL_SCREEN}}">' +
					'<svg viewBox="0 0 40 40">' +
						'<path d="M9,12 h22 v16 h-22 v-16 v16 h22 v-16 Z" />' +
					'</svg>' +
				'</button>'
		},
		fullScreen : {
			autoStart : false
		}
	});

	$(document).on({
		'onInit.fb' : function(e, instance) {
			var $container;

			if ( instance && instance.group[ instance.currIndex ].opts.fullScreen ) {
				$container = instance.$refs.container;

				$container.on('click.fb-fullscreen', '[data-fancybox-fullscreen]', function(e) {

					e.stopPropagation();
					e.preventDefault();

					FullScreen.toggle( $container[ 0 ] );

				});

				if ( instance.opts.fullScreen && instance.opts.fullScreen.autoStart === true ) {
					FullScreen.request( $container[ 0 ] );
				}

				// Expose API
				instance.FullScreen = FullScreen;

			} else if ( instance ) {
				instance.$refs.toolbar.find('[data-fancybox-fullscreen]').hide();
			}

		},

		'afterKeydown.fb' : function(e, instance, current, keypress, keycode) {

			// "P" or Spacebar
			if ( instance && instance.FullScreen && keycode === 70 ) {
				keypress.preventDefault();

				instance.FullScreen.toggle( instance.$refs.container[ 0 ] );
			}

		},

		'beforeClose.fb' : function( instance ) {
			if ( instance && instance.FullScreen ) {
				FullScreen.exit();
			}
		}
	});

	$(document).on(fn.fullscreenchange, function() {
		var isFullscreen = FullScreen.isFullscreen(),
			instance = $.fancybox.getInstance();

		if ( instance ) {

			// If image is zooming, then force to stop and reposition properly
			if ( instance.current && instance.current.type === 'image' && instance.isAnimating ) {
				instance.current.$content.css( 'transition', 'none' );

				instance.isAnimating = false;

				instance.update( true, true, 0 );
			}

			instance.trigger( 'onFullscreenChange', isFullscreen );

			instance.$refs.container.toggleClass( 'fancybox-is-fullscreen', isFullscreen );
		}

	});

}( document, window.jQuery || jQuery ));

// ==========================================================================
//
// Thumbs
// Displays thumbnails in a grid
//
// ==========================================================================
;(function (document, $) {
	'use strict';

	// Make sure there are default values
	$.fancybox.defaults = $.extend(true, {
		btnTpl : {
			thumbs :
			'<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}">' +
				'<svg viewBox="0 0 120 120">' +
					'<path d="M30,30 h14 v14 h-14 Z M50,30 h14 v14 h-14 Z M70,30 h14 v14 h-14 Z M30,50 h14 v14 h-14 Z M50,50 h14 v14 h-14 Z M70,50 h14 v14 h-14 Z M30,70 h14 v14 h-14 Z M50,70 h14 v14 h-14 Z M70,70 h14 v14 h-14 Z" />' +
				'</svg>' +
			'</button>'
		},
		thumbs : {
			autoStart   : false,                  // Display thumbnails on opening
			hideOnClose : true,                   // Hide thumbnail grid when closing animation starts
			parentEl    : '.fancybox-container',  // Container is injected into this element
			axis        : 'y'                     // Vertical (y) or horizontal (x) scrolling
		}
	}, $.fancybox.defaults);

	var FancyThumbs = function( instance ) {
		this.init( instance );
	};

	$.extend( FancyThumbs.prototype, {

		$button		: null,
		$grid		: null,
		$list		: null,
		isVisible	: false,
		isActive	: false,

		init : function( instance ) {
			var self = this;

			self.instance = instance;

			instance.Thumbs = self;

			// Enable thumbs if at least two group items have thumbnails
			var first  = instance.group[0],
				second = instance.group[1];

			self.opts = instance.group[ instance.currIndex ].opts.thumbs;

			self.$button = instance.$refs.toolbar.find( '[data-fancybox-thumbs]' );

			if ( self.opts && first && second && (
		    		( first.type == 'image'  || first.opts.thumb  || first.opts.$thumb ) &&
		    		( second.type == 'image' || second.opts.thumb || second.opts.$thumb )
			)) {

				self.$button.show().on('click', function() {
					self.toggle();
				});

				self.isActive = true;

			} else {
				self.$button.hide();
			}
		},

		create : function() {
			var self = this,
				instance = self.instance,
				parentEl = self.opts.parentEl,
				list,
				src;

			self.$grid = $('<div class="fancybox-thumbs fancybox-thumbs-' + self.opts.axis + '"></div>').appendTo( instance.$refs.container.find( parentEl ).addBack().filter( parentEl ) );

			// Build list HTML
			list = '<ul>';

			$.each(instance.group, function( i, item ) {
				src = item.opts.thumb || ( item.opts.$thumb ? item.opts.$thumb.attr( 'src' ) : null );

				if ( !src && item.type === 'image' ) {
					src = item.src;
				}

				if ( src && src.length ) {
					list += '<li data-index="' + i + '"  tabindex="0" class="fancybox-thumbs-loading"><img data-src="' + src + '" /></li>';
				}
			});

			list += '</ul>';

			self.$list = $( list ).appendTo( self.$grid ).on('click', 'li', function() {
				instance.jumpTo( $(this).data('index') );
			});

			self.$list.find( 'img' ).hide().one('load', function() {
				var $parent		= $(this).parent().removeClass( 'fancybox-thumbs-loading' ),
					thumbWidth	= $parent.outerWidth(),
					thumbHeight	= $parent.outerHeight(),
					width,
					height,
					widthRatio,
					heightRatio;

				width  = this.naturalWidth	|| this.width;
				height = this.naturalHeight	|| this.height;

				// Calculate thumbnail dimensions; center vertically and horizontally
				widthRatio  = width  / thumbWidth;
				heightRatio = height / thumbHeight;

				if (widthRatio >= 1 && heightRatio >= 1) {
					if (widthRatio > heightRatio) {
						width  = width / heightRatio;
						height = thumbHeight;

					} else {
						width  = thumbWidth;
						height = height / widthRatio;
					}
				}

				$(this).css({
					width         : Math.floor(width),
					height        : Math.floor(height),
					'margin-top'  : height > thumbHeight ? ( Math.floor(thumbHeight * 0.3 - height * 0.3 ) ) : Math.floor(thumbHeight * 0.5 - height * 0.5 ),
					'margin-left' : Math.floor(thumbWidth * 0.5 - width * 0.5 )
				}).show();

			})
			.each(function() {
				this.src = $( this ).data( 'src' );
			});

			if ( self.opts.axis === 'x' ) {
				self.$list.width( parseInt( self.$grid.css("padding-right") ) + ( instance.group.length * self.$list.children().eq(0).outerWidth(true) ) + 'px' );
			}
		},

		focus : function( duration ) {
			var self = this,
				$list = self.$list,
				thumb,
				thumbPos;

			if ( self.instance.current ) {
				thumb = $list.children()
					.removeClass( 'fancybox-thumbs-active' )
					.filter('[data-index="' + self.instance.current.index  + '"]')
					.addClass('fancybox-thumbs-active');

				thumbPos = thumb.position();

				// Check if need to scroll to make current thumb visible
				if ( self.opts.axis === 'y' && ( thumbPos.top < 0 || thumbPos.top > ( $list.height() - thumb.outerHeight() ) ) ) {
					$list.stop().animate({ 'scrollTop' : $list.scrollTop() + thumbPos.top }, duration);

				} else if ( self.opts.axis === 'x' && (
						thumbPos.left < $list.parent().scrollLeft() ||
						thumbPos.left > ( $list.parent().scrollLeft() + ( $list.parent().width() - thumb.outerWidth() ) )
					)
				) {
					$list.parent().stop().animate({ 'scrollLeft' : thumbPos.left }, duration);
				}
			}
		},

		update : function() {
			this.instance.$refs.container.toggleClass( 'fancybox-show-thumbs', this.isVisible );

			if ( this.isVisible ) {
				if ( !this.$grid ) {
					this.create();
				}

				this.instance.trigger( 'onThumbsShow' );

				this.focus( 0 );

			} else if ( this.$grid ) {
				this.instance.trigger( 'onThumbsHide' );
			}

			// Update content position
			this.instance.update();
		},

		hide : function() {
			this.isVisible = false;
			this.update();
		},

		show : function() {
			this.isVisible = true;
			this.update();
		},

		toggle : function() {
			this.isVisible = !this.isVisible;
			this.update();
		}
	});

	$(document).on({

		'onInit.fb' : function(e, instance) {
			var Thumbs;

			if ( instance && !instance.Thumbs ) {
				Thumbs = new FancyThumbs( instance );

				if ( Thumbs.isActive && Thumbs.opts.autoStart === true ) {
					Thumbs.show();
				}
			}
		},

		'beforeShow.fb' : function(e, instance, item, firstRun) {
			var Thumbs = instance && instance.Thumbs;

			if ( Thumbs && Thumbs.isVisible ) {
				Thumbs.focus( firstRun ? 0 : 250 );
			}
		},

		'afterKeydown.fb' : function(e, instance, current, keypress, keycode) {
			var Thumbs = instance && instance.Thumbs;

			// "G"
			if ( Thumbs && Thumbs.isActive && keycode === 71 ) {
				keypress.preventDefault();

				Thumbs.toggle();
			}
		},

		'beforeClose.fb' : function( e, instance ) {
			var Thumbs = instance && instance.Thumbs;

			if ( Thumbs && Thumbs.isVisible && Thumbs.opts.hideOnClose !== false ) {
				Thumbs.$grid.hide();
			}
		}

	});

}(document, window.jQuery));

//// ==========================================================================
//
// Share
// Displays simple form for sharing current url
//
// ==========================================================================
;(function (document, $) {
	'use strict';

	$.extend(true, $.fancybox.defaults, {
		btnTpl : {
			share :
				'<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}">' +
					'<svg viewBox="0 0 40 40">' +
						'<path d="M6,30 C8,18 19,16 23,16 L23,16 L23,10 L33,20 L23,29 L23,24 C19,24 8,27 6,30 Z">' +
					'</svg>' +
				'</button>'
		},
		share : {
			tpl :
				'<div class="fancybox-share">' +
					'<h1>{{SHARE}}</h1>' +
					'<p class="fancybox-share__links">' +
						'<a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}">' +
							'<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg>' +
							'<span>Facebook</span>' +
						'</a>' +
						'<a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}">' +
							'<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg>' +
							'<span>Pinterest</span>' +
						'</a>' +
						'<a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}">' +
							'<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg>' +
							'<span>Twitter</span>' +
						'</a>' +
					'</p>' +
					'<p><input class="fancybox-share__input" type="text" value="{{url_raw}}" /></p>' +
				'</div>'
		}
	});

	function escapeHtml(string) {
		var entityMap = {
		  '&': '&amp;',
		  '<': '&lt;',
		  '>': '&gt;',
		  '"': '&quot;',
		  "'": '&#39;',
		  '/': '&#x2F;',
		  '`': '&#x60;',
		  '=': '&#x3D;'
		};

		return String(string).replace(/[&<>"'`=\/]/g, function (s) {
			return entityMap[s];
		});
	}

	$(document).on('click', '[data-fancybox-share]', function() {
		var f = $.fancybox.getInstance(),
			url,
			tpl;

		if ( f ) {
			url = f.current.opts.hash === false ? f.current.src : window.location;
			tpl = f.current.opts.share.tpl
					.replace( /\{\{media\}\}/g, f.current.type === 'image' ? encodeURIComponent( f.current.src ) : '' )
					.replace( /\{\{url\}\}/g, encodeURIComponent( url ) )
					.replace( /\{\{url_raw\}\}/g, escapeHtml( url ) )
					.replace( /\{\{descr\}\}/g, f.$caption ? encodeURIComponent( f.$caption.text() ) : '' );

			$.fancybox.open({
				src  : f.translate( f, tpl ),
				type : 'html',
				opts : {
					animationEffect   : "fade",
					animationDuration : 250,
					afterLoad : function(instance, current) {
						// Opening links in a popup window
						current.$content.find('.fancybox-share__links a').click(function() {
					        window.open(this.href, "Share", "width=550, height=450");
					        return false;
						});
					}
				}
			});
		}

	});

}( document, window.jQuery || jQuery ));

// ==========================================================================
//
// Hash
// Enables linking to each modal
//
// ==========================================================================
;(function (document, window, $) {
	'use strict';

	// Simple $.escapeSelector polyfill (for jQuery prior v3)
	if ( !$.escapeSelector ) {
		$.escapeSelector = function( sel ) {
			var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
			var fcssescape = function( ch, asCodePoint ) {
				if ( asCodePoint ) {
					// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
					if ( ch === "\0" ) {
						return "\uFFFD";
					}

					// Control characters and (dependent upon position) numbers get escaped as code points
					return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
				}

				// Other potentially-special ASCII characters get backslash-escaped
				return "\\" + ch;
			};

			return ( sel + "" ).replace( rcssescape, fcssescape );
		};
	}

	// Create new history entry only once
	var shouldCreateHistory = true;

	// Variable containing last hash value set by fancyBox
	// It will be used to determine if fancyBox needs to close after hash change is detected
    var currentHash = null;

	// Throttling the history change
	var timerID = null;

	// Get info about gallery name and current index from url
    function parseUrl() {
        var hash    = window.location.hash.substr( 1 );
        var rez     = hash.split( '-' );
        var index   = rez.length > 1 && /^\+?\d+$/.test( rez[ rez.length - 1 ] ) ? parseInt( rez.pop( -1 ), 10 ) || 1 : 1;
        var gallery = rez.join( '-' );

		// Index is starting from 1
		if ( index < 1 ) {
			index = 1;
		}

        return {
            hash    : hash,
            index   : index,
            gallery : gallery
        };
    }

	// Trigger click evnt on links to open new fancyBox instance
	function triggerFromUrl( url ) {
		var $el;

        if ( url.gallery !== '' ) {

			// If we can find element matching 'data-fancybox' atribute, then trigger click event for that ..
			$el = $( "[data-fancybox='" + $.escapeSelector( url.gallery ) + "']" ).eq( url.index - 1 );

            if ( !$el.length ) {
				// .. if not, try finding element by ID
				$el = $( "#" + $.escapeSelector( url.gallery ) + "" );
			}

			if ( $el.length ) {
				shouldCreateHistory = false;

				$el.trigger( 'click' );
			}

        }
	}

	// Get gallery name from current instance
	function getGalleryID( instance ) {
		var opts;

		if ( !instance ) {
			return false;
		}

		opts = instance.current ? instance.current.opts : instance.opts;

		return opts.hash || ( opts.$orig ? opts.$orig.data( 'fancybox' ) : ''  );
	}

	// Start when DOM becomes ready
    $(function() {

		// Check if user has disabled this module
		if ( $.fancybox.defaults.hash === false ) {
			return;
		}

		// Update hash when opening/closing fancyBox
	    $(document).on({
			'onInit.fb' : function( e, instance ) {
				var url, gallery;

				if ( instance.group[ instance.currIndex ].opts.hash === false ) {
					return;
				}

				url     = parseUrl();
				gallery = getGalleryID( instance );

				// Make sure gallery start index matches index from hash
				if ( gallery && url.gallery && gallery == url.gallery ) {
					instance.currIndex = url.index - 1;
				}
			},

			'beforeShow.fb' : function( e, instance, current ) {
				var gallery;

				if ( !current || current.opts.hash === false ) {
					return;
				}

	            gallery = getGalleryID( instance );

	            // Update window hash
	            if ( gallery && gallery !== '' ) {

					if ( window.location.hash.indexOf( gallery ) < 0 ) {
		                instance.opts.origHash = window.location.hash;
		            }

					currentHash = gallery + ( instance.group.length > 1 ? '-' + ( current.index + 1 ) : '' );

					if ( 'replaceState' in window.history ) {
						if ( timerID ) {
							clearTimeout( timerID );
						}

						timerID = setTimeout(function() {
							window.history[ shouldCreateHistory ? 'pushState' : 'replaceState' ]( {} , document.title, window.location.pathname + window.location.search + '#' +  currentHash );

							timerID = null;

							shouldCreateHistory = false;

						}, 300);

					} else {
						window.location.hash = currentHash;
					}

	            }

	        },

			'beforeClose.fb' : function( e, instance, current ) {
				var gallery, origHash;

				if ( timerID ) {
					clearTimeout( timerID );
				}

				if ( current.opts.hash === false ) {
					return;
				}

				gallery  = getGalleryID( instance );
				origHash = instance && instance.opts.origHash ? instance.opts.origHash : '';

	            // Remove hash from location bar
	            if ( gallery && gallery !== '' ) {

	                if ( 'replaceState' in history ) {
						window.history.replaceState( {} , document.title, window.location.pathname + window.location.search + origHash );

	                } else {
						window.location.hash = origHash;

						// Keep original scroll position
						$( window ).scrollTop( instance.scrollTop ).scrollLeft( instance.scrollLeft );
	                }
	            }

				currentHash = null;
	        }
	    });

		// Check if need to close after url has changed
		$(window).on('hashchange.fb', function() {
			var url = parseUrl();

			if ( $.fancybox.getInstance() ) {
				if ( currentHash && currentHash !== url.gallery + '-' + url.index && !( url.index === 1 && currentHash == url.gallery ) ) {
					currentHash = null;

					$.fancybox.close();
				}

			} else if ( url.gallery !== '' ) {
				triggerFromUrl( url );
			}
		});

		// Check current hash and trigger click event on matching element to start fancyBox, if needed
		setTimeout(function() {
			triggerFromUrl( parseUrl() );
		}, 50);
    });

}( document, window, window.jQuery || jQuery ));

;(function (document, $) {
	'use strict';

	var prevTime = new Date().getTime();

    $(document).on({
        'onInit.fb' : function( e, instance, current ) {
			instance.$refs.stage.on('mousewheel DOMMouseScroll wheel MozMousePixelScroll', function(e) {
				var current  = instance.current,
					currTime = new Date().getTime();

				if ( instance.group.length < 1 || current.opts.wheel === false || ( current.opts.wheel === 'auto' && current.type !== 'image' ) ) {
					return;
				}

				e.preventDefault();
				e.stopPropagation();

				if ( current.$slide.hasClass( 'fancybox-animated' ) ) {
					return;
				}

				e = e.originalEvent || e;

				if ( currTime - prevTime < 250 ) {
					return;
				}

				prevTime = currTime;

				instance[ ( -e.deltaY || -e.deltaX || e.wheelDelta || -e.detail ) < 0 ? 'next' : 'previous' ]();

			});
		}
    });

}( document, window.jQuery || jQuery ));


/***/ }),

/***/ "HH+/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("oN+n")(__webpack_require__("q/mW"))

/***/ }),

/***/ "J9kM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blocks_last_comments_lastcomments__ = __webpack_require__("mvuq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_globals__ = __webpack_require__("TxBK");




function init() {
    __WEBPACK_IMPORTED_MODULE_1__blocks_last_comments_lastcomments__["a" /* init */]({
        heightTarget: '#blogContent',
        commentsType: 'blog'
    });

    var toggleFilterClear = function toggleFilterClear() {
        var filtered = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sortSelect').val() !== 'add_date' || __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shopSearch').val() || __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.category-filter-item:checked').length > 0;

        if (filtered) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.filter-clear-wrapper').show();
        } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.filter-clear-wrapper').hide();
        }
    };

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sortSelect').change(function (e) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.cookie('blog_sort_by', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val(), { expires: 365, path: '/' });

        toggleFilterClear();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('reloadSales');
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#filterSelect').change(function (e) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.cookie('blog_date_filter', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val(), { expires: 365, path: '/' });

        toggleFilterClear();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('reloadSales');
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shopSearch').on('keyup paste', function (e) {
        toggleFilterClear();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('reloadSales');
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.category-filter-item-wrapper').click(function (e) {
        e.preventDefault();
        var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        var $checkBox = $this.find('.category-filter-item');

        var category = $checkBox.data('slug');
        var checked = !$this.hasClass('current-cat');

        var blogType = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_globals__["a" /* globals */])('blogType');
        if (blogType != 'sale_new') {
            // just go to new location
            if (checked) {
                var blogUrl = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_globals__["a" /* globals */])('blogUrl');
                location.href = blogUrl + '/category/' + category;
            }
            return;
        }

        var categories = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.cookie('blog_categories_filter');

        $checkBox.prop('checked', checked);
        $this.toggleClass('current-cat', checked);

        if (categories === undefined) {
            categories = [];
        } else {
            categories = categories.split(',');
        }

        var arrIndex = categories.indexOf(category);
        if (checked && arrIndex === -1) {
            categories.push(category);
        } else if (!checked && arrIndex !== -1) {
            categories.splice(arrIndex, 1);
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.cookie('blog_categories_filter', categories.join(','), { path: '/' });

        toggleFilterClear();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('reloadSales');
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.filter-clear').click(function (e) {
        e.preventDefault();

        //Clear cookies
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.removeCookie('blog_sort_by', { path: '/' });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.removeCookie('blog_categories_filter', { path: '/' });

        var blogType = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_globals__["a" /* globals */])('blogType');
        if (blogType === 'sale_new') {
            //Clear elements
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sortSelect').val('add_date').trigger('chosen:updated');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shopSearch').val('');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.category-filter-item').prop('checked', false);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.category-filter-item-wrapper').toggleClass('current-cat', false);

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.filter-clear-wrapper').hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('reloadSales');
        } else {
            window.location = '/articles';
        }
    });
}

/***/ }),

/***/ "Jkdx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (immutable) */ __webpack_exports__["categoriesCrop"] = categoriesCrop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar__ = __webpack_require__("J9kM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pagecomments__ = __webpack_require__("NdAU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_model_salemodel__ = __webpack_require__("ZLxd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_adminpanel__ = __webpack_require__("lNzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_adaptivefontsize__ = __webpack_require__("9Aqb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_adaptivefontsize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lib_adaptivefontsize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_utils_logger__ = __webpack_require__("5wqq");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var logger = Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_logger__["a" /* newLogger */])('Sale page');

function init(options) {
	var o = _extends({
		page: {},
		comments: []
	}, options);

	logger.log('init', o);

	initPage(o.page);
	__WEBPACK_IMPORTED_MODULE_1__pagecomments__["a" /* init */]({ page: o.page, comments: o.comments });
	setTimeout(__WEBPACK_IMPORTED_MODULE_0__sidebar__["a" /* init */]);
	categoriesCrop($('#saleWrapper .sale-cats'));
	setTimeout(initFontScale);

	Object(__WEBPACK_IMPORTED_MODULE_3__common_adminpanel__["a" /* initSaleAdminPanel */])('#wrapAdminPanel');
}

function initPage(page) {
	var model = new SalePage(page);
	ko.applyBindings(model, $("#page_content")[0]);
}

function initFontScale() {
	$('#saleWrapper').find('.sale-name-inner').adaptiveFontSize({
		done: function done(el) {
			$(el).parent().css('opacity', 1);
		}
	});
}

var SalePage = function (_SaleModel) {
	_inherits(SalePage, _SaleModel);

	function SalePage(item) {
		_classCallCheck(this, SalePage);

		var _this = _possibleConstructorReturn(this, (SalePage.__proto__ || Object.getPrototypeOf(SalePage)).call(this, item));

		$(document).on('reloadSales', function () {
			location.href = '/sale';
		});
		return _this;
	}

	return SalePage;
}(__WEBPACK_IMPORTED_MODULE_2__common_model_salemodel__["a" /* SaleModel */]);

function categoriesCrop($container) {
	var $list = $container.find('.cats-list');
	while ($container.innerWidth() < $list.innerWidth()) {
		$list.find('li').last().remove();
	}
	$container.css('opacity', '1');
}

/***/ }),

/***/ "NKwv":
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ "NdAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__newcomment__ = __webpack_require__("QWJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pagecomments__ = __webpack_require__("Oqlb");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function init(options) {
    var o = _extends({
        page: {},
        comments: []
    }, options);

    var commentsModel = __WEBPACK_IMPORTED_MODULE_1__pagecomments__["a" /* init */](o.comments);
    __WEBPACK_IMPORTED_MODULE_0__newcomment__["a" /* init */](o.page, commentsModel);
}

/***/ }),

/***/ "Oqlb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 *
 * @param {Array} comments
 * @return {PageCommentsViewModel}
 */
function init(comments) {
    var model = new PageCommentsViewModel(comments);

    ko.applyBindings(model, __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#page_comments_wrapper')[0]);
    model.postInit();

    return model;
}

var PageCommentsViewModel = function () {
    function PageCommentsViewModel(comments) {
        var _this = this;

        _classCallCheck(this, PageCommentsViewModel);

        this._$wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#page_comments_wrapper');
        this._scroll = null;
        this.comments = null;

        this.comments = new ko.observableArray(comments);
        this._scroll = this._$wrapper.zInfiniteScroll({
            selector: '.comment',
            checkViewport: false,
            enabled: true,
            autoStart: false,
            maxAutoloadPages: 100,
            loading: '#page_comments_scroll_loader',
            fetch: function fetch(page, callback) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(_this._$wrapper.data('load-url'), {
                    page: page,
                    blog_page_id: _this._$wrapper.data('page-id'),
                    raw: 1
                }, function (response) {
                    callback(response.comments);
                }, 'json');
            },
            show: function show(items) {
                for (var i = 0; i < items.length; i++) {
                    _this.comments.push(items[i]);
                }

                return items.length;
            }
        });
    }

    _createClass(PageCommentsViewModel, [{
        key: 'afterRender',
        value: function afterRender(elements, data) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elements).find('.comment-text-container').urlconverter(30);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('heightTargetUpdated');
        }
    }, {
        key: 'postInit',
        value: function postInit() {
            this._scroll.on();
        }
    }]);

    return PageCommentsViewModel;
}();

/***/ }),

/***/ "PtfZ":
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__("/Q8n");
var delegate = __webpack_require__("wYtf");

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ "Q4Fy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QWJR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_knockout__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 *
 * @param {object} page
 * @param {PageCommentsViewModel} commentsModel
 * @return {newComment}
 */
function init(page, commentsModel) {
    var model = new newComment(page.page_id, commentsModel);
    __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.applyBindings(model, __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#comment_add_wrap')[0]);
    return model;
}

var newComment = function () {
    function newComment(pageId, commentsModel) {
        var _this = this;

        _classCallCheck(this, newComment);

        this.pageId = null;
        this.commentsModel = null;
        this.text = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable('');
        this.progress = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);
        this.valid = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.computed(function () {
            return _this.text().replace(' ', '').length > 0 && !_this.progress();
        });

        this.pageId = pageId;
        this.commentsModel = commentsModel;
    }

    _createClass(newComment, [{
        key: 'save',
        value: function save(model, event) {
            var _this2 = this;

            var userId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            if (USER_ID || userId) {
                this.progress(true);

                var data = {
                    comments_page_id: this.pageId,
                    comments_content: this.text()
                };
                if (this.commentsModel.comments().length > 0) {
                    data.after_date = this.commentsModel.comments()[0].comments_date;
                }
                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(site_url('blog/comments_save'), data, function (response) {
                    if (response.success) {
                        _this2.text('');
                        for (var i = response.comments.length - 1; i >= 0; i--) {
                            _this2.commentsModel.comments.unshift(response.comments[i]);
                        }
                    } else if (response.message !== undefined) {
                        zde.notifier.error(response.message);
                    }
                    _this2.progress(false);
                }, 'json');
            } else {
                zde.showLogin(function (data) {
                    if (data) {
                        _this2.save(model, event, data.id);
                        return;
                    }
                });
            }
        }
    }]);

    return newComment;
}();

/***/ }),

/***/ "TQCA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_cookie_jquery_cookie__ = __webpack_require__("TvIv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_cookie_jquery_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vendor_cookie_jquery_cookie__);


/***/ }),

/***/ "TvIv":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("oN+n")(__webpack_require__("i4G7"))

/***/ }),

/***/ "TxBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = globals;
/* harmony export (immutable) */ __webpack_exports__["b"] = phrases;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var__ = __webpack_require__("dTkA");


var _globals = {};
var _phrases = {};

/**
 * Returns Globals object
 * @param {string|null} key Optional key to return
 * @param {*} defaultValue Default value for key
 * @return {object|*} Globals object if no key is provided, otherwise associated value
 */
function globals() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var g = window.globals || _globals;
  return key !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__var__["e" /* element */])(g, key, defaultValue) : g;
}

/**
 * Returns global Phrases object
 * @param {string|null} key Optional key to return
 * @param {*} defaultValue Default value for key
 * @return {object} Phrases object if no key is provided, otherwise associated value
 */
function phrases() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var g = globals('phrases') || _phrases;
  return key !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__var__["e" /* element */])(g, key, defaultValue) : g;
}

/***/ }),

/***/ "WO3R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar_index__ = __webpack_require__("J9kM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_model_salemodel__ = __webpack_require__("ZLxd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_adminpanel__ = __webpack_require__("lNzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_adaptivefontsize__ = __webpack_require__("9Aqb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_adaptivefontsize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lib_adaptivefontsize__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






/**
 *
 * @param {object} options
 */
function init(options) {
    var o = _extends({
        pages: []
    }, options);

    __WEBPACK_IMPORTED_MODULE_0__sidebar_index__["a" /* init */]({
        heightTarget: '#salesWrapper'
    });

    initCustomSelect();
    initList(o.pages);
    Object(__WEBPACK_IMPORTED_MODULE_2__common_adminpanel__["b" /* initSaleAdminPanelForList */])('#salesWrapper', '.admin-area');
}

function initCustomSelect() {
    $('.sort-wrapper').find('select[rel=chosen]').chosen();
}

function initList(pages) {
    var model = new ListViewModel(pages, function (element) {
        $(element).find('.sale-name-inner').adaptiveFontSize({
            done: function done(el) {
                $(el).parent().css('opacity', 1);
            }
        });
        setTimeout(function () {
            // update last comments in sidebar
            $(document).trigger('heightTargetUpdated');
        });
    });

    ko.applyBindings(model, $('#salesWrapper')[0]);
    model.postInit();

    return model;
}

var ListViewModel = function () {

    /**
     *
     * @param {object[]} pages
     * @param {function} itemsLoadedCallback Called for each rendered item, accepts DOM Element as parameter
     */
    function ListViewModel(pages) {
        var _this = this;

        var itemsLoadedCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, ListViewModel);

        this._$wrapper = $('.sales-wrapper');
        this._itemsLoadedCallback = null;
        this._scroll = null;
        this.pages = new ko.observableArray();

        this.afterRender = function (element, data) {
            if ($.isFunction(_this._itemsLoadedCallback)) {
                var $item = $(element).filter('.sale-item');
                setTimeout(function () {
                    _this._itemsLoadedCallback($item[0]);
                });
            }
        };

        var SEEN_ARRAY_KEY = 'blog_sale_seen';
        var SEEN_ARRAY_MAX_LENGTH = 200;

        var seenArray = null;

        var readSeenArray = function readSeenArray() {
            var valueStored = localStorage.getItem(SEEN_ARRAY_KEY);
            try {
                seenArray = valueStored !== null ? JSON.parse(valueStored) : [];
            } catch (e) {
                seenArray = [];
            }
        };

        var writeSeenArray = function writeSeenArray() {
            if (seenArray.length > SEEN_ARRAY_MAX_LENGTH) {
                seenArray = seenArray.slice(0, SEEN_ARRAY_MAX_LENGTH);
            }
            localStorage.setItem(SEEN_ARRAY_KEY, JSON.stringify(seenArray));
        };

        this._itemsLoadedCallback = itemsLoadedCallback;

        readSeenArray();
        pages.forEach(function (item) {
            _this.pages.push(new SaleItem(item, seenArray));
        });
        writeSeenArray();

        this._scroll = this._$wrapper.zInfiniteScroll({
            selector: '.sale-item',
            checkViewport: false,
            enabled: true,
            autoStart: false,
            maxAutoloadPages: 100,
            getCurrentCount: function getCurrentCount() {
                return _this.pages().length;
            },
            totalCount: this._$wrapper.data('count'),
            countPerPage: this._$wrapper.data('count-per-page'),
            loading: '#pagesScrollLoader',
            fetch: function fetch(page, callback) {
                $.get(_this._$wrapper.data('load-url'), {
                    page: page,
                    type: _this._$wrapper.data('blog-type'),
                    category: $('.category-filter-item:checked').map(function () {
                        return $(this).data('slug');
                    }).get().join(','),
                    blog_sort_by: $('#sortSelect').val(),
                    blog_shop_filter: $('#shopSearch').val(),
                    blog_date_filter: $('#filterSelect').val()
                }, function (response) {
                    if (response.archiveCount !== undefined) {
                        $('#archiveButtonCounter').text(response.archiveCount);
                    }
                    callback(response.pages);
                }, 'json');
            },
            clear: function clear() {
                _this.pages.removeAll();
            },
            show: function show(items) {
                readSeenArray();
                items.forEach(function (item) {
                    _this.pages.push(new SaleItem(item, seenArray));
                });
                writeSeenArray();
                return items.length;
            },
            finished: function finished() {
                $('#archiveButton').css('display', 'inline-block');
            }
        });

        $(document).on('reloadSales', function () {
            $('#archiveButton').hide();
            _this._scroll.reload();
        });
    }

    /**
     *
     * @param {Element} element
     * @param {SaleItem} data
     */


    _createClass(ListViewModel, [{
        key: "postInit",
        value: function postInit() {
            this._scroll.on();
        }
    }]);

    return ListViewModel;
}();

var SaleItem = function (_SaleModel) {
    _inherits(SaleItem, _SaleModel);

    function SaleItem(item, seenArray) {
        _classCallCheck(this, SaleItem);

        var _this2 = _possibleConstructorReturn(this, (SaleItem.__proto__ || Object.getPrototypeOf(SaleItem)).call(this, item));

        _this2.multicolumn = _this2.details_type == 'multicolumn';
        _this2.seen = seenArray.indexOf(_this2.page_id) != -1;

        if (!_this2.seen) {
            seenArray.unshift(_this2.page_id);
        }

        if (_this2.discount_code) {
            _this2.discount_code = "\u0421\u043A\u0438\u0434\u043E\u0447\u043D\u044B\u0439 \u043A\u043E\u0434: " + _this2.discount_code;
        }

        _this2.isPureImageBanner = _this2.isImageBanner && !_this2.details_content_columns.length;
        return _this2;
    }

    return SaleItem;
}(__WEBPACK_IMPORTED_MODULE_1__common_model_salemodel__["a" /* SaleModel */]);

/***/ }),

/***/ "X0GP":
/***/ (function(module, exports) {

module.exports = _;

/***/ }),

/***/ "XRua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildUrl */
/* harmony export (immutable) */ __webpack_exports__["c"] = buildQuery;
/* harmony export (immutable) */ __webpack_exports__["a"] = addQuery;
/* harmony export (immutable) */ __webpack_exports__["b"] = appendQuery;
/* unused harmony export query */
/* unused harmony export hashQuery */
/* harmony export (immutable) */ __webpack_exports__["d"] = decodeQueryString;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This script adds some additional methods to window.location
 *  buildQuery      Helper method for constricting query strings
 *  query           location.query manipulator
 *  hashQuery       location.hash manipulator
 */

var location = window.location;

function buildUrl(pathname, queryString) {
	if (!queryString) {
		return pathname;
	}
	queryString = '' + queryString;
	if (!queryString.startsWith('?')) {
		queryString = '?' + queryString;
	}
	return pathname + queryString;
}

/**
 * Builds query string from given object
 * @param {object} queryData
 * @param {boolean} [numeric_prefix]
 * @return {string}
 */
function buildQuery(queryData, numeric_prefix) {
	var value = void 0,
	    key = void 0,
	    tmp = [];
	var arg_separator = "&";

	for (key in queryData) {
		if (!queryData.hasOwnProperty(key)) {
			continue;
		}
		value = queryData[key];
		if (numeric_prefix && !isNaN(key)) {
			key = String(numeric_prefix) + key;
		}
		var _query = http_build_query_helper(urlencode(key), value, arg_separator);
		if (_query !== '') {
			tmp.push(_query);
		}
	}

	return tmp.join(arg_separator);
}

/**
 * Appends given query data to given URL
 * @param {string} url
 * @param {object} queryData
 * @return {string} New url
 */
function addQuery(url, queryData) {
	var q = buildQuery(queryData);
	url = '' + url;
	var m = /^([^?#]*)(\?[^#]+)?(#.+)?$/.exec(url);
	if (!m) {
		return url + '?' + q;
	}
	return (m[1] || '') + (m[2] ? m[2] + '&' + q : '?' + q) + (m[3] || '');
}

/**
 * Appends given query data to given query string
 * @param {string} queryString
 * @param {object} queryData
 * @return {string} New query string
 */
function appendQuery(queryString, queryData) {
	var q = buildQuery(queryData);
	if (!q) {
		return queryString;
	}
	var str = '' + queryString;
	return str.length > 0 ? str + '&' + q : q;
}

/**
 * Manipulates <code>location.search</code> as an object.<br/>
 * With no arguments - returns the whole <code>location.search</code> object.<br/>
 * With only key argument - returns value for this key.<br/>
 * With key and value arguments (or only key as object) - updates <code>location.search</code> with new value
 * @param [key] The key to set. Can be an object, so the value is not needed
 * @param [value] The value to set
 * @param [extend] TRUE to extend current <code>location.search</code> object, or FALSE to replace it. Default is TRUE
 * @returns {Object|String}
 */
function query(key, value, extend) {
	return processQuery('search', key, value, extend);
}

/**
 * Manipulates <code>location.hash</code> as an object.<br/>
 * With no arguments - returns the whole <code>location.hash</code> object.<br/>
 * With only key argument - returns value for this key.<br/>
 * With key and value arguments (or only key as object) - updates <code>location.hash</code> with new value
 * @param [key] The key to set. Can be an object, so the value is not needed
 * @param [value] The value to set
 * @param [extend] TRUE to extend current <code>location.hash</code> object, or FALSE to replace it. Default is TRUE
 * @returns {Object|String}
 */
function hashQuery(key, value, extend) {
	return processQuery('hash', key, value, extend);
}

function processQuery(type, key, value, extend) {
	var queryData = decodeQueryString(location[type].substring(1));
	if (key !== undefined) {
		var isObj = (typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object';

		if (value === undefined && !isObj) {
			// return value
			return queryData[key] === undefined ? null : queryData[key];
		} else if (!isObj) {
			if (extend === undefined) extend = true;

			// set value to key
			var k = key.toString();
			key = {};
			key[k] = value;
		}

		if (extend) {
			$.extend(queryData, key);
		} else {
			queryData = key;
		}

		// clear data
		var newData = {};
		$.each(queryData, function (key, value) {
			if (value) newData[key] = value;
		});
		queryData = newData;

		location[type] = buildQuery(queryData);
	}
	return queryData;
}

/**
 * Decodes query string like 'a=one&b=two&c[]=three' and returns an object
 * @param string
 * @return {Object}
 */
function decodeQueryString(string) {
	var glue1 = '=',
	    glue2 = '&',
	    array = {},
	    // holds result
	array2 = String(string).replace(/^&?([\s\S]*?)&?$/, '$1').split(glue2),
	    i = void 0,
	    j = void 0,
	    chr = void 0,
	    tmp = void 0,
	    key = void 0,
	    value = void 0,
	    bracket = void 0,
	    keys = void 0,
	    evalStr = void 0,
	    fixStr = function fixStr(str) {
		return decodeURIComponent(str).replace(/([\\"'])/g, '\\$1').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\+/g, ' ');
	};

	for (i = 0; i < array2.length; i++) {
		tmp = array2[i].split(glue1);
		if (tmp.length < 2) {
			tmp = [tmp, ''];
		}
		key = fixStr(tmp[0]);
		value = fixStr(tmp[1]);
		while (key.charAt(0) === ' ') {
			key = key.substr(1);
		}
		if (key.indexOf('\0') !== -1) {
			key = key.substr(0, key.indexOf('\0'));
		}
		if (key && key.charAt(0) !== '[') {
			keys = [];
			bracket = 0;
			for (j = 0; j < key.length; j++) {
				if (key.charAt(j) === '[' && !bracket) {
					bracket = j + 1;
				} else if (key.charAt(j) === ']') {
					if (bracket) {
						if (!keys.length) {
							keys.push(key.substr(0, bracket - 1));
						}
						keys.push(key.substr(bracket, j - bracket));
						bracket = 0;
						if (key.charAt(j + 1) !== '[') {
							break;
						}
					}
				}
			}
			if (!keys.length) {
				keys = [key];
			}
			for (j = 0; j < keys[0].length; j++) {
				chr = keys[0].charAt(j);
				if (chr === ' ' || chr === '.' || chr === '[') {
					keys[0] = keys[0].substr(0, j) + '_' + keys[0].substr(j + 1);
				}
				if (chr === '[') {
					break;
				}
			}
			evalStr = 'array';
			for (j = 0; j < keys.length; j++) {
				key = keys[j];
				if (key !== '' && key !== ' ' || j === 0) {
					key = "'" + key + "'";
				} else {
					key = eval(evalStr + '.push([]);') - 1;
				}
				evalStr += '[' + key + ']';
				if (j !== keys.length - 1 && eval('typeof ' + evalStr) === 'undefined') {
					eval(evalStr + ' = [];');
				}
			}
			evalStr += " = '" + value + "';\n";
			eval(evalStr);
		}
	}

	return array;
}

function urlencode(str) {
	str = (str + '').toString();
	return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}

function http_build_query_helper(key, val, arg_separator) {
	var k = void 0,
	    tmp = [];
	if (val === true) {
		val = "1";
	} else if (val === false) {
		val = "0";
	}
	if (val !== null && val !== undefined && val !== '') {
		if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === "object") {
			var start = 0;
			for (k in val) {
				if (!val.hasOwnProperty(k)) {
					continue;
				}
				if (val[k] !== null) {
					var sk = void 0,
					    num = Number(k);
					if (!isNaN(num) && num - start === 0) {
						if (_typeof(val[k]) === "object") {
							sk = num;
						} else {
							sk = '';
						}
						start++;
					} else {
						sk = urlencode(k);
					}
					var part = http_build_query_helper(key + "[" + sk + "]", val[k], arg_separator);
					if (part) {
						tmp.push(part);
					}
				}
			}
			return tmp.join(arg_separator);
		} else if (typeof val !== "function") {
			return key + "=" + urlencode(val);
		} else {
			throw new Error('There was an error processing for http_build_query().');
		}
	} else {
		return '';
	}
}

/***/ }),

/***/ "XXni":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YWK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar_index__ = __webpack_require__("J9kM");


function init() {
	var $list = $('#articlesList');
	itemSizeSpot();
	__WEBPACK_IMPORTED_MODULE_0__sidebar_index__["a" /* init */]({
		heightTarget: $list
	});

	$list.zInfiniteScroll({
		selector: '[rel=page]',
		loading: '#pagesScrollLoader',
		maxAutoloadPages: 200,
		totalCount: $list.data('totalCount'),
		fetch: function fetch(page, callback) {
			var data = {
				page: page,
				type: $list.data('blogType'),
				category: $list.data('blogCategory')
			};
			$.get($list.data('loadUrl'), data, null, 'json').done(function (response) {
				var $blocks = $(response['html']).filter('[rel=page]');
				callback($blocks);
			});
		}
	});

	$(window).resize(function () {
		itemSizeSpot();
	});
}

function itemSizeSpot() {
	var $items = $('.articles-list').find('.post');
	var width = $items.find('.content').innerWidth();

	if (width > 254) {
		$items.attr('size', 'large');
	}

	if (width <= 254 && width >= 240) {
		$items.attr('size', 'medium');
	}

	if (width >= 208 && width < 240) {
		$items.attr('size', 'small');
	}
	if (width < 208) {
		$items.attr('size', 'extra-small');
	}
}

/***/ }),

/***/ "YnTO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = checkIsIframe;
/* harmony export (immutable) */ __webpack_exports__["c"] = isMobile;
/* harmony export (immutable) */ __webpack_exports__["d"] = isTouchScreen;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WEBP_FEATURES; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isWebpFeatureSupported;
/**
 * @return {boolean} TRUE if current window is an iframe window
 */
function checkIsIframe() {
	return window !== window.top;
}

var _isMobile = 'orientation' in window || navigator.userAgent.indexOf('IEMobile') !== -1;
var _isTouchScreen = 'ontouchstart' in window || navigator.msMaxTouchPoints;

function isMobile() {
	return _isMobile;
}

function isTouchScreen() {
	return _isTouchScreen;
}

var WEBP_FEATURES = {
	LOSSY: 'lossy',
	LOSSLESS: 'lossless',
	ALPHA: 'alpha',
	ANIMATION: 'animation'
};

function isWebpFeatureSupported(feature) {
	return new Promise(function (resolve, reject) {
		if (!Object.values(WEBP_FEATURES).includes(feature)) {
			reject('Invalid feature name');
			return;
		}

		var kTestImages = {
			lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
			lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
			alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
			animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
		};
		var img = new Image();
		img.onload = function () {
			var result = img.width > 0 && img.height > 0;
			resolve(result);
		};
		img.onerror = function () {
			resolve(false);
		};
		img.src = "data:image/webp;base64," + kTestImages[feature];
	});
}

/*export class MobileDetect {
	static Android = navigator.userAgent.match(/Android/i);
	static BlackBerry = navigator.userAgent.match(/BlackBerry/i);
	static iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
	static Opera = navigator.userAgent.match(/Opera Mini/i);
	static Windows = navigator.userAgent.match(/IEMobile/i);
	static Any = MobileDetect.Android || MobileDetect.BlackBerry || MobileDetect.iOS || MobileDetect.Opera || MobileDetect.Windows;
}*/

/***/ }),

/***/ "ZLxd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaleModel; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SaleModel = function () {
    function SaleModel(item) {
        _classCallCheck(this, SaleModel);

        for (var property in item) {
            if (property == 'my_like') {
                this[property] = ko.observable(item[property]);
            } else {
                this[property] = item[property];
            }
        }

        this.active = this.status == 'Активна';
        this.totalLikes = ko.observable(parseInt(this.likes_initial) + parseInt(this.likes));
        this.isTextBanner = this.banner_type == 'text';
        this.isImageBanner = this.banner_type == 'image';
    }

    _createClass(SaleModel, [{
        key: 'saveLike',
        value: function saveLike(model, event) {
            var _this = this;

            var userId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            if (USER_ID || userId) {
                $.post(base_url + 'blog/likes_save', { id: this.page_id }, function (response) {
                    if (response.success) {
                        if (response.action == 'up') {
                            _this.my_like(true);
                        } else {
                            _this.my_like(false);
                        }

                        _this.totalLikes(response.likes);
                    }
                }, 'json');
            } else {
                zde.showLogin(function (data) {
                    if (data) {
                        _this.saveLike(model, event, data.id);
                        return;
                    }
                });
            }
        }
    }]);

    return SaleModel;
}();

/***/ }),

/***/ "ZuML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openPopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popup_less__ = __webpack_require__("Q4Fy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popup_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__popup_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dialog__ = __webpack_require__("fokk");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * The same as {@link openHtmlDialog()} but with name='popup' enabled
 * @param {*} content HTML content
 * @param {object} options ZDialog options
 * @return {ZDialog} Dialog instance
 */
function openPopup(content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return Object(__WEBPACK_IMPORTED_MODULE_1__dialog__["openHtmlDialog"])(content, _extends({ name: 'popup' }, options));
}

/***/ }),

/***/ "dTkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isset */
/* harmony export (immutable) */ __webpack_exports__["e"] = element;
/* unused harmony export elementOrDefault */
/* harmony export (immutable) */ __webpack_exports__["f"] = elementOrDash;
/* harmony export (immutable) */ __webpack_exports__["g"] = orDefault;
/* harmony export (immutable) */ __webpack_exports__["c"] = asNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = asBoolean;
/* harmony export (immutable) */ __webpack_exports__["d"] = asString;
/* harmony export (immutable) */ __webpack_exports__["h"] = trim;
/* harmony export (immutable) */ __webpack_exports__["a"] = asArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);


/**
 * Is a given variable defined and has value?
 * @param {*} val
 * @return {boolean} <code>false</code> if given value is <code>undefined</code> or <code>null</code>, otherwise <code>true</code>
 */
function isset(val) {
  return !__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isUndefined(val) && !__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isNull(val);
}

/**
 * Returns object's property or array's index if exists and default value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function element(object, key) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.has(object, key) ? object[key] : defaultValue;
}

/**
 * Returns object's property or array's index if exists and is not <code>null</code> or default value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function elementOrDefault(object, key) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.has(object, key) && object[key] !== null ? object[key] : defaultValue;
}

/**
 * Returns object's property or array's index if exists and is not <code>null</code> or "&mdash;" value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function elementOrDash(object, key) {
  return elementOrDefault(object, key, '&mdash;');
}

/**
 * Returns value if it's not <code>undefined</code> or <code>null</code>, otherwise defaultValue
 * @param {*} value
 * @param {*} defaultValue
 * @return {*}
 */
function orDefault(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return isset(value) ? value : defaultValue;
}

/**
 * Converts given value to number using standard javascript converter: <code>+value</code>
 * @param {*} value Input value
 * @param {number} defaultValue
 * @return {number} Either converted value if it's not <code>NaN</code> and default value otherwise
 */
function asNumber(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  value = +value;
  return !isNaN(value) ? value : 0;
}

/**
 * Converts given value to boolean using such algo:
 * - string <code>"0"</code> results in <code>false</code>;
 * - string <code>"false"</code> results in <code>false</code>;
 * - string <code>"null"</code> results in <code>false</code>;
 * - empty object results in <code>false</code>;
 * - empty array results in <code>false</code>;
 * - other values go through standard javascript converter: <code>!!value</code>
 * @param {*} value Input value
 * @return {boolean} Converted value
 */
function asBoolean(value) {
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isBoolean(value)) return value;
  if (value === '0') return false;
  if (value === 'false') return false;
  if (value === 'null') return false;
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isObject(value) && __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(value)) return false;
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(value) && __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(value)) return false;
  return !!value;
}

/**
 * Converts given value to string using standard javascript converter: <code>''+value</code>
 * except that <code>null</code> and <code>undefined</code> values will be converted to empty string.
 * @param {*} value Input value
 * @return {string} Converted value
 */
function asString(value) {
  if (value === null || __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isUndefined(value)) return '';
  return '' + value;
}

/**
 * Converts given value to string using {@link asString()} and trims whitespace characters.
 * @param {string|*} value
 * @return {string} Converted and trimmed value
 */
function trim(value) {
  return asString(value).trim();
}

/**
 * If input value is an array - it will be returned as is.
 * In other cases input value will be converted to string and either split with given delimiter
 * or just returned as a single array element.
 * @param {array|string} value
 * @param {string} delimiter
 * @return {array}
 */
function asArray(value) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!value) return [];
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(value)) return value;
  value = asString(value);
  return delimiter ? value.split(delimiter) : [value];
}

/***/ }),

/***/ "dydC":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("oN+n")(__webpack_require__("i8fT"))

/***/ }),

/***/ "e2Zi":
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),

/***/ "ejlv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_urlconverter_jquery_urlconverter__ = __webpack_require__("dydC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_urlconverter_jquery_urlconverter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vendor_urlconverter_jquery_urlconverter__);


/***/ }),

/***/ "fokk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createIframeDialog"] = createIframeDialog;
/* harmony export (immutable) */ __webpack_exports__["createHtmlDialog"] = createHtmlDialog;
/* harmony export (immutable) */ __webpack_exports__["openHtmlDialog"] = openHtmlDialog;
/* harmony export (immutable) */ __webpack_exports__["createWindowDialog"] = createWindowDialog;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dialogManager", function() { return dialogManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_less__ = __webpack_require__("vBks");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dialog_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__("YnTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_var__ = __webpack_require__("dTkA");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var logger = Object(__WEBPACK_IMPORTED_MODULE_3__utils_logger__["a" /* newLogger */])('ZDialog');

/**
 * Creates new dialog with IFrame with given url
 * @param {string} url IFrame url
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog}
 */
function createIframeDialog(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: url, type: 'iframe', __width: 800 }, options));
}

/**
 * Creates new dialog instance.
 * autoOpen option is false by default, so you should either call open() method
 * or override autoOpen option
 * @param {*} content HTML content. Can be either valid HTML string, or DOM node, or jQuery object
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog} Dialog instance
 */
function createHtmlDialog(content) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: content, type: 'html', showCloseButton: true }, options));
}

/**
 * The same as {@link createHtmlDialog()} but with autoOpen enabled
 * @param {*} content HTML content
 * @param {object} options ZDialog options
 * @return {ZDialog} Dialog instance
 */
function openHtmlDialog(content) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return createHtmlDialog(content, _extends({ autoOpen: true }, options));
}

/**
 * Creates new dialog as new window with given url
 * @param {string} url IFrame url
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog}
 */
function createWindowDialog(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: url, type: 'window' }, options));
}

// add some helper functions to jQuery
$.extend($.fn, {
	/**
  * Calls {@link openHtmlDialog()} with source element as content
  * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
  */
	zdialog: function zdialog() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		var $el = $(this);
		var $placeholder = $('<div style="display: none !important;"></div>').insertAfter($el);
		var isInDom = $el.closest(document.documentElement);
		var isVisible = $el.css('display') != 'none';
		if (isInDom) {
			$el.detach();
		}
		if (!isVisible) {
			$el.show();
		}
		var dialog = createHtmlDialog($el, options);
		dialog.onBeforeClose(function () {
			$el.detach();
		});
		dialog.onClose(function () {
			if (isInDom) {
				$el.insertAfter($placeholder);
			}
			if (!isVisible) {
				$el.hide();
			}
			$placeholder.remove();
		});
		dialog.open();
		$el.data('zdialogInstance', dialog);
		return this;
	},

	/**
  * Returns ZDialog instance for given element (if the dialog was created with {@link jQuery.fn.zdialog} function)
  * @return {ZDialog}
  */
	zdialogInstance: function zdialogInstance() {
		return this.data('zdialogInstance');
	}
});

// FOR TESTING
/*import {MODAL_ASK_REDIRECT, MODAL_CRITICAL_NEWS, MODAL_LOGIN, MODAL_PACKAGE_INFO, MODAL_REVIEW} from "../modals";
$('.logo').click(function(e) {
	e.preventDefault();
	const queue = [];
	const showNext = () => {
		if (queue.length > 0) {
			queue.shift()();
		}
	};
	const onOpen = () => {};
	// queue.push(() => MODAL_REVIEW.show(104625).onOpen(showNext));
	// queue.push(() => MODAL_LOGIN.show().onOpen(showNext));
	// queue.push(() => MODAL_PACKAGE_INFO.show(1803110691).onOpen(showNext));
	// queue.push(() => MODAL_ASK_REDIRECT.show().onOpen(showNext));
	// queue.push(() => MODAL_CRITICAL_NEWS.show(312).onOpen(showNext));
	queue.push(() => openHtmlDialog('<div rel="show-next" style="width: 400px; height: 400px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 400px; height: 1000px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 1500px; height: 400px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 400px; height: 400px; background: red;"></div>', {fullscreen: true}).onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 2500px; height: 2500px; background: red;"></div>', {fullscreen: true}).onOpen(onOpen));
	showNext();

	$(document).on('click', '.zdialog-html > div', showNext);
});*/

/**
 * @param {object} options
 * @return {ZDialog}
 */
var newDialog = function newDialog(options) {
	return new ZDialog(options);
};

// force use newDialog function from top window
var key = '__zdialog_newDialog';
if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["b" /* checkIsIframe */])()) {
	newDialog = window.top[key];
} else {
	window.top[key] = newDialog;
}

/**
 * Dialog class
 */

var ZDialog = function () {
	/** @type {JQuery.Callbacks} */

	/** @type {JQuery.Callbacks} */

	/** @type {HeightWatcher} */
	function ZDialog(options) {
		_classCallCheck(this, ZDialog);

		this._width = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable();
		this._height = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable();
		this._isModal = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isCloseBtnVisible = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isLoading = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isOpened = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isClosed = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isHidden = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._contentHeight = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(0);
		this._iframeHeight = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(0);
		this._opened = false;
		this._onOpen = $.Callbacks();
		this._onClose = $.Callbacks();
		this._onBeforeClose = $.Callbacks();
		this._result = null;

		var o = _extends({}, ZDialog.defaults, options);

		this._name = o.name;
		this._o = o;
		this._isModal(!!o.modal);
		this._isCloseBtnVisible(!!o.showCloseButton);
		this._width(o.width);
		this._height(o.height);

		if (o.onOpen) {
			this._onOpen.add(o.onOpen);
		}
		if (o.onClose) {
			this._onClose.add(o.onClose);
		}

		if (o.autoOpen) {
			this.open();
		}
	}
	/** @type {JQuery.Callbacks} */


	// options


	_createClass(ZDialog, [{
		key: "open",
		value: function open() {
			var _this = this;

			if (this.isOpened) {
				return;
			}
			this._isClosed(false);
			this._isHidden(false);
			this._result = null;
			if (this.type === 'window') {
				this._wnd = window.open(this.content);
				this._wnd.addEventListener('DOMContentLoaded', function () {
					return _this._handleWindowReady();
				});
				this._wnd.onbeforeunload = function () {
					if (!_this.isClosed) {
						_this.close();
					}
				};
				this._isLoading(true);
			} else if (!dialogManager.isRegistered(this)) {
				if (this.isFullScreen) {
					this._width('');
					this._height('');
					this._contentHeight('');
					this._iframeHeight('');
				}
				if (this.type === 'iframe') {
					this._isLoading(true);
					if (!this.isAutoHeight) {
						this._contentHeight(this.height);
						this._iframeHeight(this.height);
					} else {
						this._contentHeight('');
					}
				} else {
					this._contentHeight(this.height);
					this._isOpened(true);
					setTimeout(function () {
						return _this._onOpen.fireWith(_this);
					}, 0);
				}
				dialogManager.register(this);
			} else if (this._isHidden()) {
				dialogManager.show(this);
			}
		}
	}, {
		key: "close",
		value: function close() {
			var _this2 = this;

			if (this.isClosed) {
				return;
			}
			this._onBeforeClose.fireWith(this, [this._result]);
			this._isOpened(false);
			this._isHidden(false);
			this._isClosed(true);
			if (this.type === 'window') {
				if (this._wnd) {
					this._wnd.close();
					window.top.focus();
					this._wnd = null;
					setTimeout(function () {
						return _this2._onClose.fireWith(_this2, [_this2._result]);
					}, 0);
				}
			} else if (dialogManager.isRegistered(this)) {
				if (this._heightWatcher) {
					this._heightWatcher.off();
				}
				dialogManager.unregister(this);
				setTimeout(function () {
					return _this2._onClose.fireWith(_this2, [_this2._result]);
				}, 0);
			}
		}
	}, {
		key: "hide",
		value: function hide() {
			if (this.type === 'window') {
				logger.error('Method is not supported for current dialog type');
			} else if (dialogManager.isRegistered(this)) {
				this._isOpened(false);
				this._isHidden(true);
				dialogManager.hide(this);
			}
		}
	}, {
		key: "closeWithResult",
		value: function closeWithResult(result) {
			this.result = result;
			this.close();
		}
	}, {
		key: "updatePosition",
		value: function updatePosition() {
			if (this.type === 'iframe') {
				this._contentHeight(this.iframeHeight);
			}
		}

		/** @return {string} */

	}, {
		key: "handleIframeLoad",
		value: function handleIframeLoad(item, e) {
			var _this3 = this;

			logger.log('loaded', e);
			this._isLoading(false);

			if (!this.isFullScreen && this.isAutoHeight) {
				this._heightWatcher = new HeightWatcher(e.target, function (newHeight) {
					logger.log("new height = " + newHeight);
					_this3._iframeHeight(newHeight);
					if (!_this3.contentHeight) {
						_this3._contentHeight(newHeight);
					}
					_this3._isOpened(true);
					setTimeout(function () {
						return _this3._onOpen.fireWith(_this3);
					}, 0);
				});
			} else {
				this._isOpened(true);
				setTimeout(function () {
					return _this3._onOpen.fireWith(_this3);
				}, 0);
			}

			// inject this instance to iframe
			e.target.contentWindow.dialogInstance = this;

			// apply special classes
			$(e.target.contentWindow.document.body).toggleClass('zdialog-layout-modal', this.isModal).toggleClass('zdialog-layout-autoheight', this.isAutoHeight).toggleClass('zdialog-layout-fullscreen', this.isFullScreen);

			// triger event inside iframe
			e.target.contentWindow.$(e.target.contentWindow.document).trigger('zdialog-shown');
		}
	}, {
		key: "_handleWindowReady",
		value: function _handleWindowReady(e) {
			var _this4 = this;

			logger.log('loaded', e);
			this._isLoading(false);
			this._isOpened(true);

			// inject this instance to iframe
			this._wnd.dialogInstance = this;
			$(this._wnd.document.body).addClass('zdialog-layout-window');

			setTimeout(function () {
				return _this4._onOpen.fireWith(_this4);
			}, 0);
		}
	}, {
		key: "handleCloseClick",
		value: function handleCloseClick(item, e) {
			var $target = $(e.target);
			if ($target.is('[data-dialog-result]')) {
				this.result = $target.data('dialogResult');
			}
			this.close();
		}
	}, {
		key: "handleBackdropClick",
		value: function handleBackdropClick() {
			if (dialogManager.isTopmost(this) && !this.isModal) {
				this.close();
			}
		}
	}, {
		key: "onOpen",
		value: function onOpen(callback) {
			this._onOpen.add(callback);
		}
	}, {
		key: "offOpen",
		value: function offOpen(callback) {
			this._onOpen.remove(callback);
		}
	}, {
		key: "onClose",
		value: function onClose(callback) {
			this._onClose.add(callback);
		}
	}, {
		key: "offClose",
		value: function offClose(callback) {
			this._onClose.remove(callback);
		}
	}, {
		key: "onBeforeClose",
		value: function onBeforeClose(callback) {
			this._onBeforeClose.add(callback);
		}
	}, {
		key: "offBeforeClose",
		value: function offBeforeClose(callback) {
			this._onBeforeClose.remove(callback);
		}
	}, {
		key: "name",
		get: function get() {
			return this._name;
		}

		/** @return {string} */

	}, {
		key: "type",
		get: function get() {
			return this._o.type;
		}

		/** @return {string} */

	}, {
		key: "content",
		get: function get() {
			return this._o.content;
		}

		/** @return {string} */

	}, {
		key: "title",
		get: function get() {
			return this._o.title;
		}

		/** @return {number} */

	}, {
		key: "width",
		get: function get() {
			return this._width();
		}

		/** @return {number|string} */

	}, {
		key: "height",
		get: function get() {
			return this._height();
		}

		/** @return {number|string} */

	}, {
		key: "minWidth",
		get: function get() {
			return this._o.minWidth;
		}

		/** @return {number|string} */

	}, {
		key: "maxWidth",
		get: function get() {
			return this._o.maxWidth;
		}

		/** @return {number|string} */

	}, {
		key: "contentWidth",
		get: function get() {
			return this._width();
		}

		/** @return {number|string} */

	}, {
		key: "contentHeight",
		get: function get() {
			return this._contentHeight();
		}

		/** @return {number} */

	}, {
		key: "iframeHeight",
		get: function get() {
			return this._iframeHeight();
		}

		/** @return {boolean} */

	}, {
		key: "isLoading",
		get: function get() {
			return this._isLoading();
		}

		/** @return {boolean} */

	}, {
		key: "isOpened",
		get: function get() {
			return this._isOpened();
		}

		/** @return {boolean} */

	}, {
		key: "isClosed",
		get: function get() {
			return this._isClosed();
		}

		/** @return {boolean} */

	}, {
		key: "isHidden",
		get: function get() {
			return this._isHidden();
		}

		/** @return {boolean} */

	}, {
		key: "isModal",
		get: function get() {
			return this._isModal();
		}

		/** @return {boolean} */

	}, {
		key: "isCloseBtnVisible",
		get: function get() {
			return this._isCloseBtnVisible();
		}

		/** @type {boolean} */

	}, {
		key: "isFullScreen",
		get: function get() {
			return this._o.fullscreen;
		}

		/** @type {boolean} */

	}, {
		key: "isAutoHeight",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_5__utils_var__["d" /* asString */])(this.height) === '' || this.height === 'auto';
		}

		/** @return {*} */

	}, {
		key: "result",
		get: function get() {
			return this._result;
		}

		/**
   * @param {*} value
   */
		,
		set: function set(value) {
			this._result = value;
		}

		/**
   * @return {*}
   */

	}, {
		key: "customData",
		get: function get() {
			return this._o.custom;
		}

		/**
   * @return {string}
   */

	}, {
		key: "cssClass",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_5__utils_var__["d" /* asString */])(this._o.cssClass);
		}
	}]);

	return ZDialog;
}();

ZDialog.defaults = {
	name: '',
	type: 'iframe', // iframe, html
	content: '',
	title: '',
	buttons: [],
	modal: false,
	autoOpen: false,
	showCloseButton: false,

	width: '',
	height: '',
	fullscreen: false,
	cssClass: '',

	custom: null,

	//events
	onOpen: null,
	onClose: null
};

var DialogManager = function () {
	/** @type {KnockoutObservableArray<ZDialog>} */
	function DialogManager() {
		var _this5 = this;

		_classCallCheck(this, DialogManager);

		this._counter = 0;
		this._dialogs = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observableArray([]);
		this._isClosing = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._initialized = false;
		this._wrapper = new WindowWrapper();

		this._$html = $('html');
		this._$body = $('body');

		this._isLoading = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.any(_this5.dialogs, function (d) {
				return d.isLoading;
			});
		});

		this._visibleDialogs = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.pureComputed(function () {
			return _this5.dialogs.filter(function (d) {
				return !d.isHidden;
			});
		});
	}

	/**
  * @param {ZDialog} dialog
  */


	_createClass(DialogManager, [{
		key: "register",
		value: function register(dialog) {
			if (this.isRegistered(dialog)) {
				return;
			}

			this._dialogs.push(dialog);
			this._checkMarkupAfterOpen();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "unregister",
		value: function unregister(dialog) {
			if (this._dialogs.remove(dialog).length === 0) {
				// nothing has been removed
				return;
			}
			this._checkMarkupAfterClose();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "hide",
		value: function hide(dialog) {
			if (this.isRegistered(dialog)) {
				this._checkMarkupAfterClose();
			}
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "show",
		value: function show(dialog) {
			if (this.isRegistered(dialog)) {
				this._checkMarkupAfterOpen();
			}
		}
	}, {
		key: "_checkMarkupAfterOpen",
		value: function _checkMarkupAfterOpen() {
			if (this._isClosing()) {
				clearTimeout(this._timeout);
				this._timeout = null;
				this._isClosing(false);
			} else if (this.visibleDialogs.length === 1 && !this._initialized) {
				this._wrapper.on();

				if (!this._$el) {
					this._$el = $("<div class=\"zdialog-wrapper\" data-bind=\"component: {name: 'zdialog-wrapper', params: $data}, \n\t\t\t\t\t\t\t\t\t\tcss: {'zdialog-loading': isLoading, 'zdialog-closing': isClosing}\"></div>");
					__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.applyBindings(this, this._$el[0]);
					this._$el.appendTo('body');
				} else {
					this._$el.show();
				}
				this._initialized = true;
			}
		}
	}, {
		key: "_checkMarkupAfterClose",
		value: function _checkMarkupAfterClose() {
			var _this6 = this;

			if (!this._isClosing() && this.visibleDialogs.length === 0 && this._initialized) {
				// no dialogs left
				this._isClosing(true);
				this._timeout = setTimeout(function () {
					_this6._wrapper.off();
					// logger.log('remove container');
					_this6._$el.remove();
					__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.cleanNode(_this6._$el[0]);
					_this6._$el = null;
					_this6._initialized = false;
					_this6._isClosing(false);
				}, 300);
			}
		}

		/**
   * @param {ZDialog} dialog
   * @return {boolean}
   */

	}, {
		key: "isRegistered",
		value: function isRegistered(dialog) {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.contains(this.dialogs, dialog);
		}
	}, {
		key: "handleBeforeRemove",
		value: function handleBeforeRemove(node) {
			var $node = $(node);
			$node.remove();
			/*if (node.nodeType === 3) {
   	$node.remove();
   	return;
   }
   $node.addClass('zdialog-closing');
   setTimeout(() => $node.remove(), 300);*/
		}

		/** @return {ZDialog[]} */

	}, {
		key: "getTopmostDialog",
		value: function getTopmostDialog() {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.last(this.visibleDialogs.filter(function (d) {
				return !d.isLoading;
			}));
		}
	}, {
		key: "isTopmost",
		value: function isTopmost(dialog) {
			return dialog === this.getTopmostDialog();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "getDialogClass",
		value: function getDialogClass(dialog) {
			var css = [];
			if (dialog.isModal) {
				css.push('zdialog-modal');
			}
			if (dialog.isFullScreen) {
				css.push('zdialog-fullscreen');
			}
			if (this.isTopmost(dialog)) {
				css.push('zdialog-topmost');
			} else if (this.visibleDialogs.length > 1) {
				css.push('zdialog-overlapped');
			}
			if (dialog.isLoading) {
				css.push('zdialog-loading');
			}
			if (dialog.isOpened) {
				css.push('zdialog-opened');
			}
			if (dialog.isHidden) {
				css.push('zdialog-hidden');
			}
			if (dialog.name) {
				css.push('zdialog-instance-' + dialog.name);
			}
			if (dialog.cssClass) {
				css.push(dialog.cssClass);
			}
			return css.join(' ');
		}
	}, {
		key: "dialogs",
		get: function get() {
			return this._dialogs();
		}

		/** @return {ZDialog[]} */

	}, {
		key: "visibleDialogs",
		get: function get() {
			return this._visibleDialogs();
		}

		/** @return {boolean} */

	}, {
		key: "isLoading",
		get: function get() {
			return this._isLoading();
		}

		/** @return {boolean} */

	}, {
		key: "isClosing",
		get: function get() {
			return this._isClosing();
		}
	}]);

	return DialogManager;
}();

var HeightWatcher = function () {
	function HeightWatcher($iframe, callback) {
		var _this7 = this;

		_classCallCheck(this, HeightWatcher);

		this._currHeight = 0;
		this._event = $.Callbacks();

		this._event.add(callback);
		this._ibody = $($iframe)[0].contentWindow.document.body;
		// this.updateHeight();
		setTimeout(function () {
			_this7.updateHeight();
			_this7._interval = setInterval(function () {
				return _this7.updateHeight();
			}, 50);
		}, 0);
	}

	_createClass(HeightWatcher, [{
		key: "updateHeight",
		value: function updateHeight() {
			// const newHeight = this._ibody.offsetHeight;
			var newHeight = this.getHeight();
			if (newHeight !== this._currHeight) {
				this._currHeight = newHeight;
				this._event.fire(newHeight);
			}
		}
	}, {
		key: "getHeight",
		value: function getHeight() {
			var height = this._ibody.scrollHeight;
			$(this._ibody).find('iframe:visible').filter(function () {
				return $(this).css('visibility') !== 'hidden';
			}).each(function () {
				var iHeight = $(this).height();
				if (iHeight > height) {
					height = iHeight;
				}
			});
			return height;
		}
	}, {
		key: "off",
		value: function off() {
			clearInterval(this._interval);
			this._event.empty();
		}
	}]);

	return HeightWatcher;
}();

var WindowWrapper = function () {
	function WindowWrapper() {
		_classCallCheck(this, WindowWrapper);

		this._$wnd = $(window);
		this._$html = $('html');
		this._$head = $('head');
		this._scrollTop = 0;
		this._scrollLeft = 0;

		this._$scrollBarStyle = $("<style type=\"text/css\"></style>").appendTo(this._$head);
		this._$positionStyle = $("<style type=\"text/css\"></style>").appendTo(this._$head);
		// this._useFixedLayout = /(iPod|iPhone|iPad)/.test(navigator.userAgent);
		this._useFixedLayout = Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["c" /* isMobile */])(); ///(iPod|iPhone|iPad)/.test(navigator.userAgent);
	}

	_createClass(WindowWrapper, [{
		key: "on",
		value: function on() {
			if (this._useFixedLayout) {
				this._scrollTop = this._$wnd.scrollTop();
				this._scrollLeft = this._$wnd.scrollLeft();
				this._applyPositionStyle();
				this._$wnd.scrollTop(0).scrollLeft(0);
			}
			this._applyScrollbarStyle();

			this._$html.toggleClass('zdialog-scrollbar-fix', this._hasScrollBar()).toggleClass('zdialog-position-fix', this._useFixedLayout).addClass('zdialog-open');
		}
	}, {
		key: "off",
		value: function off() {
			this._$html.removeClass('zdialog-scrollbar-fix').removeClass('zdialog-position-fix').removeClass('zdialog-open');
			if (this._useFixedLayout) {
				this._$wnd.scrollTop(this._scrollTop).scrollLeft(this._scrollLeft);
			}
		}
	}, {
		key: "_applyScrollbarStyle",
		value: function _applyScrollbarStyle() {
			var scrollBarWidth = getScrollBarWidth();
			// language=CSS
			this._$scrollBarStyle.html("\n.zdialog-scrollbar-fix {\n\tpadding-right: " + scrollBarWidth + "px;\n}\n");
		}
	}, {
		key: "_applyPositionStyle",
		value: function _applyPositionStyle() {
			// language=CSS
			this._$positionStyle.html("\n.zdialog-position-fix {\n\tposition: fixed;\n\twidth: 100%;\n\theight: 100%;\n\ttop: -" + this._scrollTop + "px;\n\tleft: -" + this._scrollLeft + "px;\n}\n");
		}
	}, {
		key: "_hasScrollBar",
		value: function _hasScrollBar() {
			return hasScrollBar(this._$html);
		}
	}]);

	return WindowWrapper;
}();

function getScrollBarWidth() {
	var $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body'),
	    widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
	$outer.remove();
	return 100 - widthWithScroll;
}

function hasScrollBar(el) {
	var $el = $(el);
	return $el.length > 0 ? $el[0].scrollHeight > $(window).height() : false;
}

var dialogManager = new DialogManager();

__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-wrapper', {
	template: "\n<div class=\"zdialog-overlay\"></div>\n<div class=\"zdialog-loader\"></div>\n<div data-bind=\"foreach: {data: dialogs, beforeRemove: handleBeforeRemove}\">\n\t<div class=\"zdialog-container\">\n\t\t<div class=\"zdialog\" data-bind=\"component: {name: 'zdialog', params: $data}, height: contentHeight, \n\t\t\t\t\t\t\t\t\t\tcss: $parent.getDialogClass($data)\"></div>\n\t</div>\n</div>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog', {
	template: "\n<div class=\"zdialog-backdrop\" data-bind=\"click: handleBackdropClick\"></div>\n<div class=\"zdialog-content\" data-bind=\"css: 'zdialog-content-' + type, \n\t\t\t\t\t\t\t\t\t\tcomponent: {name: 'zdialog-content-' + type, params: $data},\n\t\t\t\t\t\t\t\t\t\twidth: contentWidth\"></div>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-content-iframe', {
	template: "\n<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n<iframe class=\"zdialog-iframe\" frameborder=\"0\" vspace=\"0\" hspace=\"0\" scrolling=\"auto\"\n\t\tdata-bind=\"attr: {src: content}, event: {load: handleIframeLoad}, height: iframeHeight\"></iframe>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-content-html', {
	template: "\n<!-- ko if: title -->\n<h2 class=\"zdialog-title\">\n\t<span data-bind=\"html: title\"></span>\n\t<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n</h2>\n<!-- /ko -->\n<!-- ko ifnot: title -->\n<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n<!-- /ko -->\n<div class=\"zdialog-html\" data-bind=\"html: content, on: {events: 'click', selector: '[rel=close-dialog]', handler: handleCloseClick}\"></div>\n".trim()
});

/***/ }),

/***/ "i4G7":
/***/ (function(module, exports) {

module.exports = "/*!\n * jQuery Cookie Plugin v1.4.1\n * https://github.com/carhartl/jquery-cookie\n *\n * Copyright 2013 Klaus Hartl\n * Released under the MIT license\n */\n(function (factory) {\n\tif (typeof define === 'function' && define.amd) {\n\t\t// AMD\n\t\tdefine(['jquery'], factory);\n\t} else if (typeof exports === 'object') {\n\t\t// CommonJS\n\t\tfactory(require('jquery'));\n\t} else {\n\t\t// Browser globals\n\t\tfactory(jQuery);\n\t}\n}(function ($) {\n\n\tvar pluses = /\\+/g;\n\n\tfunction encode(s) {\n\t\treturn config.raw ? s : encodeURIComponent(s);\n\t}\n\n\tfunction decode(s) {\n\t\treturn config.raw ? s : decodeURIComponent(s);\n\t}\n\n\tfunction stringifyCookieValue(value) {\n\t\treturn encode(config.json ? JSON.stringify(value) : String(value));\n\t}\n\n\tfunction parseCookieValue(s) {\n\t\tif (s.indexOf('\"') === 0) {\n\t\t\t// This is a quoted cookie as according to RFC2068, unescape...\n\t\t\ts = s.slice(1, -1).replace(/\\\\\"/g, '\"').replace(/\\\\\\\\/g, '\\\\');\n\t\t}\n\n\t\ttry {\n\t\t\t// Replace server-side written pluses with spaces.\n\t\t\t// If we can't decode the cookie, ignore it, it's unusable.\n\t\t\t// If we can't parse the cookie, ignore it, it's unusable.\n\t\t\ts = decodeURIComponent(s.replace(pluses, ' '));\n\t\t\treturn config.json ? JSON.parse(s) : s;\n\t\t} catch(e) {}\n\t}\n\n\tfunction read(s, converter) {\n\t\tvar value = config.raw ? s : parseCookieValue(s);\n\t\treturn $.isFunction(converter) ? converter(value) : value;\n\t}\n\n\tvar config = $.cookie = function (key, value, options) {\n\n\t\t// Write\n\n\t\tif (value !== undefined && !$.isFunction(value)) {\n\t\t\toptions = $.extend({}, config.defaults, options);\n\n\t\t\tif (typeof options.expires === 'number') {\n\t\t\t\tvar days = options.expires, t = options.expires = new Date();\n\t\t\t\tt.setTime(+t + days * 864e+5);\n\t\t\t}\n\n\t\t\treturn (document.cookie = [\n\t\t\t\tencode(key), '=', stringifyCookieValue(value),\n\t\t\t\toptions.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE\n\t\t\t\toptions.path    ? '; path=' + options.path : '',\n\t\t\t\toptions.domain  ? '; domain=' + options.domain : '',\n\t\t\t\toptions.secure  ? '; secure' : ''\n\t\t\t].join(''));\n\t\t}\n\n\t\t// Read\n\n\t\tvar result = key ? undefined : {};\n\n\t\t// To prevent the for loop in the first place assign an empty array\n\t\t// in case there are no cookies at all. Also prevents odd result when\n\t\t// calling $.cookie().\n\t\tvar cookies = document.cookie ? document.cookie.split('; ') : [];\n\n\t\tfor (var i = 0, l = cookies.length; i < l; i++) {\n\t\t\tvar parts = cookies[i].split('=');\n\t\t\tvar name = decode(parts.shift());\n\t\t\tvar cookie = parts.join('=');\n\n\t\t\tif (key && key === name) {\n\t\t\t\t// If second argument (value) is a function it's a converter...\n\t\t\t\tresult = read(cookie, value);\n\t\t\t\tbreak;\n\t\t\t}\n\n\t\t\t// Prevent storing a cookie that we couldn't decode.\n\t\t\tif (!key && (cookie = read(cookie)) !== undefined) {\n\t\t\t\tresult[name] = cookie;\n\t\t\t}\n\t\t}\n\n\t\treturn result;\n\t};\n\n\tconfig.defaults = {};\n\n\t$.removeCookie = function (key, options) {\n\t\tif ($.cookie(key) === undefined) {\n\t\t\treturn false;\n\t\t}\n\n\t\t// Must not alter options, thus extending a fresh object...\n\t\t$.cookie(key, '', $.extend({}, options, { expires: -1 }));\n\t\treturn !$.cookie(key);\n\t};\n\n}));\n"

/***/ }),

/***/ "i8fT":
/***/ (function(module, exports) {

module.exports = "(function($) {\r\n    $.fn.urlconverter = function(maxlength) {\r\n        return this.each(function() {\r\n            let text = $(this).html();\r\n            if(text) {\r\n                text = text.replace(\"&amp;\", \"&\");\r\n                $(this).html(text.replace(/(https?:\\/\\/)?([\\da-z\\.\\-@]+)\\.([a-z\\.]{2,6})([\\?+=&%#\\/\\wА-Яа-яёЁ\\.;\\-]*)*\\/?/g, function (s) {\r\n                    let st = s;\r\n\r\n                    if (s.length > maxlength) {\r\n                        st = s.slice(0, maxlength) + \"...\";\r\n                    }\r\n\r\n                    if (!/^(https?:\\/\\/)/.test(s)) {\r\n                        if(s.indexOf('@') !== -1) {\r\n                            s = \"mailto:\" + s;\r\n                        } else {\r\n                            s = \"http://\" + s;\r\n                        }\r\n                    }\r\n\r\n                    return \"<a href='\" + s + \"' target='_blank' rel='nofollow noopener'>\" + st + \"</a>\";\r\n                }));\r\n            }\r\n        });\r\n    };\r\n}(jQuery));\r\n"

/***/ }),

/***/ "iOFR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kvOq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sale__ = __webpack_require__("Jkdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__article__ = __webpack_require__("FE6W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contest__ = __webpack_require__("mzgk");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "sale", function() { return __WEBPACK_IMPORTED_MODULE_0__sale__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "article", function() { return __WEBPACK_IMPORTED_MODULE_1__article__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "contest", function() { return __WEBPACK_IMPORTED_MODULE_2__contest__; });






/***/ }),

/***/ "l4Yc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loading_less__ = __webpack_require__("iOFR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loading_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loading_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("YnTO");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var $el = void 0;
var counter = 0;
var iframeOverride = Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* checkIsIframe */])() ? window.top.zde.loading : {};

/* harmony default export */ __webpack_exports__["a"] = (_extends({
	/**
  * Shows loading spinner
  */
	show: function show() {
		if (!$el) {
			$el = $('<div class="zloader"></div>').appendTo('body');
			/*$el = $(`<div class="zloader2">
   <div></div>
   <div></div>
   <div></div>
   </div>`).appendTo('body');*/
		}
		counter++;
	},

	/**
  * Shows loading spinner
  */
	hide: function hide() {
		if ($el && --counter <= 0) {
			$el.addClass('zloader-closing');
			// let animation finish and remove the element
			var $element = $el;
			setTimeout(function () {
				$element.remove();
			}, 1000);
			$el = null;
			counter = 0;
		}
	}

}, iframeOverride));

/***/ }),

/***/ "lNzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initSaleAdminPanelForList;
/* harmony export (immutable) */ __webpack_exports__["a"] = initSaleAdminPanel;
/* unused harmony export initSaleTemplatesCopy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard__ = __webpack_require__("oqjq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_widgets_loading__ = __webpack_require__("l4Yc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_widgets_notifier__ = __webpack_require__("2uje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_widgets_dialog__ = __webpack_require__("fokk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_utils_globals__ = __webpack_require__("TxBK");








function initSaleAdminPanelForList($listWrapper, selector) {
	$listWrapper = $($listWrapper);
	$listWrapper.on('click', selector + ' [rel=change-status]', function () {
		onClickChangeStatus($(this));
	});
}

function initSaleAdminPanel(selector) {
	var $wrap = $(selector);
	if (!$wrap || !$wrap.length) {
		return;
	}

	$wrap.find('[rel=change-status]').on('click', function () {
		onClickChangeStatus($(this));
	});

	initSaleTemplatesCopy($wrap.find('[rel=copy-template]'));
}

function onClickChangeStatus($wrap) {
	if (!$wrap || !$wrap.length || $wrap.data('isWorking')) {
		return;
	}
	var id = $wrap.data('pageId');
	var $status = $wrap.find('[rel=page-status]');
	var status = $status.text();
	$wrap.data('isWorking', true);
	__WEBPACK_IMPORTED_MODULE_2__core_widgets_loading__["a" /* default */].show();
	$.post(Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */])('blog/changePageStatus'), { id: id, status: status }, null, 'json').always(__WEBPACK_IMPORTED_MODULE_2__core_widgets_loading__["a" /* default */].hide).fail(__WEBPACK_IMPORTED_MODULE_3__core_widgets_notifier__["a" /* Notifier */].errorXHR).done(function (response) {
		if (!response || !response.success) {
			__WEBPACK_IMPORTED_MODULE_3__core_widgets_notifier__["a" /* Notifier */].error();
		} else {
			var newStatus = response.status;
			$status.text(newStatus);
			__WEBPACK_IMPORTED_MODULE_3__core_widgets_notifier__["a" /* Notifier */].success('Статус изменен на ' + newStatus);
			$wrap.data('isWorking', false);
		}
	});
}

/**
 * Initialize copy-template admin block
 * @param {JQuery} $wrap
 */
function initSaleTemplatesCopy($wrap) {
	if (!$wrap || !$wrap.length) {
		return;
	}
	var items = Object(__WEBPACK_IMPORTED_MODULE_6__core_utils_globals__["a" /* globals */])('saleTemplateItems');
	if (!items) {
		return;
	}
	var $select = $wrap.find('select[rel=template-items]');
	$.each(items, function (id, name) {
		$select.append($('<option></option>').attr('value', id).text(name));
	});

	var clipboard = new __WEBPACK_IMPORTED_MODULE_0_clipboard___default.a('#btnCopySaleTemplate', {
		text: function text() {
			return $wrap.data('content');
		}
	});
	var page_id = $wrap.data('pageId');
	var $buttons = $wrap.find('button.main');
	var $buttonsTg = $wrap.find('button.tg');
	var zresponse = '';
	$select.on('change', function () {
		$buttons.prop('disabled', true);
		$buttonsTg.prop('disabled', true);
		var template_id = $(this).val();
		if (!template_id) {
			return;
		}
		__WEBPACK_IMPORTED_MODULE_2__core_widgets_loading__["a" /* default */].show();
		var selected = $(this).val();
		var text = $(this).find('option[value="' + selected + '"]').text();
		$.get(Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */])('sale/ajax_get_template'), { page_id: page_id, template_id: template_id }, null, 'json').always(__WEBPACK_IMPORTED_MODULE_2__core_widgets_loading__["a" /* default */].hide).fail(__WEBPACK_IMPORTED_MODULE_3__core_widgets_notifier__["a" /* Notifier */].errorXHR).done(function (response) {
			$wrap.data('content', response['content']);
			$buttons.prop('disabled', false);
			zresponse = response.content;
			if (text.indexOf('TG') + 1) {
				$buttonsTg.prop('disabled', false);
			}
		});
	});
	clipboard.on('success', function (e) {
		__WEBPACK_IMPORTED_MODULE_3__core_widgets_notifier__["a" /* Notifier */].success('Шаблон скопирован в буффер обмена');
	});
	$wrap.find('[rel=btn-view-template]').on('click', function () {
		var content = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.escape($wrap.data('content'));
		Object(__WEBPACK_IMPORTED_MODULE_5__core_widgets_dialog__["openHtmlDialog"])("<pre style=\"white-space: pre-wrap; word-break: break-all;\">" + content + "</pre>");
	});
	$('#btn-tg-test').click(function () {
		var request = {
			text: zresponse,
			chat_id: '-1001283636934',
			parse_mode: 'Markdown'
		};

		$.post(Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */])('blog/telegramPost'), request, function (response) {
			updateResponse(response);
		}, 'json');
	});
	$('#btn-tg-prod').click(function () {
		var request = {
			text: zresponse,
			chat_id: '-1001220675019',
			parse_mode: 'Markdown'
		};

		$.post(Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */])('blog/telegramPost'), request, function (response) {
			updateResponse(response);
		}, 'json');
	});

	function updateResponse(response) {
		if (response.success) {
			zde.notifier.success('Сообщение отправлено');
		} else {
			zde.notifier.error('Произошла ошибка');
		}
	}
}

/***/ }),

/***/ "mvuq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 *
 * @param {object} options
 * @return {LastCommentsViewModel}
 */
function init(options) {
    var o = _extends({
        heightTarget: '.layout-content',
        commentsType: 'all',
        reviewType: null
    }, options);

    return new LastCommentsViewModel(o.heightTarget, o.commentsType, o.reviewType);
}

var LastCommentsViewModel = function () {
    function LastCommentsViewModel(heightTarget, commentsType, reviewType) {
        var _this = this;

        _classCallCheck(this, LastCommentsViewModel);

        this._$wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#commentsWrapper');
        this.needsLoading = true;
        this.allVisible = true;
        this.heightTarget = null;

        var commentsPerPage = 50;

        this.heightTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(heightTarget);

        this._prepareCommentBlocks(this._$wrapper.children('.comment-item'));
        this.fit();

        this._$wrapper.zInfiniteScroll({
            selector: '.comment-item',
            checkViewport: false,
            enabled: function enabled() {
                if (!_this.allVisible) {
                    _this.fit();
                }
                return _this.needsLoading && _this.allVisible;
            },
            maxAutoloadPages: 100,
            loading: '#lastCommentsScrollLoader',
            fetch: function fetch(page, callback) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(_this._$wrapper.data('load-url'), {
                    offset: (page - 1) * commentsPerPage,
                    count: commentsPerPage,
                    comments_type: commentsType,
                    review_type: reviewType,
                    new_layout: 1
                }, function (response) {
                    var $blocks = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(response['html']);
                    callback($blocks);
                }, 'json');
            },
            show: function show($blocks) {
                $blocks = $blocks.filter('.comment-item');
                _this.fit();
                _this._$wrapper.append($blocks);
                _this._prepareCommentBlocks($blocks);
                _this.fit();
                return $blocks.length;
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('heightTargetUpdated', function () {
            _this.fit();
        });
    }

    _createClass(LastCommentsViewModel, [{
        key: '_prepareCommentBlocks',
        value: function _prepareCommentBlocks($blocks) {
            $blocks.each(function () {
                var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                $this.data('height', $this.outerHeight(true));
            });
        }
    }, {
        key: 'fit',
        value: function fit() {
            var $content = this.heightTarget;
            var $comments = this._$wrapper.children('.comment-item');

            var contentBottom = $content.offset().top + $content.outerHeight();
            var top = this._$wrapper.offset().top;
            var commentsBottom = top + this._$wrapper.outerHeight();
            var $item = void 0;
            var result = 0;

            var commentsHeight = this._$wrapper.outerHeight();

            if (commentsBottom > contentBottom) {
                // hide elements one by one while comments column is longer
                do {
                    $item = $comments.filter(':visible').last();
                    if ($item.length === 0) {
                        break;
                    }
                    if (top + commentsHeight > contentBottom) {
                        commentsHeight -= $item.data('height');
                        $item.hide();
                        result--;
                    } else {
                        break;
                    }
                } while (true);
            } else if (commentsBottom < contentBottom) {
                // show elements one by one while comments column is shorter
                do {
                    $item = $comments.filter(':hidden').first();
                    if ($item.length === 0) {
                        break;
                    }
                    commentsHeight += $item.data('height');
                    if (top + commentsHeight <= contentBottom) {
                        $item.show();
                        result++;
                    } else {
                        break;
                    }
                } while (true);
            }

            this.needsLoading = result >= 0;
            this.allVisible = $comments.filter(':hidden').length === 0;
            return result;
        }
    }]);

    return LastCommentsViewModel;
}();

/***/ }),

/***/ "mzgk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pagecomments__ = __webpack_require__("NdAU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sidebar__ = __webpack_require__("J9kM");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var logger = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_logger__["a" /* newLogger */])('Contest page');

function init(options) {
	var o = _extends({
		page: {},
		comments: []
	}, options);

	logger.log('init', o);

	__WEBPACK_IMPORTED_MODULE_1__pagecomments__["a" /* init */]({ page: o.page, comments: o.comments });
	setTimeout(__WEBPACK_IMPORTED_MODULE_2__sidebar__["a" /* init */]);
}

/***/ }),

/***/ "oN+n":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	function log(error) {
		(typeof console !== "undefined")
		&& (console.error || console.log)("[Script Loader]", error);
	}

	// Check for IE =< 8
	function isIE() {
		return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
	}

	try {
		if (typeof execScript !== "undefined" && isIE()) {
			execScript(src);
		} else if (typeof eval !== "undefined") {
			eval.call(null, src);
		} else {
			log("EvalError: No eval function available");
		}
	} catch (error) {
		log(error);
	}
}


/***/ }),

/***/ "og09":
/***/ (function(module, exports) {

module.exports = toastr;

/***/ }),

/***/ "oqjq":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__("qqFi"), __webpack_require__("e2Zi"), __webpack_require__("PtfZ")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),

/***/ "q/mW":
/***/ (function(module, exports) {

module.exports = "/* Soon v1.9.0 - Soon, Animated Responsive Countdowns, jQuery\n * Copyright (c) 2016 Rik Schennink - http://rikschennink.nl/products/soon\n */\n!function(a,b,c){function d(){H!==window.innerWidth&&(H=window.innerWidth,g())}function e(a,b,c,d){var e=parseInt(getComputedStyle(document.documentElement).fontSize,10)/16,f=parseInt(getComputedStyle(b).fontSize,10)/16/e,g=d/b.scrollWidth,h=g*f;return 4>h?(a.style.fontSize=\"\",c.redraw(),!1):(a.style.fontSize=h+\"rem\",a.setAttribute(\"data-scale-rounded\",Math.round(h).toString()),c.redraw(),!0)}function f(a,b){if(!B.isSlow()){for(var c,d,f=window.getComputedStyle(a.parentNode),g=parseInt(f.getPropertyValue(\"padding-left\"),10),h=parseInt(f.getPropertyValue(\"padding-right\"),10),i=a.parentNode.clientWidth-g-h,j=a.getAttribute(\"data-scale-max\"),k=a.getAttribute(\"data-scale-hide\"),l=j?I.indexOf(j):J,m=a.querySelectorAll(\".soon-group-sub\"),n=0,o=m.length,p=a.querySelector(\".soon-group\");o>n;n++)m[n].style.display=\"\";if(\"fit\"===j||\"fill\"===j){if(e(a,p,b,i))return;l=0}c=l;do a.setAttribute(\"data-scale\",I[c]),c++;while(p.scrollWidth>i&&I[c]);if(c!==l&&b.redraw(),!(p.scrollWidth<=i||\"none\"===k)){n=0,d=!1;do{if(\"0\"!==m[n].getAttribute(\"data-value\"))break;m[n].style.display=\"none\",d=!0,n++}while(p.scrollWidth>i&&o>n);if(d&&b.redraw(),\"empty\"!==k){n=o-1,d=!1;do m[n].style.display=\"none\",d=!0,n--;while(p.scrollWidth>i&&n>0);d&&b.redraw()}}}}function g(){for(var a=K.length-1;a>=0;a--)f(K[a].node,K[a].presenter)}function h(a){for(var b=0,c=K.length;c>b;b++)if(K[b].node===a)return b;return null}function i(a){for(var b=0,c=L.length;c>b;b++)if(L[b].node===a)return b;return null}function j(a){var b=h(a);return null===b?null:K[b]}function k(a){-1===a.className.indexOf(\"soon\")&&(a.className+=\" soon\"),B.supportsAnimation()||(a.className+=\" soon-no-animation\");var b=a.getAttribute(\"data-layout\");(!b||-1===b.indexOf(\"group\")&&-1===b.indexOf(\"line\"))&&(b||(b=\"\"),a.setAttribute(\"data-layout\",b+\" group\")),B.isSlow()&&(a.removeAttribute(\"data-visual\"),a.setAttribute(\"data-view\",\"text\"),a.className+=\" soon-slow-browser\")}function l(a,b,c){b[c]&&!a.getAttribute(\"data-\"+c)&&a.setAttribute(\"data-\"+c,b[c])}function m(a,b){return a.getAttribute(\"data-\"+b)}function n(a,b){var c=null!==a.due||null!==a.since,d=null;if(c)if(a.since){var e=a.now?a.now.valueOf():(new Date).valueOf();d=D.chain(function(b){return a.now?-b:b},D.offset(e),D.diff(a.since.valueOf()),function(a){return Math.abs(a)},function(a){return Math.max(0,a)},function(b){return a.callback.onTick(b,a.since),b},D.event(function(a){return 0===a},b),D.duration(new Date(e),a.since,a.format,a.cascade))}else d=D.chain(D.offset(a.now.valueOf()),D.diff(a.due.valueOf()),function(a){return Math.max(0,a)},function(b){return a.callback.onTick(b,a.due),b},D.event(function(a){return 0>=a},b),D.duration(a.now,a.due,a.format,a.cascade));else d=function(){var a=new Date;return[a.getHours(),a.getMinutes(),a.getSeconds()]},a.format=[\"h\",\"m\",\"s\"],a.separator=\":\";return d}function o(a,b){for(var c,d,e,f,g,h,i,j=null!==a.due||null!==a.since,k=n(a,b),l={type:\"group\",options:{transform:k,presenters:[]}},m=[],o=a.format.length,r=0;o>r;r++)h=a.format[r],i=r,c={type:\"group\",options:{className:\"soon-group-sub\",presenters:[]}},a.visual&&(c.options.presenters.push(p(a,h)),a.reflect&&c.options.presenters.push(p(a,h,\"soon-reflection\"))),d={type:\"text\",options:{className:\"soon-label\"}},d.options.transform=a.singular?D.plural(a.label[h],a.label[h+\"_s\"]):function(b){return function(){return a.label[b+\"_s\"]}}(h),e=q(a,h),f=null,a.reflect&&!a.visual&&(f=q(a,h,\"soon-reflection\")),c.options.presenters.push(e),f&&c.options.presenters.push(f),j&&c.options.presenters.push(d),a.separator&&(g={type:\"group\",options:{className:\"soon-group-separator\",presenters:[c]}},0!==i&&(a.reflect&&g.options.presenters.unshift({type:\"text\",options:{className:\"soon-separator soon-reflection\",transform:function(){return a.separator}}}),g.options.presenters.unshift({type:\"text\",options:{className:\"soon-separator\",transform:function(){return a.separator}}})),c=g),m.push(c);return l.options.presenters=m,l}function p(a,b,c){var d=a.visual.split(\" \"),e=d[0];return d.shift(),{type:e,options:{className:\"soon-visual \"+(c||\"\"),transform:D.chain(D.progress(B.MAX[b]),D.cap()),modifiers:d,animate:\"ms\"!==b}}}function q(a,b,c){var d=[];return a.face&&(d=a.face.split(\" \"),d.shift()),a.chars?{type:\"repeater\",options:{delay:\"text\"===a.view?0:50,className:\"soon-value \"+(c||\"\"),transform:D.chain(D.pad(a.padding[b]),D.chars()),presenter:{type:a.view,options:{modifiers:d}}}}:{type:\"group\",options:{className:\"soon-group-sub-sub soon-value \"+(c||\"\"),transform:D.pad(a.padding[b]),presenters:[{type:a.view,options:{modifiers:d}}]}}}function r(a,b,c,d){K.push({node:a,ticker:b,presenter:c,options:d})}function s(a){return new(t(a.type))(a.options||{})}function t(a){return C[a.charAt(0).toUpperCase()+a.slice(1)]}function u(a,b){var c=a.getElementsByClassName?a.getElementsByClassName(\"soon-placeholder\"):a.querySelectorAll(\"soon-placeholder\");c.length&&(c[0].innerHTML=\"\",a=c[0]);var d=s(b);return a.appendChild(d.getElement()),d}function v(a,b,c,d){var e=new F(function(a){b.setValue(a)},{rate:c});return r(a,e,b,d),e.start(),f(a,b),e}function w(a){var b,c,d=[\"labels\",\"padding\"],e=2,f={since:m(a,\"since\"),due:m(a,\"due\"),now:m(a,\"now\"),face:m(a,\"face\"),visual:m(a,\"visual\"),format:m(a,\"format\"),singular:\"true\"===m(a,\"singular\"),reflect:\"true\"===m(a,\"reflect\"),scaleMax:m(a,\"scale-max\"),scaleHide:m(a,\"scale-hide\"),separateChars:!(\"false\"===m(a,\"separate-chars\")),cascade:!(\"false\"===m(a,\"cascade\")),separator:m(a,\"separator\"),padding:!(\"false\"===m(a,\"padding\")),eventComplete:m(a,\"event-complete\"),eventTick:m(a,\"event-tick\")};for(var g in M)if(M.hasOwnProperty(g))for(b=M[g],c=0;e>c;c++)f[d[c]+b.option]=m(a,d[c]+\"-\"+b.option.toLowerCase());return A.create(a,f)}function x(a){var b;if(0===a.indexOf(\"in \")){var c=a.match(N),d=parseInt(c[1],10),e=c[2];return b=new Date,-1!==e.indexOf(\"hour\")?b.setHours(b.getHours()+d):-1!==e.indexOf(\"minute\")?b.setMinutes(b.getMinutes()+d):-1!==e.indexOf(\"second\")&&b.setSeconds(b.getSeconds()+d),b}if(-1!==a.indexOf(\"at \")){b=new Date;var f=b.getTime(),g=-1!==a.indexOf(\"reset\");a=a.replace(\"reset \",\"\");var h=a.split(\"at \"),i=h[1].match(O),j=parseInt(i[1],10),k=i[2]?parseInt(i[2],10):0,l=i[3]?parseInt(i[3],10):0,m=h[1].split(\" zone \");if(m&&(m=m[1]),h[0].length){var n=B.getDayIndex(h[0]),o=(n+7-b.getDay())%7;b.setDate(b.getDate()+o)}b.setHours(j),b.setMinutes(k),b.setSeconds(l),b.setMilliseconds(0),g&&f>=b.getTime()&&b.setHours(j+(h[0].length?168:24));var p=B.pad,q=b.getFullYear()+\"-\"+p(b.getMonth()+1)+\"-\"+p(b.getDate()),r=p(b.getHours())+\":\"+p(b.getMinutes())+\":\"+p(b.getSeconds());a=q+\"T\"+r+(m||\"\")}return B.isoToDate(a)}function y(a,b){if(0===b.indexOf(a))return\"\";if(\"w\"===a&&-1!==b.indexOf(\"M\"))return\"\";if(\"d\"===a){if(-1!==b.indexOf(\"w\"))return\"\";if(-1!==b.indexOf(\"M\"))return\"00\"}return null}function z(a,b,c){if(c&&-1!==G.indexOf(a))return c;var d=function(c){return function(){c(),A.destroy(a),A.create(a,b)}}(c);return G.push(a),d}if(document.querySelectorAll&&!a.Soon){var A={},B={},C={},D={},E={timer:0,cbs:[],register:function(a){E.cbs.push(a)},deregister:function(a){for(var b=E.cbs.length-1;b>=0;b--)E.cbs[b]===a&&E.cbs.splice(b,1)},onresize:function(){clearTimeout(E.timer),E.timer=setTimeout(function(){E.resize()},100)},resize:function(){for(var a=0,b=E.cbs.length;b>a;a++)E.cbs[a]()},init:function(){a.addEventListener&&a.addEventListener(\"resize\",E.onresize,!1)}};E.init(),Function.prototype.bind||(Function.prototype.bind=function(a){if(\"function\"!=typeof this)throw new TypeError(\"Function.prototype.bind - what is trying to be bound is not callable\");var b=Array.prototype.slice.call(arguments,1),c=this,d=function(){},e=function(){return c.apply(this instanceof d&&a?this:a,b.concat(Array.prototype.slice.call(arguments)))};return d.prototype=this.prototype,e.prototype=new d,e}),Array.prototype.indexOf||(Array.prototype.indexOf=function(a,b){var c;if(null==this)throw new TypeError('\"this\" is null or not defined');var d=Object(this),e=d.length>>>0;if(0===e)return-1;var f=+b||0;if(1/0===Math.abs(f)&&(f=0),f>=e)return-1;for(c=Math.max(f>=0?f:e-Math.abs(f),0);e>c;){if(c in d&&d[c]===a)return c;c++}return-1}),function(){function a(a){this.el=a;for(var b=a.className.replace(/^\\s+|\\s+$/g,\"\").split(/\\s+/),c=0;c<b.length;c++)d.call(this,b[c])}function b(a,b,c){Object.defineProperty?Object.defineProperty(a,b,{get:c}):a.__defineGetter__(b,c)}if(!(\"undefined\"==typeof window.Element||\"classList\"in document.documentElement)){var c=Array.prototype,d=c.push,e=c.splice,f=c.join;a.prototype={add:function(a){this.contains(a)||(d.call(this,a),this.el.className=this.toString())},contains:function(a){return-1!=this.el.className.indexOf(a)},item:function(a){return this[a]||null},remove:function(a){if(this.contains(a)){for(var b=0;b<this.length&&this[b]!=a;b++);e.call(this,b,1),this.el.className=this.toString()}},toString:function(){return f.call(this,\" \")},toggle:function(a){return this.contains(a)?this.remove(a):this.add(a),this.contains(a)}},window.DOMTokenList=a,b(Element.prototype,\"classList\",function(){return new a(this)})}}(),function(){for(var a=0,b=[\"webkit\",\"moz\"],c=0;c<b.length&&!window.requestAnimationFrame;++c)window.requestAnimationFrame=window[b[c]+\"RequestAnimationFrame\"],window.cancelAnimationFrame=window[b[c]+\"CancelAnimationFrame\"]||window[b[c]+\"CancelRequestAnimationFrame\"];window.requestAnimationFrame||(window.requestAnimationFrame=function(b){var c=(new Date).getTime(),d=Math.max(0,16-(c-a)),e=window.setTimeout(function(){b(c+d)},d);return a=c+d,e}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)})}(),B=function(){function a(){if(!window.getComputedStyle)return!1;var a,b=document.createElement(\"div\"),d={webkitTransform:\"-webkit-transform\",OTransform:\"-o-transform\",msTransform:\"-ms-transform\",MozTransform:\"-moz-transform\",transform:\"transform\"};document.body.insertBefore(b,null);for(var e in d)b.style[e]!==c&&(b.style[e]=\"translate3d(1px,1px,1px)\",a=window.getComputedStyle(b).getPropertyValue(d[e]));return document.body.removeChild(b),a!==c&&a.length>0&&\"none\"!==a}function b(){var a=!1,b=\"animation\",d=\"\",e=\"Webkit Moz O ms Khtml\".split(\" \"),f=\"\",g=0,h=document.body,i=e.length;if(h.style.animationName!==c&&(a=!0),a===!1)for(;i>g;g++)if(h.style[e[g]+\"AnimationName\"]!==c){f=e[g],b=f+\"Animation\",d=\"-\"+f.toLowerCase()+\"-\",a=!0;break}return a}var d,e,f=\"textContent\"in document.documentElement,g=function(a){var b,c,d=/^(\\d{4}\\-\\d\\d\\-\\d\\d([tT ][\\d:\\.]*)?)([zZ]|([+\\-])(\\d\\d):(\\d\\d))?$/,e=d.exec(a)||[];if(e[1]){b=e[1].split(/\\D/);for(var f=0,g=b.length;g>f;f++)b[f]=parseInt(b[f],10)||0;return b[1]-=1,b=new Date(Date.UTC.apply(Date,b)),b.getDate()?(e[5]&&(c=60*parseInt(e[5],10),e[6]&&(c+=parseInt(e[6],10)),\"+\"==e[4]&&(c*=-1),c&&b.setUTCMinutes(b.getUTCMinutes()+c)),b):Number.NaN}return Number.NaN},h=new Date(\"2015-01-01T12:00:00.123+01:00\"),i=isNaN(h)?function(a){return g(a)}:function(a){return new Date(a)};\"undefined\"!=typeof document.hidden?(e=\"hidden\",d=\"visibilitychange\"):\"undefined\"!=typeof document.mozHidden?(e=\"mozHidden\",d=\"mozvisibilitychange\"):\"undefined\"!=typeof document.msHidden?(e=\"msHidden\",d=\"msvisibilitychange\"):\"undefined\"!=typeof document.webkitHidden&&(e=\"webkitHidden\",d=\"webkitvisibilitychange\");var j=!1,k=1,l=1e3*k,m=60*l,n=60*m,o=24*n,p=7*o,q={MAX:{y:100,M:12,w:52,d:365,h:24,m:60,s:60,ms:1e3},AMOUNT:{w:p,d:o,h:n,m:m,s:l,ms:k},NAMES:{y:\"years\",M:\"months\",w:\"weeks\",d:\"days\",h:\"hours\",m:\"minutes\",s:\"seconds\",ms:\"milliseconds\"},FORMATS:[\"y\",\"M\",\"w\",\"d\",\"h\",\"m\",\"s\",\"ms\"],CIRC:2*Math.PI,QUART:.5*Math.PI,DAYS:[\"su\",\"mo\",\"tu\",\"we\",\"th\",\"fr\",\"sa\"],setText:null,documentVisibilityEvent:d,pad:function(a){return(\"00\"+a).slice(-2)},getDayIndex:function(a){return this.DAYS.indexOf(a.substr(0,2))},isSlow:function(){return!f},supportsAnimation:function(){return j=b()&&a(),q.supportsAnimation=function(){return j},j},toArray:function(a){return Array.prototype.slice.call(a)},toBoolean:function(a){return\"string\"==typeof a?\"true\"===a:a},isoToDate:function(a){if(a.match(/(Z)|([+\\-][0-9]{2}:?[0-9]*$)/g))return i(a);a+=-1!==a.indexOf(\"T\")?\"Z\":\"\";var b=i(a);return this.dateToLocal(b)},dateToLocal:function(a){return new Date(a.getTime()+6e4*a.getTimezoneOffset())},prefix:function(){for(var a,b=[\"webkit\",\"Moz\",\"ms\",\"O\"],c=0,d=b.length,e=document.createElement(\"div\").style;d>c;c++)if(a=b[c]+\"Transform\",a in e)return b[c];return null}(),setTransform:function(a,b){a.style[this.prefix+\"Transform\"]=b,a.style.transform=b},setTransitionDelay:function(a,b){a.style[this.prefix+\"TransitionDelay\"]=b+\",\"+b+\",\"+b,a.style.TransitionDelay=b+\",\"+b+\",\"+b},getShadowProperties:function(a){if(a=a?a.match(/(-?\\d+px)|(rgba\\(.+\\))|(rgb\\(.+\\))|(#[abcdef\\d]+)/g):null,!a)return null;for(var b,c=0,d=a.length,e=[];d>c;c++)-1!==a[c].indexOf(\"px\")?e.push(parseInt(a[c],10)):b=a[c];return e.push(b),5===e.length&&e.splice(3,1),e},getDevicePixelRatio:function(){return window.devicePixelRatio||1},isDocumentHidden:function(){return e?document[e]:!1},triggerAnimation:function(a,b){a.classList.remove(b),window.requestAnimationFrame(function(){a.offsetLeft,a.classList.add(b)})},getBackingStoreRatio:function(a){return a.webkitBackingStorePixelRatio||a.mozBackingStorePixelRatio||a.msBackingStorePixelRatio||a.oBackingStorePixelRatio||a.backingStorePixelRatio||1},setShadow:function(a,b,c,d,e){a.shadowOffsetX=b,a.shadowOffsetY=c,a.shadowBlur=d,a.shadowColor=e},getColorBetween:function(a,b,c){function d(a,b){return a+Math.round((b-a)*c)}function e(a){a=Math.min(a,255),a=Math.max(a,0);var b=a.toString(16);return b.length<2&&(b=\"0\"+b),b}return\"#\"+e(d(a.r,b.r))+e(d(a.g,b.g))+e(d(a.b,b.b))},getGradientColors:function(a,b,c){for(var d=[],e=0,f=c,g=1/(f-1),h=0;f>e;e++)d[e]=this.getColorBetween(a,b,h),h+=g;return d},hexToRgb:function(a){var b=/^#?([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})$/i.exec(a);return b?{r:parseInt(b[1],16),g:parseInt(b[2],16),b:parseInt(b[3],16)}:null},drawGradientArc:function(a,b,c,d,e,f,g,h,i,j,k,l,m){if(!(g>h)){l&&this.drawArc(a,b,c,d,e,f,g,h,i,\"transparent\",l,m);for(var n,o,p,q,r,s,t,u=this.hexToRgb(j),v=this.hexToRgb(k),w=this.hexToRgb(this.getColorBetween(u,v,(g-e)/f)),x=this.hexToRgb(this.getColorBetween(u,v,(h-e)/f)),y=h-g,z=Math.ceil(30*y),A=this.getGradientColors(w,x,z),B=-this.QUART+this.CIRC*g,C=A.length,D=0,E=this.CIRC*y/C;C>D;D++)o=A[D],p=A[D+1]||o,q=b+Math.cos(B)*d,s=b+Math.cos(B+E)*d,r=c+Math.sin(B)*d,t=c+Math.sin(B+E)*d,a.beginPath(),n=a.createLinearGradient(q,r,s,t),n.addColorStop(0,o),n.addColorStop(1,p),a.lineCap=m,a.strokeStyle=n,a.arc(b,c,d,B-.005,B+E+.005),a.lineWidth=i,a.stroke(),a.closePath(),B+=E}},drawArc:function(a,b,c,d,e,f,g,h,i,j,k,l){if(!(g>h)){if(null!==j.gradient.colors&&\"follow\"===j.gradient.type)return void this.drawGradientArc(a,b,c,d,e,f,g,h,i,j.gradient.colors[0],j.gradient.colors[1],k,l);if(k){var m=\"transparent\"===j.fill?9999:0;a.save(),a.translate(m,0),this.setShadow(a,k[0]-m,k[1],k[2],k[3])}if(a.beginPath(),a.lineWidth=i,a.arc(b,c,d,-this.QUART+this.CIRC*g,-this.QUART+this.CIRC*h,!1),j.gradient.colors){var n=\"horizontal\"===j.gradient.type?a.createLinearGradient(0,d,2*d,d):a.createLinearGradient(d,0,d,2*d);n.addColorStop(0,j.gradient.colors[0]),n.addColorStop(1,j.gradient.colors[1]),a.strokeStyle=n}else a.strokeStyle=\"transparent\"===j.fill?\"#000\":j.fill;a.lineCap=l,a.stroke(),k&&a.restore()}},drawRing:function(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p){d+e>1&&(d-=-1+d+e,c+=.5*e);var q=c,r=c+d,s=b*d,t=.5-Math.abs(-.5+b),u=c+(s-t*e),v=c+(s+(1-t)*e);(g||k)&&(p?(this.drawArc(a,f,f,g,c,d,v,r,h,i,j,o),this.drawArc(a,f,f,k,c,d,q,u,l,m,n,o)):(this.drawArc(a,f,f,g,c,d,q,u,h,i,j,o),this.drawArc(a,f,f,k,c,d,v,r,l,m,n,o)))},setTextContent:function(){return f?function(a,b){a.textContent=b}:function(a,b){a.innerText=b}}()};return q}(),D.cap=function(a,b){return a=a||0,b=b||1,function(c){return Math.min(Math.max(c,a),b)}},D.chain=function(a){return function(){var b,c=a.toArray(arguments),d=c.length;return function(a){for(b=0;d>b;b++)a=c[b](a);return a}}}(B),D.chars=function(){return function(a){return(a+\"\").split(\"\")}},D.diff=function(a){return function(b){return a-b}},D.duplicate=function(a){var b,c=new Array(a);return function(d){for(b=a;b--;)c[b]=d;return c}},D.duration=function(a){function b(a,b){return a.setMonth(a.getMonth()+b),a}function c(a){return new Date(a.valueOf())}function d(a,b){return-1!==b.indexOf(a)}function e(a,d){var e,f,g=12*(d.getFullYear()-a.getFullYear())+(d.getMonth()-a.getMonth()),h=b(c(a),g);return 0>d-h?(e=b(c(a),g-1),f=(d-h)/(h-e)):(e=b(c(a),g+1),f=(d-h)/(e-h)),-(g+f)}var f=a.FORMATS,g=f.length,h={M:1,y:12};return function(i,j,k,l){var m=d(\"M\",k),n=d(\"y\",k);return function(j){var o,p,q,r,s,t,u=0,v=[];for((m||n||!l)&&(o=new Date(i.valueOf()+j),p=e(o,i),t=m?Math.floor(p):12*Math.floor(p/12),j=o.valueOf()-b(c(i),t).valueOf());g>u;u++)r=f[u],2>u?(q=Math.floor(p/h[r]),d(r,k)?(p-=q*h[r],v.push(Math.max(0,q))):l||(p-=q*h[r])):(s=a.AMOUNT[r],q=Math.floor(j/s),d(r,k)?(j%=s,v.push(Math.max(0,q))):l||(j%=s));return v}}}(B),D.event=function(a,b){return function(c){return a(c)&&b(),c}},D.modulate=function(a){return function(b){return parseInt(b,10)%2===0?a:\"\"}},D.now=function(){return function(){return(new Date).getTime()}},D.offset=function(a){return function(b){return a+b}},D.pad=function(a){return a=a||\"\",function(b){return(a+b).slice(-a.length)}},D.plural=function(a,b){return function(c){return 1===parseInt(c,10)?a:b}},D.progress=function(a,b){return function(c){return c=parseInt(c,10),b>a?c/b:(a-c)/a}},C.Console=function(){var a=function(a){this._transform=a.transform||function(a){return a}};return a.prototype={redraw:function(){},destroy:function(){return null},getElement:function(){return null},setValue:function(a){console.log(this._transform(a))}},a}(),C.Fill=function(a){var b=function(a){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-fill \"+(a.className||\"\"),this._transform=a.transform||function(a){return a},this._direction=\"to-top\";for(var b=0,c=a.modifiers.length;c>b;b++)if(0===a.modifiers[b].indexOf(\"to-\")){this._direction=a.modifiers[b];break}this._fill=document.createElement(\"span\"),this._fill.className=\"soon-fill-inner\",this._progress=document.createElement(\"span\"),this._progress.className=\"soon-fill-progress\",this._fill.appendChild(this._progress),this._wrapper.appendChild(this._fill)};return b.prototype={redraw:function(){},destroy:function(){return this._wrapper},getElement:function(){return this._wrapper},setValue:function(b){var c,d=this._transform(b);switch(this._direction){case\"to-top\":c=\"translateY(\"+(100-100*d)+\"%)\";break;case\"to-top-right\":c=\"scale(1.45) rotateZ(-45deg) translateX(\"+(-100+100*d)+\"%)\";break;case\"to-top-left\":c=\"scale(1.45) rotateZ(45deg) translateX(\"+(100-100*d)+\"%)\";break;case\"to-left\":c=\"translateX(\"+(100-100*d)+\"%)\";break;case\"to-right\":c=\"translateX(\"+(-100+100*d)+\"%)\";break;case\"to-bottom-right\":c=\"scale(1.45) rotateZ(45deg) translateX(\"+(-100+100*d)+\"%)\";break;case\"to-bottom-left\":c=\"scale(1.45) rotateZ(-45deg) translateX(\"+(100-100*d)+\"%)\";break;case\"to-bottom\":c=\"translateY(\"+(-100+100*d)+\"%)\"}a.setTransform(this._progress,c)}},b}(B),C.Flip=function(a){var b=function(b){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-flip \"+(b.className||\"\"),this._transform=b.transform||function(a){return a},this._inner=document.createElement(\"span\"),this._inner.className=\"soon-flip-inner\",this._card=document.createElement(\"span\"),this._card.className=\"soon-flip-card\",a.supportsAnimation()?(this._front=document.createElement(\"span\"),this._front.className=\"soon-flip-front soon-flip-face\",this._back=document.createElement(\"span\"),this._back.className=\"soon-flip-back soon-flip-face\",this._card.appendChild(this._front),this._card.appendChild(this._back),this._top=document.createElement(\"span\"),this._top.className=\"soon-flip-top soon-flip-face\",this._card.appendChild(this._top),this._bottom=document.createElement(\"span\"),this._bottom.className=\"soon-flip-bottom soon-flip-face\",this._card.appendChild(this._bottom)):(this._fallback=document.createElement(\"span\"),this._fallback.className=\"soon-flip-fallback\",this._card.appendChild(this._fallback)),this._bounding=document.createElement(\"span\"),this._bounding.className=\"soon-flip-bounding\",this._card.appendChild(this._bounding),this._inner.appendChild(this._card),this._wrapper.appendChild(this._inner),this._frontValue=null,this._backValue=null,this._boundingLength=0};return b.prototype={redraw:function(){},_setBoundingForValue:function(a){var b=(a+\"\").length;if(b!==this._boundingLength){this._boundingLength=b;for(var c=\"\",d=0;b>d;d++)c+=\"8\";this._bounding.textContent=c;var e=parseInt(getComputedStyle(this._card).fontSize,10),f=this._bounding.offsetWidth/e;this._inner.style.width=f+.1*(b-1)+\"em\"}},destroy:function(){return this._wrapper},getElement:function(){return this._wrapper},setValue:function(b){return b=this._transform(b),a.supportsAnimation()?this._frontValue?void(this._backValue&&this._backValue===b||this._frontValue===b||(this._backValue&&(this._bottom.textContent=this._backValue,this._front.textContent=this._backValue,this._frontValue=this._backValue),this._setBoundingForValue(b),this._top.textContent=b,this._back.textContent=b,this._backValue=b,a.triggerAnimation(this._inner,\"soon-flip-animate\"))):(this._bottom.textContent=b,this._front.textContent=b,this._frontValue=b,void this._setBoundingForValue(b)):(this._fallback.textContent=b,void this._setBoundingForValue(b))}},b}(B),C.Group=function(a){var b=function(a){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-group \"+(a.className||\"\"),this._inner=document.createElement(\"span\"),this._inner.className=\"soon-group-inner\",this._wrapper.appendChild(this._inner),this._transform=a.transform||function(a){return a},this._presenters=a.presenters,this._presenterStorage=[]};return b.prototype={redraw:function(){for(var a=this._presenterStorage.length-1;a>=0;a--)this._presenterStorage[a].redraw()},destroy:function(){for(var a=this._presenterStorage.length-1;a>=0;a--)this._presenterStorage[a].destroy();return this._wrapper},getElement:function(){return this._wrapper},setValue:function(b){this._wrapper.setAttribute(\"data-value\",b),b=this._transform(b);for(var c,d=0,e=b instanceof Array,f=e?b.length:this._presenters.length;f>d;d++)c=this._presenterStorage[d],c||(c=a(this._presenters[d]),this._inner.appendChild(c.getElement()),this._presenterStorage[d]=c),c.setValue(e?b[d]:b)}},b}(s),C.Matrix=function(){var a={\"3x5\":{\" \":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]],0:[[1,1,1],[1,0,1],[1,0,1],[1,0,1],[1,1,1]],1:[[1,1,0],[0,1,0],[0,1,0],[0,1,0],[0,1,0]],2:[[1,1,1],[0,0,1],[1,1,1],[1,0,0],[1,1,1]],3:[[1,1,1],[0,0,1],[1,1,1],[0,0,1],[1,1,1]],4:[[1,0,1],[1,0,1],[1,1,1],[0,0,1],[0,0,1]],5:[[1,1,1],[1,0,0],[1,1,1],[0,0,1],[1,1,1]],6:[[1,1,1],[1,0,0],[1,1,1],[1,0,1],[1,1,1]],7:[[1,1,1],[0,0,1],[0,0,1],[0,0,1],[0,0,1]],8:[[1,1,1],[1,0,1],[1,1,1],[1,0,1],[1,1,1]],9:[[1,1,1],[1,0,1],[1,1,1],[0,0,1],[1,1,1]]},\"5x7\":{\" \":[[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]],0:[[0,1,1,1,0],[1,1,0,1,1],[1,1,0,1,1],[1,1,0,1,1],[1,1,0,1,1],[1,1,0,1,1],[0,1,1,1,0]],1:[[0,0,1,1,0],[0,1,1,1,0],[0,0,1,1,0],[0,0,1,1,0],[0,0,1,1,0],[0,0,1,1,0],[0,1,1,1,1]],2:[[0,1,1,1,0],[1,1,0,1,1],[0,0,0,1,1],[0,0,1,1,0],[0,1,1,0,0],[1,1,0,0,0],[1,1,1,1,1]],3:[[0,1,1,1,0],[1,1,0,1,1],[0,0,0,1,1],[0,0,1,1,0],[0,0,0,1,1],[1,1,0,1,1],[0,1,1,1,0]],4:[[0,0,1,1,1],[0,1,0,1,1],[1,1,0,1,1],[1,1,1,1,1],[0,0,0,1,1],[0,0,0,1,1],[0,0,0,1,1]],5:[[1,1,1,1,1],[1,1,0,0,0],[1,1,0,0,0],[1,1,1,1,0],[0,0,0,1,1],[1,1,0,1,1],[0,1,1,1,0]],6:[[0,1,1,1,0],[1,1,0,0,0],[1,1,1,1,0],[1,1,0,1,1],[1,1,0,1,1],[1,1,0,1,1],[0,1,1,1,0]],7:[[1,1,1,1,1],[0,0,0,1,1],[0,0,0,1,1],[0,0,1,1,0],[0,1,1,0,0],[1,1,0,0,0],[1,1,0,0,0]],8:[[0,1,1,1,0],[1,1,0,1,1],[1,1,0,1,1],[0,1,1,1,0],[1,1,0,1,1],[1,1,0,1,1],[0,1,1,1,0]],9:[[0,1,1,1,0],[1,1,0,1,1],[1,1,0,1,1],[1,1,0,1,1],[0,1,1,1,1],[0,0,0,1,1],[0,1,1,1,0]]}},b=function(){var b,c,d,e,f,g,h=[];for(d in a)if(a.hasOwnProperty(d)){for(b=a[d][0].length,c=a[d][0][0].length,g=\"\",e=0;b>e;e++){for(g+='<span class=\"soon-matrix-row\">',f=0;c>f;f++)g+='<span class=\"soon-matrix-dot\"></span>';g+=\"</span>\"}h[d]=g}return h}(),c=function(a){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-matrix \"+(a.className||\"\"),this._inner=document.createElement(\"span\"),this._inner.className=\"soon-matrix-inner\",this._wrapper.appendChild(this._inner),this._transform=a.transform||function(a){return a},this._value=[],this._type=-1!==a.modifiers.indexOf(\"3x5\")?\"3x5\":\"5x7\"};return c.prototype={redraw:function(){},destroy:function(){return this._wrapper},getElement:function(){return this._wrapper},_addChar:function(){var a=document.createElement(\"span\");return a.className=\"soon-matrix-char\",a.innerHTML=b[this._type],{node:a,ref:[]}},_updateChar:function(b,c){var d,e=a[this._type][c],f=e.length,g=e[0].length,h=0,i=b.ref;if(!i.length)for(var j=b.node.getElementsByClassName(\"soon-matrix-dot\");f>h;h++)for(i[h]=[],d=0;g>d;d++)i[h][d]=j[h*g+d];for(;f>h;h++)for(d=0;g>d;d++)i[h][d].setAttribute(\"data-state\",1===e[h][d]?\"1\":\"0\")},setValue:function(a){a=this._transform(a),a+=\"\",a=a.split(\"\");for(var b=0,c=a.length;c>b;b++){var d=this._value[b];d||(d=this._addChar(),this._inner.appendChild(d.node),this._value[b]=d),this._updateChar(d,a[b])}}},c}(),C.Repeater=function(a){var b=function(b){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-repeater \"+(b.className||\"\"),this._delay=b.delay||0,this._transform=b.transform||function(a){return a},this._destroyed=!1,this._presenter=b.presenter,this._Presenter=a(this._presenter.type),this._prepend=\"undefined\"==typeof b.prepend?!0:b.prepend,this._presenterStorage=[]};return b.prototype={redraw:function(){for(var a=this._presenterStorage.length-1;a>=0;a--)this._presenterStorage[a].redraw()},destroy:function(){this._destroyed=!0;for(var a=this._presenterStorage.length-1;a>=0;a--)this._presenterStorage[a].destroy();return this._wrapper},getElement:function(){return this._wrapper},setValue:function(a){a=this._transform(a),a=a instanceof Array?a:[a],this._prepend&&a.reverse();for(var b,c,d,e=0,f=a.length,g=0,h=a.length!==this._wrapper.children.length;f>e;e++)b=this._presenterStorage[e],b||(b=new this._Presenter(this._presenter.options||{}),0!==this._wrapper.children.length&&this._prepend?this._wrapper.insertBefore(b.getElement(),this._wrapper.firstChild):this._wrapper.appendChild(b.getElement()),this._presenterStorage[e]=b,this._delay&&(g-=this._delay)),this._delay&&!h?(this._setValueDelayed(b,a[e],g),g+=this._delay):this._setValue(b,a[e],h);for(f=this._wrapper.children.length,d=e;f>e;e++)b=this._presenterStorage[e],c=b.destroy(),c.parentNode.removeChild(c),this._presenterStorage[e]=null;this._presenterStorage.length=d},_setValueDelayed:function(a,b,c,d){var e=this;setTimeout(function(){e._setValue(a,b,d)},c)},_setValue:function(a,b,c){c&&a.setValue(\" \"),a.setValue(b)}},b}(t),C.Ring=function(a,b){var c=function(b){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-ring \"+(b.className||\"\"),this._transform=b.transform||function(a){return a},this._modifiers=b.modifiers,this._animate=b.animate,this._drawn=!1,this._canvas=document.createElement(\"canvas\"),this._wrapper.appendChild(this._canvas),this._style=document.createElement(\"span\"),this._style.className=\"soon-ring-progress\",this._style.style.visibility=\"hidden\",this._style.style.position=\"absolute\",this._wrapper.appendChild(this._style),this._current=0,this._target=null,this._destroyed=!1,this._lastTick=0,this._styles=null;var c=this;a.supportsAnimation()?window.requestAnimationFrame(function(a){c._tick(a)}):this._animate=!1};return c.prototype={destroy:function(){return this._destroyed=!0,b.deregister(this._resizeBind),this._wrapper},getElement:function(){return this._wrapper},_getModifier:function(a){for(var b=0,c=this._modifiers.length,d=null;c>b;b++)if(-1!==this._modifiers[b].indexOf(a)){d=this._modifiers[b];break}if(!d)return null;if(-1===d.indexOf(\"-\"))return!0;var e=d.split(\"-\");if(-1!==e[1].indexOf(\"_\")){var f=e[1].split(\"_\");return f[0]=\"#\"+f[0],f[1]=\"#\"+f[1],f}var g=parseFloat(e[1]);return isNaN(g)?e[1]:g/100},redraw:function(){var b=window.getComputedStyle(this._style);this._styles={offset:this._getModifier(\"offset\")||0,gap:this._getModifier(\"gap\")||0,length:this._getModifier(\"length\")||1,flip:this._getModifier(\"flip\")||!1,invert:this._getModifier(\"invert\")||null,align:\"center\",size:0,radius:0,padding:parseInt(b.getPropertyValue(\"padding-bottom\"),10)||0,cap:0===parseInt(b.getPropertyValue(\"border-top-right-radius\"),10)?\"butt\":\"round\",progressColor:{fill:b.getPropertyValue(\"color\")||\"#000\",gradient:{colors:this._getModifier(\"progressgradient\")||null,type:this._getModifier(\"progressgradienttype\")||\"follow\"}},progressWidth:parseInt(b.getPropertyValue(\"border-top-width\"),10)||2,progressShadow:a.getShadowProperties(b.getPropertyValue(\"text-shadow\")),ringColor:{fill:b.getPropertyValue(\"background-color\")||\"#fff\",gradient:{colors:this._getModifier(\"ringgradient\")||null,type:this._getModifier(\"ringgradienttype\")||\"follow\"}},ringWidth:parseInt(b.getPropertyValue(\"border-bottom-width\"),10)||2,ringShadow:a.getShadowProperties(b.getPropertyValue(\"box-shadow\"))};var c=this._canvas.getContext(\"2d\"),d=this._canvas.parentNode.clientWidth,e=a.getDevicePixelRatio(),f=a.getBackingStoreRatio(c),g=e/f,h=125>d?Math.min(1,.005*d):1;if(this._styles.ringWidth=Math.ceil(this._styles.ringWidth*h),this._styles.progressWidth=Math.ceil(this._styles.progressWidth*h),\"transparent\"===this._styles.ringColor.fill&&(this._styles.ringColor.fill=\"rgba(0,0,0,0)\"),\"transparent\"===this._styles.progressColor.fill&&(this._styles.progressColor.fill=\"rgba(0,0,0,0)\"),\"round\"===this._styles.cap&&-1===this._modifiers.join(\"\").indexOf(\"gap-\")&&(this._styles.gap=.5*(this._styles.ringWidth+this._styles.progressWidth)*.005),d){e!==f?(this._canvas.width=d*g,this._canvas.height=d*g,this._canvas.style.width=d+\"px\",this._canvas.style.height=d+\"px\",c.scale(g,g)):(this._canvas.width=d,this._canvas.height=d),this._styles.size=.5*d;var i=this._styles.size-this._styles.padding;this._styles.ringRadius=i-.5*this._styles.ringWidth,this._styles.progressRadius=i-.5*this._styles.progressWidth,this._styles.progressWidth===this._styles.ringWidth?this._styles.progressRadius=this._styles.ringRadius:this._styles.progressWidth<this._styles.ringWidth?-1!==this._modifiers.indexOf(\"align-center\")?this._styles.progressRadius=this._styles.ringRadius:-1!==this._modifiers.indexOf(\"align-bottom\")?this._styles.progressRadius=i-(this._styles.ringWidth-.5*this._styles.progressWidth):-1!==this._modifiers.indexOf(\"align-inside\")&&(this._styles.progressRadius=i-(this._styles.ringWidth+.5*this._styles.progressWidth)):-1!==this._modifiers.indexOf(\"align-center\")?this._styles.ringRadius=this._styles.progressRadius:-1!==this._modifiers.indexOf(\"align-bottom\")?this._styles.ringRadius=i-(this._styles.progressWidth-.5*this._styles.ringWidth):-1!==this._modifiers.indexOf(\"align-inside\")&&(this._styles.ringRadius=i-(this._styles.progressWidth+.5*this._styles.ringWidth)),-1!==this._modifiers.indexOf(\"glow-progress\")&&this._styles.progressShadow&&(this._styles.progressShadow[this._styles.progressShadow.length-1]=null!==this._styles.progressColor.gradient.colors?this._styles.progressColor.gradient.colors[0]:this._styles.progressColor.fill),-1!==this._modifiers.indexOf(\"glow-background\")&&this._styles.ringShadow&&(this._styles.ringShadow[this._styles.ringShadow.length-1]=null!==this._styles.ringColor.gradient.colors?this._styles.ringColor.gradient.colors[0]:this._styles.ringColor.fill),this._drawn=!1}},_tick:function(a){if(!this._destroyed){null!==this._target&&this._draw(a);var b=this;window.requestAnimationFrame(function(a){b._tick(a)})}},_draw:function(b){if(this._animate){var c=b-this._lastTick,d=250>c?1e3/c:30;if(this._lastTick=b,this._current===this._target&&this._drawn)return;this._current+=(this._target-this._current)/(d/3),Math.abs(this._current-this._target)<=.001&&(this._current=this._target)}else this._current=this._target;\n    var e=this._canvas.getContext(\"2d\");e.clearRect(0,0,this._canvas.width,this._canvas.height);var f=this._styles.flip?1-this._current:this._current;a.drawRing(e,f,this._styles.offset,this._styles.length,this._styles.gap,this._styles.size,this._styles.ringRadius,this._styles.ringWidth,this._styles.ringColor,this._styles.ringShadow,this._styles.progressRadius,this._styles.progressWidth,this._styles.progressColor,this._styles.progressShadow,this._styles.cap,this._styles.invert),this._drawn=!0},setValue:function(b){this._styles||this.redraw(),b=this._transform(b),this._target!==b&&(null==this._target&&(this._current=b),this._target=b),a.supportsAnimation()||(this._current=this._target,this._draw())}},c}(B,E),C.Slot=function(a){var b=function(a){this._forceReplace=\"undefined\"==typeof a.forceReplace?!1:a.forceReplace,this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-slot \"+(a.className||\"\"),this._transform=a.transform||function(a){return a},this._new=document.createElement(\"span\"),this._new.className=\"soon-slot-new\",this._old=document.createElement(\"span\"),this._old.className=\"soon-slot-old\",this._bounding=document.createElement(\"span\"),this._bounding.className=\"soon-slot-bounding\",this._inner=document.createElement(\"span\"),this._inner.className=\"soon-slot-inner soon-slot-animate\",this._inner.appendChild(this._old),this._inner.appendChild(this._new),this._inner.appendChild(this._bounding),this._wrapper.appendChild(this._inner),this._newValue=\"\",this._oldValue=\"\",this._boundingLength=0};return b.prototype={redraw:function(){},destroy:function(){return this._wrapper},getElement:function(){return this._wrapper},_isEmpty:function(){return!this._newValue},_isSame:function(a){return this._newValue===a},_setBoundingForValue:function(a){var b=(a+\"\").length;if(b!==this._boundingLength){this._boundingLength=b;for(var c=\"\",d=0;b>d;d++)c+=\"8\";this._bounding.textContent=c;var e=parseInt(getComputedStyle(this._wrapper).fontSize,10),f=this._bounding.offsetWidth/e;this._inner.style.width=f+.1*(b-1)+\"em\"}},_setNewValue:function(a){this._newValue=a,\" \"!==a&&(this._new.textContent=a)},_setOldValue:function(a){this._oldValue=a,this._old.textContent=a},setValue:function(b){b=this._transform(b),this._isEmpty()?(this._setNewValue(b),this._setBoundingForValue(b),a.triggerAnimation(this._inner,\"soon-slot-animate\")):this._isSame(b)&&!this._forceReplace||(this._newValue.length&&this._setOldValue(this._newValue),this._setNewValue(b),this._setBoundingForValue(b),a.triggerAnimation(this._inner,\"soon-slot-animate\"))}},b}(B),C.Text=function(a){var b=function(a){this._wrapper=document.createElement(\"span\"),this._wrapper.className=\"soon-text \"+(a.className||\"\"),this._transform=a.transform||function(a){return a}};return b.prototype={redraw:function(){},destroy:function(){return this._wrapper},getElement:function(){return this._wrapper},setValue:function(b){a.setTextContent(this._wrapper,this._transform(b))}},b}(B);var F=function(a,b){var c=function(a,c){c=c||{},this._rate=c.rate||1e3,this._offset=null,this._time=0,this._paused=!1,this._nextTickReference=null,this._tickBind=this._tick.bind(this),this._onTick=a||function(){},\"addEventListener\"in document&&document.addEventListener(b.documentVisibilityEvent,this)};return c.prototype={handleEvent:function(){b.isDocumentHidden()?this._lock():this._unlock()},isRunning:function(){return null!==this._offset},isPaused:function(){return this.isRunning()&&this._paused},start:function(){this.isRunning()||this.reset()},getTime:function(){return this._time},reset:function(){this.pause(),this._offset=(new Date).getTime(),this._time=0,this.resume()},stop:function(){var a=this;setTimeout(function(){a._clearTimer(),a._offset=null},0)},pause:function(){this._paused=!0,this._clearTimer()},resume:function(){if(this.isPaused()){this._paused=!1;var a=(new Date).getTime();this._time+=a-this._offset,this._offset=a,this._tick()}},_clearTimer:function(){clearTimeout(this._nextTickReference),this._nextTickReference=null},_lock:function(){this._clearTimer()},_unlock:function(){this.isPaused()||(this.pause(),this.resume())},_tick:function(){this._onTick(this._time),this._offset+=this._rate,this._time+=this._rate,this._nextTickReference=setTimeout(this._tickBind,this._offset-(new Date).getTime())}},c}(this,B),G=[],H=0,I=[\"xxl\",\"xl\",\"l\",\"m\",\"s\",\"xs\",\"xxs\"],J=3,K=(I.length,[]),L=[],M={y:{labels:\"Year,Years\",option:\"Years\",padding:\"\"},M:{labels:\"Month,Months\",option:\"Months\",padding:\"00\"},w:{labels:\"Week,Weeks\",option:\"Weeks\",padding:\"00\"},d:{labels:\"Day,Days\",option:\"Days\",padding:\"000\"},h:{labels:\"Hour,Hours\",option:\"Hours\",padding:\"00\"},m:{labels:\"Minute,Minutes\",option:\"Minutes\",padding:\"00\"},s:{labels:\"Second,Seconds\",option:\"Seconds\",padding:\"00\"},ms:{labels:\"Millisecond,Milliseconds\",option:\"Milliseconds\",padding:\"000\"}};E.register(d);var N=/([\\d]+)[\\s]+([a-z]+)/i,O=/([\\d]+)[:]*([\\d]{2})*[:]*([\\d]{2})*/;A.parse=function(a){w(a)},A.redraw=function(a){if(a){var b=j(a);f(b.node,b.presenter)}else g()},A.reset=function(a){var b=j(a);b&&b.ticker.reset()},A.freeze=function(a){var b=j(a);b&&b.ticker.pause()},A.unfreeze=function(a){var b=j(a);b&&b.ticker.resume()},A.setOption=function(a,b,c){var d=j(a);if(d){var e=d.options;e[b]=c,this.destroy(a),this.create(a,e)}},A.setOptions=function(a,b){var c=j(a);if(c){var d,e=c.options;for(d in b)b.hasOwnProperty(d)&&(e[d]=b[d]);this.destroy(a),this.create(a,b)}},A.destroy=function(a){var b=h(a);if(null!==b){var c=i(a);null!==c&&L.splice(c,1);var d=K[b];d.ticker&&d.ticker.stop(),d.presenter.destroy();var e=d.node.querySelector(\".soon-placeholder\");d.node.removeChild(e?e:d.node.querySelector(\".soon-group\")),a.removeAttribute(\"data-initialized\"),K.splice(b,1)}},A.create=function(a,b){if(!b)return w(a);if(\"true\"===a.getAttribute(\"data-initialized\"))return null;a.setAttribute(\"data-initialized\",\"true\");var c=null,d=null;b.eventComplete&&(c=\"string\"==typeof b.eventComplete?window[b.eventComplete]:b.eventComplete),b.eventTick&&(d=\"string\"==typeof b.eventTick?window[b.eventTick]:b.eventTick),b.due&&-1!==b.due.indexOf(\"reset\")&&(c=z(a,b,c),b.eventComplete=c),l(a,b,\"layout\"),l(a,b,\"face\"),l(a,b,\"visual\"),l(a,b,\"format\"),b.scaleMax&&a.setAttribute(\"data-scale-max\",b.scaleMax),b.scaleHide&&a.setAttribute(\"data-scale-hide\",b.scaleHide);var e,f,g,h=(b.format||\"d,h,m,s\").split(\",\"),i=-1===h.indexOf(\"ms\")?1e3:24,j={};for(e in M)M.hasOwnProperty(e)&&(f=M[e],g=(b[\"labels\"+f.option]||f.labels).split(\",\"),j[e]=g[0],j[e+\"_s\"]=g[1]||g[0]);var m=\"undefined\"==typeof b.padding?!0:b.padding,n={};for(e in M)M.hasOwnProperty(e)&&(f=M[e],m?(n[e]=y(e,h),null===n[e]&&(n[e]=f.padding),b[\"padding\"+f.option]&&(n[e]=b[\"padding\"+f.option])):n[e]=\"\");var p=(b.face||\"text \").split(\" \")[0],q=b.due?x(b.due):null,r=b.since?B.isoToDate(b.since):null,s=b.now?B.isoToDate(b.now):r?null:new Date,t={due:q,since:r,now:s,view:p,face:b.face,visual:b.visual||null,format:h,separator:b.separator||null,cascade:\"undefined\"==typeof b.cascade?!0:B.toBoolean(b.cascade),singular:b.singular,reflect:b.reflect||!1,chars:\"undefined\"==typeof b.separateChars?!0:B.toBoolean(b.separateChars),label:j,padding:n,callback:{onComplete:c||function(){},onTick:d||function(){}}};B.isSlow()&&(t.view=\"text\",t.reflect=!1,t.visual=null);var A=null,C=o(t,function(){A&&A.stop(),t.callback.onComplete()});k(a);var D=u(a,C);return A=v(a,D,i,b)};var P;!function(a){P=a()}(function(a){function b(a){for(n=1;a=d.shift();)a()}var c,d=[],e=!1,f=document,g=f.documentElement,h=g.doScroll,i=\"DOMContentLoaded\",j=\"addEventListener\",k=\"onreadystatechange\",l=\"readyState\",m=h?/^loaded|^c/:/^loaded|c/,n=m.test(f[l]);return f[j]&&f[j](i,c=function(){f.removeEventListener(i,c,e),b()},e),h&&f.attachEvent(k,c=function(){/^c/.test(f[l])&&(f.detachEvent(k,c),b())}),a=h?function(b){self!=top?n?b():d.push(b):function(){try{g.doScroll(\"left\")}catch(c){return setTimeout(function(){a(b)},50)}b()}()}:function(a){n?a():d.push(a)}}),P(function(){var a=document.querySelector(\"script[src*=soon]\");if(!a||\"false\"!==a.getAttribute(\"data-auto\"))for(var b=document.getElementsByClassName?document.getElementsByClassName(\"soon\"):document.querySelectorAll(\".soon\"),c=0,d=b.length;d>c;c++)w(b[c])}),function(a,b){\"use strict\";if(b){var c=[\"destroy\",\"reset\",\"resize\",\"freeze\",\"unfreeze\",\"redraw\"],d=c.length;b.fn.soon=function(){var b=this;b.create=function(b){return this.each(function(){a.create(this,b)})},b.setOption=function(b,c){return this.each(function(){a.setOption(this,b,c)})},b.setOptions=function(b){return this.each(function(){a.setOptions(this,b)})};for(var e=0;d>e;e++)!function(c){b[c]=function(){return this.each(function(){a[c](this)})}}(c[e]);return this}}}(A,b),\"undefined\"!=typeof module&&module.exports?module.exports=A:\"function\"==typeof define&&define.amd?define(function(){return A}):a.Soon=A}}(window,window.jQuery);"

/***/ }),

/***/ "qqFi":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__("NKwv")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),

/***/ "r1M9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tM7p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_cookie__ = __webpack_require__("TQCA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_urlconverter__ = __webpack_require__("ejlv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_zinfinitescroll__ = __webpack_require__("wC9f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list__ = __webpack_require__("F0bM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page__ = __webpack_require__("kvOq");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "list", function() { return __WEBPACK_IMPORTED_MODULE_3__list__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "page", function() { return __WEBPACK_IMPORTED_MODULE_4__page__; });








/***/ }),

/***/ "vBks":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w2CW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fancyapps_fancybox__ = __webpack_require__("GfF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fancyapps_fancybox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fancyapps_fancybox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fancyapps_fancybox_dist_jquery_fancybox_css__ = __webpack_require__("XXni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fancyapps_fancybox_dist_jquery_fancybox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fancyapps_fancybox_dist_jquery_fancybox_css__);



$.fancybox.defaults.i18n.ru = {
	CLOSE: 'Закрыть',
	NEXT: 'Следующий',
	PREV: 'Предыдущий',
	ERROR: 'Не удалось загрузить содержимое <br/> Пожалуйста, попробуйте позже.',
	PLAY_START: 'Начать слайдшоу',
	PLAY_STOP: 'Остановить слайдшоу',
	FULL_SCREEN: 'На весь экран',
	THUMBS: 'Предпросмотр'
};

$.fancybox.defaults.lang = LANG;

/***/ }),

/***/ "wC9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfiniteScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* Copy-paste of Vadim's extension*/



/**
 * This is simple plugin that checks when window is scrolled
 * to the bottom of the element and fires event in this case
 */
var InfiniteScroll = function () {
	function InfiniteScroll(element, options) {
		_classCallCheck(this, InfiniteScroll);

		this._clNeedMore = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();

		this._$el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
		this._$window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
		this._o = _extends({
			/**
    * If distance in pixels between bottom of the window and bottom of the element
    * becomes less than this value - event is fired
    */
			distance: 500,
			/**
    * Event handler
    */
			onNeedMore: null

		}, options);
		if (this._o.onNeedMore) {
			this._clNeedMore.add(this._o.onNeedMore);
		}
	}

	/**
  * Subscribe to needed events and start monitoring
  */


	_createClass(InfiniteScroll, [{
		key: 'on',
		value: function on() {
			if (this._eventHandler) {
				return;
			}
			this._eventHandler = this.update.bind(this);
			this._$window.on('scroll resize', this._eventHandler);
			this.update();
		}

		/**
   * Unsubscribe from all events and stop monitoring
   */

	}, {
		key: 'off',
		value: function off() {
			if (!this._eventHandler) {
				return;
			}
			this._$window.off('scroll resize', this._eventHandler);
			this._eventHandler = null;
		}

		/**
   * Manual update. Event will be fired immediately if needed.
   */

	}, {
		key: 'update',
		value: function update() {
			var checkVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (checkVisible && !this._$el.is(':visible')) {
				return;
			}
			var blockEnd = this._$el.offset().top + this._$el.outerHeight();
			var windowHeight = this._$window.height();
			var windowScrollTop = this._$window.scrollTop();
			var isNearBottom = blockEnd < windowScrollTop + windowHeight + this._o.distance;

			if (isNearBottom != this._needMore) {
				this._needMore = isNearBottom;

				if (isNearBottom) {
					this._clNeedMore.fireWith(this._$el[0], [this._loadedMoreCallback.bind(this)]);
				}
			}
		}

		/**
  * Change internal state in response to loaded more event
   */

	}, {
		key: '_loadedMoreCallback',
		value: function _loadedMoreCallback() {
			this._needMore = false;
		}

		/**
   * Add event handler
   * @param callback
   */

	}, {
		key: 'onNeedMore',
		value: function onNeedMore(callback) {
			this._clNeedMore.add(callback);
		}

		/**
   * Remove event handler
   * @param callback
   */

	}, {
		key: 'offNeedMore',
		value: function offNeedMore(callback) {
			this._clNeedMore.remove(callback);
		}
	}]);

	return InfiniteScroll;
}();

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.zInfiniteScroll = function (options) {
	var o = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
		fetch: null,
		clear: null,
		show: null,
		enabled: null,
		finished: null,
		getCurrentCount: null,
		countPerPage: null,
		totalCount: Number.MAX_VALUE,
		selector: '*',
		btnShowMore: null,
		loading: null,
		maxAutoloadPages: null,
		checkViewport: true,
		autoStart: true
	}, options);

	var $wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
	var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
	var $btnShowMore = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(o.btnShowMore);
	var $loading = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(o.loading);
	var getCurrentCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.getCurrentCount) ? o.getCurrentCount : function () {
		return $wrapper.children(o.selector).length;
	};
	var currentPage = o.countPerPage === null ? 1 : function () {
		return getCurrentCount() / o.countPerPage;
	};
	var inProgress = false;
	var isReloading = false;
	var finished = false;
	var t = new Throttler(50);

	$btnShowMore.click(function () {
		$btnShowMore.hide();
		loadMore(function (hasMore) {
			if (hasMore) {
				$btnShowMore.show();
			}
		});
	});

	o.totalCount = +o.totalCount;
	o.maxAutoloadPages = +o.maxAutoloadPages;

	if (o.autoStart) {
		if (getCurrentCount() < o.totalCount) {
			start();
		} else {
			finished = true;
			if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.finished)) {
				o.finished();
			}
		}
	}

	return {
		on: function on() {
			finished = false;
			if (getCurrentCount() < o.totalCount) {
				start();
			} else {
				finished = true;
				if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.finished)) {
					o.finished();
				}
			}
		},
		off: function off() {
			stop();
			finished = true;
		},
		reload: function reload() {
			finished = false;
			if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(currentPage)) {
				currentPage = 0;
			}
			o.totalCount = Number.MAX_VALUE;

			if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.clear)) {
				o.clear();
			} else {
				$wrapper.children(o.selector).remove();
			}

			if (inProgress) {
				isReloading = true;
			} else {
				loadRoutine();
			}
		}
	};

	function start() {
		if (!finished) {
			$window.on('scroll', onScroll);
		}
	}

	function stop() {
		$window.off('scroll', onScroll);
	}

	function onScroll() {
		if (unwrap(o.enabled) === false || inProgress || !t.ready() || !$wrapper.is(':visible')) {
			return;
		}

		var blockEnd = $wrapper.offset().top + $wrapper.height();
		var windowHeight = $window.height();
		var windowScrollTop = $window.scrollTop();
		var isNearBottom = blockEnd < windowScrollTop + windowHeight + 500;
		var isInViewport = !o.checkViewport || blockEnd > windowScrollTop + 50;
		var ready = isNearBottom && isInViewport;

		if (ready) {
			loadRoutine();
		}
	}

	function loadRoutine() {
		stop();
		loadMore(function () {
			var needMore = getCurrentCount() < o.totalCount;
			if (needMore) {
				if (!o.maxAutoloadPages || unwrap(currentPage) < o.maxAutoloadPages) {
					t.reset();
					start();
				} else {
					$btnShowMore.show();
				}
			} else {
				finished = true;
				if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.finished)) {
					o.finished();
				}
			}
		});
	}

	function loadMore(callback) {
		if (inProgress) {
			return;
		}
		inProgress = true;
		$loading.show();

		o.fetch(unwrap(currentPage) + 1, function ($blocks) {
			if (isReloading) {
				isReloading = false;
				inProgress = false;

				loadRoutine();
				return;
			}
			var count = 0;
			if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.show)) {
				count = o.show($blocks);
			} else {
				$blocks.addClass('fadein');
				$wrapper.append($blocks);
				count = $blocks.length;
			}

			if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(currentPage)) {
				currentPage++;
			}
			inProgress = false;
			$loading.hide();

			if (count === 0 || o.countPerPage !== null && count < o.countPerPage) {
				// force stop because no more data on server
				o.totalCount = getCurrentCount();
			}

			callback();
		});
	}
};

function unwrap(value) {
	return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(value) ? value() : value;
}

var Throttler = function () {
	function Throttler(period) {
		_classCallCheck(this, Throttler);

		this.period = +period;
		this.start = +new Date();
	}

	_createClass(Throttler, [{
		key: 'ready',
		value: function ready() {
			var ready = +new Date() - this.start >= this.period;
			if (ready) {
				this.reset();
			}
			return ready;
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.start = +new Date();
		}
	}]);

	return Throttler;
}();

/***/ }),

/***/ "wYtf":
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__("8ZSj");

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ "webD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_soon_countdown_soon_1_9_0_min_js__ = __webpack_require__("HH+/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_soon_countdown_soon_1_9_0_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vendor_soon_countdown_soon_1_9_0_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendor_soon_countdown_soon_1_9_0_min_css__ = __webpack_require__("6mWo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendor_soon_countdown_soon_1_9_0_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vendor_soon_countdown_soon_1_9_0_min_css__);



/***/ })

},[16]);


// WEBPACK FOOTER //
// blog.min.js